
// import React, { useEffect, useRef, useState } from "react";
// import {
//   Container,
//   UncontrolledDropdown,
//   DropdownToggle,
//   DropdownMenu,
//   Form,
//   Input,
//   Label,
// } from "reactstrap";
// import Breadcrumbs from "../../../components/Common/Breadcrumb";
// import { Link, useNavigate } from "react-router-dom";
// import { useMemo } from "react";
// import {
//   useTable,
//   useSortBy,
//   usePagination,
//   useGlobalFilter,
// } from "react-table";
// import India from "../../../assets/images/flags/india.png";
// import Uk from "../../../assets/images/flags/uk.png";
// import Select from "react-select";
// import "../../../assets/css/Finance/Style/ExpenseSection/expense.css";
// import addexpense from "../../../assets/images/Expenses/addExpense.jpg";
// import editexpense from "../../../assets/images/Expenses/editExpense.jpg";
// import viewexpense from "../../../assets/images/Expenses/viewExpense.jpg";
// import viewbill from "../../../assets/images/Expenses/View_Bill.jpg";
// import { Table, Row, Col, Card, CardBody, Modal } from "reactstrap";
// import axios from "axios";
// import Loader from "pages/Separate/Loader";
// import swal from "sweetalert";
// import configure from "configure";
// import Swal from "sweetalert2";
// import AccessDeniedPopup from "routes/AccessDeniedPopup";
// import moment from "moment";
// import NewPagination from "components/Common/Newpagination";
// import Draggable, { DraggableCore } from "react-draggable";
// import { Resizable, ResizableBox } from "react-resizable";
// import { sum } from "lodash";
// import { formatDate } from "devextreme/localization";
// import { fetchNodeData } from "utils/common-fetchData";
// import secureLocalStorage from "react-secure-storage";
// import { colourStyles } from "utils/common-options";

// function TableContainer({
//   columns,
//   data,
//   setAccessDenied,
//   setLoading,
//   location,
//   Categories,
//   payments,
//   Currency,
//   setDatas,
//   allData,
//   fetchData,
//   setAllData,
//   paymentsOption,
//   setIsfilter,
//   introducerOptions,
//   onReloadApi,
// }) {
//   const [fixedContent, setFixedContent] = useState(false);
//   const [status, setStatus] = useState(false);
//   const [formPopup, setFormPopup] = useState(false);
//   const [addExpense, setAddExpense] = useState(false);
//   const [isConvertedAmount, setIsConvertedAmount] = useState(false);
//   const [convertInrAmount, setConvertInrAmount] = useState("");
//   const [recurring, setRecurring] = useState(0);
//   const [introducer, setIntroducer] = useState(0);
//   const [recordPayment, setRecordPayment] = useState(0);
//   const [recurringPeriod, setRecurringPeriod] = useState(null);
//   const [recurringEndDate, setRecurringEndDate] = useState("");
//   const [recurringOptions, setRecurringOptions] = useState([
//     { value: 1, label: "1 Month" },
//     { value: 2, label: "2 Month" },
//     { value: 12, label: "1 Year" },
//   ]);
//   const [boxWidth, setBoxWidth] = useState(0);
//   const [fStartDate, setFStartDate] = useState("");
//   const [fendDate, setFendDate] = useState("");

//   document.addEventListener("keydown", (e) => {
//     if (e.key === "Escape") setAddExpense(false), setFormPopup(false);
//   });

//   const expenseFileUpload = useRef(null)

//   const navigate = useNavigate();

//   document.addEventListener("scroll", () => {
//     if (window.scrollY > 300) {
//       setFixedContent(true);
//     } else {
//       setFixedContent(false);
//     }
//   });
//   // Use the state and functions returned from useTable to build your UI
//   const {
//     getTableProps,
//     getTableBodyProps,
//     headerGroups,
//     page,
//     state,
//     previousPage,
//     nextPage,
//     canPreviousPage,
//     canNextPage,
//     gotoPage,
//     setPageSize,
//     pageOptions,
//     setGlobalFilter,
//     pageCount,
//     prepareRow,
//   } = useTable(
//     {
//       columns,
//       data,
//       initialState: {
//         sortBy: [
//           {
//             id: "id",
//             desc: true,
//           },
//         ],
//       },
//     },

//     useGlobalFilter,
//     useSortBy,
//     usePagination
//   );

//   const { pageIndex, pageSize, globalFilter } = state;
//   useEffect(() => setPageSize(50), []);

//   useEffect(() => {
//     if (!data || data.length === 0) return; // Handle empty data case

//     // const totalExpense = data.reduce((acc, item) => acc + (item.amount || 0), 0);
//     const totalExpense = data.reduce(
//       (acc, item) => acc + (parseFloat(item.amount) || 0),
//       0
//     );

//     const bankTotal = data
//       .filter((list) => list.payment_method === "1")
//       .reduce((acc, item) => acc + (item.amount - item.tbal || 0), 0);

//     const creditTotal = data
//       .filter((list) => list.payment_method === "2")
//       .reduce((acc, item) => acc + (item.amount - item.tbal || 0), 0);

//     const otherTotal = data
//       .filter((list) => list.payment_method === "3")
//       .reduce((acc, item) => acc + (item.amount - item.tbal || 0), 0);

//     const modifyArray = {
//       ...allData,
//       budgetExpense: totalExpense,
//       bank: bankTotal,
//       credit_card: creditTotal,
//       others: otherTotal,
//     };
//     setAllData(modifyArray);
//   }, [data]);

//   const [title, setTitle] = useState("");
//   const [name_modal, setNameModal] = useState(false);
//   const [addDate, setAddDate] = useState("");
//   const [locationValue, setLocationValue] = useState(null);
//   const [paymentViaValue, setPaymentViaValue] = useState(null);
//   const [categoryValue, setCategoryValue] = useState(null);
//   const [currencyValue, setCurrencyValue] = useState(null);
//   const [titleValue, setTitleValue] = useState("");
//   const [amountValue, setAmountValue] = useState("");
//   const [gstValue, setGstValue] = useState("");
//   const [fromDate, setFromDate] = useState(new Date());
//   const [toDate, setToDate] = useState(new Date());

//   const [fromDateFilter, setFromDateFilter] = useState("");
//   const [toDateFilter, setToDateFilter] = useState("");
//   const [filterPayment, setFilterPayment] = useState(null);
//   const [filterCategory, setFilterCategory] = useState(null);
//   const [filterCurrency, setFilterCurrency] = useState(null);
//   const [introducerValue, setIntroducerValue] = useState(null);

//   useEffect(() => {
//     const newDate = new Date(fromDate);
//     newDate.setMonth(newDate.getMonth() + 1);
//     setToDate(newDate);
//   }, []);

//   const handleSubmit = async e => {
//     e.preventDefault()
//     const isRecurring = recurring == 1 ? recurringPeriod !== null : true
//     if (
//       locationValue !== null &&
//       paymentViaValue !== null &&
//       categoryValue !== null &&
//       currencyValue !== null &&
//       isRecurring
//     ) {
//       setLoading(true)
//       const formData = new FormData()
//       formData.append("type", 2)
//       formData.append("date", addDate)
//       formData.append("location", locationValue?.value)
//       formData.append("payment_via", paymentViaValue?.value)
//       formData.append("category", categoryValue?.value)
//       formData.append("title", titleValue)
//       formData.append("amount", amountValue)
//       formData.append("currency", currencyValue?.value)
//       formData.append("gst", gstValue)

//       if (expenseFileUpload.current.files[0]) {
//         formData.append("file", expenseFileUpload.current.files[0])
//       }

//       if (isConvertedAmount) {
//         formData.append(
//           "currency_rate",
//           convertInrAmount ? convertInrAmount : 1
//         )
//       } else {
//         formData.append("currency_rate", 1)
//       }
//       if (recurring == 1) {
//         formData.append("recurrence", recurring)
//         formData.append("recurrence_period", recurringPeriod?.value)
//         formData.append("recurrence_date", recurringEndDate)
//       }
//       formData.append("introducer_id", introducerValue)
//       formData.append("recordPayment", recordPayment)
//       try {
//         const response = await axios.post(
//           `${configure.nodeApi}/addBudgetExpense`,
//           formData,
//           {
//             headers: {
//               Accept: "application/json",
//               "Content-Type": "multipart/form-data",
//             },
//           }
//         )
//         if (response.data.success) {
//           setLoading(false)
//           Swal.fire({
//             icon: "success",
//             text: "Expense added",
//           }).then(() => {
//             setIsConvertedAmount(false)
//             setConvertInrAmount("")
//             setAddDate("")
//             setLocationValue(null)
//             setPaymentViaValue(null)
//             setCategoryValue(null)
//             setTitleValue("")
//             setAmountValue("")
//             setCurrencyValue(null)
//             setGstValue("")
//             expenseFileUpload.current = null
//             setAddExpense(false)
//             setIntroducerValue(null) // Reset introducer
//             // // const expense = response.data.data?.expense?.filter((list) => {
//             // //   const modifyAmount =
//             // //     Number(list.amount)?.toFixed(1) - Number(list.tbal)?.toFixed(1);
//             // //   return modifyAmount >= 1;
//             // // });
//             // // setDatas(expense);
//             // // setAllData(response?.data?.data);
//             setRecurring(0)
//             setRecurringPeriod(null)
//             setRecurringEndDate("")
//             onReloadApi(true)
//           })
//         } else {
//           setLoading(false)
//           Swal.fire({
//             icon: "warning",
//             text: `${response.data.data}`,
//           })
//         }
//       } catch (error) {
//         console.error("Error", error)
//         setLoading(false)
//       }
//     } else {
//       Swal.fire({
//         icon: "warning",
//         text: "Please fill all fields",
//       })
//     }
//   }

//   // const handleFilter = e => {
//   //   e.preventDefault()

//   //   if (
//   //     fromDateFilter &&
//   //     toDateFilter &&
//   //     moment(fromDateFilter).isAfter(toDateFilter)
//   //   ) {
//   //     Swal.fire({
//   //       icon: "warning",
//   //       title: "Invalid date range",
//   //       text: "end date must be after the start date.",
//   //     })
//   //     return
//   //   }

//   //   if (fromDateFilter || toDateFilter || filterPayment || filterCategory) {
//   //     setIsfilter(true)
//   //     try {
//   //       let filteredData = allData?.expense || []

//   //       if (fromDateFilter) {
//   //         filteredData = filteredData.filter(item =>
//   //           moment(item.created_at).isSameOrAfter(moment(fromDateFilter))
//   //         )
//   //       }

//   //       if (toDateFilter) {
//   //         filteredData = filteredData.filter(item =>
//   //           moment(item.created_at).isSameOrBefore(moment(toDateFilter))
//   //         )
//   //       }

//   //       if (filterPayment) {
//   //         filteredData = filteredData.filter(item => {
//   //           return item.payment_method == filterPayment?.value
//   //         })
//   //       }

//   //       if (filterCategory) {
//   //         filteredData = filteredData.filter(
//   //           item => item.category_id == filterCategory?.value
//   //         )
//   //       }

//   //       filteredData = filteredData.sort(
//   //         (a, b) => new Date(a.created_at) - new Date(b.created_at)
//   //       )
//   //       setDatas([...filteredData])
//   //     } catch (error) {
//   //       console.error(error)
//   //       Swal.fire({
//   //         icon: "error",
//   //         title: "Something went wrong",
//   //         text: "Unable to apply filters. please try again.",
//   //       })
//   //     }
//   //   } else {
//   //     Swal.fire({
//   //       icon: "warning",
//   //       text: "Please enter at least one filter criterion to proceed.",
//   //     })
//   //   }
//   // }
//   const handleFilter = (e) => {
//     e.preventDefault();

//     // Validate date range: fromDate must be before toDate
//     if (
//       fromDateFilter &&
//       toDateFilter &&
//       moment(fromDateFilter).isAfter(moment(toDateFilter))
//     ) {
//       Swal.fire({
//         icon: "warning",
//         title: "Invalid date range",
//         text: "End date must be after the start date.",
//       });
//       return;
//     }

//     if (fromDateFilter || toDateFilter || filterPayment || filterCategory) {
//       setIsfilter(true);
//       try {
//         let filteredData = allData?.expense ?? [];

//         // Filter entries with date >= fromDateFilter
//         if (fromDateFilter) {
//           filteredData = filteredData.filter((item) =>
//             moment(item.date).isSameOrAfter(moment(fromDateFilter), "day")
//           );
//         }

//         // Filter entries with date <= toDateFilter
//         if (toDateFilter) {
//           filteredData = filteredData.filter((item) =>
//             moment(item.date).isSameOrBefore(moment(toDateFilter), "day")
//           );
//         }

//         // Filter by payment method if selected
//         if (filterPayment) {
//           filteredData = filteredData.filter(
//             (item) => item.payment_method === filterPayment.value
//           );
//         }

//         // Filter by category if selected
//         if (filterCategory) {
//           filteredData = filteredData.filter(
//             (item) => item.category_id === filterCategory.value
//           );
//         }

//         // Sort by date descending (latest first)
//         filteredData = filteredData.sort(
//           (a, b) => new Date(b.date) - new Date(a.date)
//         );

//         setDatas([...filteredData]);
//       } catch (error) {
//         console.error(error);
//         Swal.fire({
//           icon: "error",
//           title: "Something went wrong",
//           text: "Unable to apply filters. Please try again.",
//         });
//       }
//     } else {
//       Swal.fire({
//         icon: "warning",
//         text: "Please enter at least one filter criterion to proceed.",
//       });
//     }
//   };

//   const handleClear = () => {
//     setIsfilter(false);
//     setFromDateFilter("");
//     setToDateFilter("");
//     setFilterPayment(null);
//     setFilterCategory(null);
//     setFilterCurrency(null);
//     const expense = allData?.expense?.filter((list) => {
//       const modifyAmount =
//         Number(list.amount)?.toFixed(1) - Number(list.tbal)?.toFixed(1);
//       return modifyAmount >= 1;
//     });
//     setDatas(expense);
//   };
//   const handleClose = async () => {
//     if (
//       fromDateFilter ||
//       toDateFilter ||
//       filterPayment ||
//       filterCategory ||
//       filterCurrency
//     ) {
//       setIsfilter(false);
//       setFormPopup(!formPopup);
//       setFromDateFilter("");
//       setToDateFilter("");
//       setFilterPayment(null);
//       setFilterCategory(null);
//       setFilterCurrency(null);
//       const expense = allData?.expense?.filter((list) => {
//         const modifyAmount =
//           Number(list.amount)?.toFixed(1) - Number(list.tbal)?.toFixed(1);
//         return modifyAmount >= 1;
//       });
//       setDatas(expense);
//       Swal.fire({
//         icon: "success",
//         text: "Filter cleared and popup closed.",
//       });
//     } else {
//       setFormPopup(!formPopup);
//     }
//   };

//   const handleAddDate = async (date) => {
//     setAddDate(date);
//   };
//   useEffect(() => {
//     if (addDate && currencyValue && amountValue) {
//       if (currencyValue.label !== "INR") {
//         const fetchCurrencyRate = async () => {
//           setLoading(true);
//           try {
//             const response = await axios.get(
//               `https://api.apilayer.com/fixer/${addDate}?symbols=INR&base=${currencyValue.label}`,
//               {
//                 headers: {
//                   apikey: configure.exchangeKey,
//                 },
//               }
//             );
//             if (response) {
//               setLoading(false);
//               const rate = response.data.rates.INR;
//               const formattedRate = rate.toFixed(2);
//               setConvertInrAmount(formattedRate); // Calculate the converted amount
//             } else {
//               setLoading(false);
//             }
//           } catch (error) {
//             setLoading(false);
//             Swal.fire({
//               icon: "warning",
//               text:
//                 error.response?.data?.message || "Error fetching currency rate",
//             });
//             console.error("Error fetching currency rate:", error);
//           }
//         };
//         fetchCurrencyRate();
//         setIsConvertedAmount(true);
//       } else {
//         setIsConvertedAmount(false);
//       }
//     }
//   }, [addDate, currencyValue, amountValue]);

//   useEffect(() => {
//     const updateWidth = () => {
//       const viewportWidth = window.innerWidth;
//       setBoxWidth(viewportWidth * 0.9);
//     };
//     updateWidth();
//     window.addEventListener("resize", updateWidth);
//     return () => window.removeEventListener("resize", updateWidth);
//   }, []);

//   const handleAddE = async () => {
//     setLoading(true);
//     const formData = new FormData();
//     formData.append("user_id", localStorage.getItem("auth_id"));
//     formData.append("module_id", 41);
//     try {
//       await axios({
//         method: "post",
//         url: `${configure.apiUrl}/earth_permission`,
//         data: formData,
//         headers: {
//           Accept: "application/json",
//           "Content-Type": "multipart/form-data",
//         },
//       }).then((res) => {
//         setLoading(false);
//         if (res.data.data.india[3] == 1 || res.data.data.uk[3] == 1) {
//           setAddExpense(true);
//         } else {
//           setAccessDenied(true);
//         }
//       });
//     } catch (error) {
//       console.log(error);
//     }
//   };

//   const fianancial_year = [
//     { label: "2024 to 2025", value: "2024 to 2025" },
//     { label: "2023 to 2024", value: "2023 to 2024" },
//     { label: "2022 to 2023", value: "2022 to 2023" },
//   ];

//   return (
//     <div>
//       {/* fixed buttons */}
//       <div
//         className={`flex-column fixed-buttons pt-2 ${fixedContent ? "d-flex" : "d-none"
//           }`}
//       >
//         <Link
//           onClick={() => handleAddE()}
//           className="btn btn-save  fix-btn btn-label pe-0"
//         >
//           <i className="fas fa-plus me-2 icon-size label-icon"></i>
//           <span>Expense</span>
//         </Link>
//         <button
//           onClick={() => navigate(-1)}
//           className="btn btn-red  fix-btn btn-label pe-0"
//         >
//           <i className="dripicons-cross me-2 icon-center label-icon"></i>
//           <span>Cancel</span>
//         </button>
//       </div>

//       <Row className="d-flex mt-4">
//         <div className="d-flex col-md-8 justify-flex-start align-items-center gap-2">
//           <div
//             className={`col-md-2 budget_status text-success pt-2 px-2 me-5 rounded proposal-status text-center total-expesne`}
//           >
//             <h6>Total Expense</h6>
//             <h3>
//               ₹{" "}
//               {allData?.budgetExpense
//                 ? Number(allData?.budgetExpense)?.toFixed(2)
//                 : 0}
//             </h3>
//           </div>
//           <div
//             className={`col-md-2 budget_status text-primary"  pt-2 px-1 rounded proposal-status text-center`}
//           >
//             <h6>Total Payable</h6>
//             <h3> ₹ 0</h3>
//           </div>
//           <div
//             className={`col-md-2 budget_status text-primary" pt-2 px-1 rounded proposal-status text-center`}
//           >
//             <h6>Total Bank</h6>
//             <h3> ₹ {allData?.bank ? Number(allData?.bank)?.toFixed(2) : 0}</h3>
//           </div>
//           <div
//             className={`col-md-2 budget_status text-primary
//           pt-2 px-2 rounded proposal-status text-center total-credit-card`}
//           >
//             <h6>Total Credit Card</h6>
//             <h3>
//               ₹{" "}
//               {allData?.credit_card
//                 ? Number(allData?.credit_card)?.toFixed(2)
//                 : 0}
//             </h3>
//           </div>
//           <div
//             className={`col-md-2 budget_status text-success pt-2 px-2 rounded proposal-status text-center`}
//           >
//             <h6>Other </h6>
//             <h3>
//               ₹ {allData?.others ? Number(allData?.others)?.toFixed(2) : 0}
//             </h3>
//           </div>
//         </div>
//         <div className="col-md-4 text-end">
//           <div className="">
//             <button
//               onClick={() => setFormPopup(!formPopup)}
//               className="btn btn-outline-secondary  me-3"
//             >
//               <i className="fas fa-filter"></i>
//             </button>
//             <button
//               className=" btn btn-save btn-label"
//               onClick={() => handleAddE()}
//             >
//               <i className="fas fa-plus me-2 label-icon"></i>
//               Expense
//             </button>
//           </div>
//         </div>
//       </Row>
//       <Row className="m-0 d-flex justify-space-between align-items-center">
//         <div className="p-0 col-md-2">
//           <select
//             className=" form-select mt-4"
//             style={{ width: "100px" }}
//             value={pageSize}
//             onChange={(e) => setPageSize(e.target.value)}
//           >
//             {[10, 25, 50, 100].map((pageSize) => (
//               <option key={pageSize} value={pageSize}>
//                 Show {pageSize}
//               </option>
//             ))}
//           </select>
//         </div>
//         <div className="p-0 col-md-2">
//           <div className="search-box my-xxl-0 d-inline-block ">
//             <div className="position-relative  mt-4">
//               <label htmlFor="search-bar-0" className="search-label">
//                 <span id="search-bar-0-label" className="sr-only">
//                   Search this table
//                 </span>
//                 <input
//                   onChange={(e) => setGlobalFilter(e.target.value)}
//                   id="search-bar-0"
//                   type="text"
//                   className=" form-control rounded h-100 "
//                   placeholder={` Search...`}
//                   value={globalFilter || ""}
//                 />
//               </label>
//               <i className="bx bx-search-alt search-icon"></i>
//             </div>
//           </div>
//         </div>
//       </Row>
//       <div className="position-relative">
//         <Table className="table table-bordered mt-4" {...getTableProps()}>
//           <thead
//             className={`${fixedContent && page.length >= 10 ? "fix-header" : ""
//               } fix-introducer-header`}
//           >
//             {headerGroups.map((headerGroup, i) => (
//               <tr key={i} {...headerGroup.getHeaderGroupProps()}>
//                 {headerGroup.headers.map((column, index) => (
//                   <th
//                     key={index}
//                     className={`t-col-${index + 1} ${column.className}`}
//                     {...column.getHeaderProps(column.getSortByToggleProps())}
//                   >
//                     <div className="d-flex align-items-center">
//                       <span className="flex-grow-1 text-center header-text">
//                         {column.render("Header")}
//                       </span>
//                       {column.isShortIcon && (
//                         <span
//                           onClick={() =>
//                             column.getSortByToggleProps().onClick()
//                           }
//                           className="d-flex align-items-center ms-2"
//                         >
//                           <i
//                             title="Ascending"
//                             className={`bi bi-arrow-up info-icon ${column.isSorted && !column.isSortedDesc
//                               ? "text-dark"
//                               : ""
//                               }`}
//                           ></i>
//                           <i
//                             title="Descending"
//                             className={`bi bi-arrow-down info-icon ${column.isSorted && column.isSortedDesc
//                               ? "text-dark"
//                               : ""
//                               }`}
//                           ></i>
//                         </span>
//                       )}
//                     </div>
//                   </th>
//                 ))}
//               </tr>
//             ))}
//           </thead>

//           <tbody className="fix-introducer-header" {...getTableBodyProps()}>
//             {page.map((row, i) => {
//               prepareRow(row);
//               return (
//                 <tr className="row-hover" {...row.getRowProps()} key={i}>
//                   {row.cells.map((cell, index) => {
//                     return (
//                       <td
//                         key={index}
//                         className={`t-col-${index + 1} ${cell.column.className
//                           }`}
//                         {...cell.getCellProps()}
//                       >
//                         {cell.render("Cell")}
//                       </td>
//                     );
//                   })}
//                 </tr>
//               );
//             })}
//             {page.length == 0 && (
//               <tr className="text-center">
//                 <td colSpan={8}>No Data Found</td>
//               </tr>
//             )}
//           </tbody>
//         </Table>
//       </div>

//       {/* Pagination */}
//       <Row className="justify-content-md-end justify-content-center align-items-center">
//         <NewPagination
//           gotoPage={gotoPage}
//           canPreviousPag={canPreviousPage}
//           canNextPage={canNextPage}
//           pageIndex={pageIndex}
//           pageOptions={pageOptions}
//           pageSize={pageSize}
//           page={page}
//           data={data}
//         />
//       </Row>

//       {/* Filter Modal  */}
//       {/* {formPopup ? (
//         <Draggable>
//         <ResizableBox
//           width={boxWidth}
//           style={{
//             position: "fixed",
//             top: "30%",
//             right: "3%",
//             zIndex: "1055",
//             backgroundColor: "#fff",
//           }}
//         >
//         <div className="expense-filter">
//           <div className="popup-form p-4">
//             <Form
//               onSubmit={handleFilter}
//               className="row d-flex justify-content-center align-items-center"
//             >
//               <div className="col-md-12 d-flex ">
//                 <div className="col-md-2 ps-2">
//                   <Label htmlFor="formrow-firstname-Input">From Date</Label>
//                   <Input
//                     type="date"
//                     value={fromDate}
//                     onChange={e => setFromDate(e.target.value)}
//                   />

//                 </div>
//                 <div className="col-md-2 ps-2">
//                   <Label htmlFor="formrow-firstname-Input">To Date</Label>
//                   <Input
//                     type="date"
//                     value={toDate}
//                     onChange={e => setToDate(e.target.value)}
//                   />

//                 </div>
//                 <div className="col-md-2 ps-2 mb-4">
//                   <Label htmlFor="formrow-firstname-Input">Payment Via</Label>
//                   <Select
//                     placeholder="Payment Via"
//                     className="basic-multi-select"
//                     classNamePrefix=" select"

//                     options={payments}
//                     value={filterPayment}
//                     onChange={selectedOption =>
//                       setFilterPayment(selectedOption)
//                     }
//                   />
//                 </div>
//                 <div className="col-md-2 ps-2">
//                   <Label htmlFor="formrow-firstname-Input">Category</Label>
//                   <Select

//                     placeholder="Payment Category"
//                     className="basic-multi-select"
//                     classNamePrefix=" select"

//                     options={Categories}
//                     value={filterCategory}
//                     onChange={selectedOption =>
//                       setFilterCategory(selectedOption)
//                     }
//                   />
//                 </div>

//                 <div className="col-md-4 d-flex justify-content-end align-items-center gap-2">
//                   <a
//                     className="btn  btn-danger"
//                     style={{
//                       fontSize: "14px",
//                       backgroundColor: "#fed36d",
//                       borderColor: "#fed36d",
//                       color: "black",
//                     }}
//                     onClick={() => handleClear()}
//                   >
//                     Clear Filters
//                   </a>
//                   <button className="btn  btn-save btn-label me-1">
//                     <i className="fas fa-filter search-icon label-icon"></i>{" "}
//                     Filter
//                   </button>
//                   <a
//                     className="btn btn-red btn-label me-1"
//                     onClick={() => setFormPopup(!formPopup)}
//                   >
//                     <i className="dripicons-cross label-icon"></i> Close
//                   </a>
//                 </div>


//               </div>
//             </Form>
//             <i className="bi bi-triangle-fill pop-icon"></i>
//           </div>
//         </div>
//         </ResizableBox>
//         </Draggable>
//       ) : null} */}
//       {formPopup ? (
//         <Draggable>
//           <ResizableBox
//             width={boxWidth}
//             style={{
//               position: "fixed",
//               top: "30%",
//               right: "3%",
//               zIndex: "1055",
//               backgroundColor: "#fff",
//             }}
//           >
//             {/* <div className="expense-filter">
//           <div className="popup-form p-4"> */}
//             <Form
//               onSubmit={handleFilter}
//               className="row d-flex justify-content-center align-items-center"
//             >
//               <div className="col-md-12 d-flex ">
//                 <div className="col-md-2 ps-2">
//                   <Label htmlFor="formrow-firstname-Input">From Date</Label>
//                   <Input
//                     type="date"
//                     required={toDateFilter ? true : false}
//                     value={fromDateFilter}
//                     onChange={(e) => setFromDateFilter(e.target.value)}
//                   />
//                 </div>
//                 <div className="col-md-2 ps-2">
//                   <Label htmlFor="formrow-firstname-Input">To Date</Label>
//                   <Input
//                     type="date"
//                     value={toDateFilter}
//                     onChange={(e) => setToDateFilter(e.target.value)}
//                   />
//                 </div>
//                 <div className="col-md-2 ps-2 mb-4">
//                   <Label htmlFor="formrow-firstname-Input">Payment Via</Label>
//                   <Select
//                     placeholder="Payment Via"
//                     className="basic-multi-select"
//                     classNamePrefix=" select"
//                     options={paymentsOption}
//                     value={filterPayment}
//                     onChange={(selectedOption) =>
//                       setFilterPayment(selectedOption)
//                     }
//                   />
//                 </div>
//                 <div className="col-md-2 ps-2">
//                   <Label htmlFor="formrow-firstname-Input">
//                     Payment Category
//                   </Label>
//                   <Select
//                     placeholder="Payment Category"
//                     className="basic-multi-select"
//                     classNamePrefix=" select"
//                     options={Categories}
//                     value={filterCategory}
//                     onChange={(selectedOption) =>
//                       setFilterCategory(selectedOption)
//                     }
//                   />
//                 </div>

//                 <div className="col-md-4 d-flex justify-content-end align-items-center gap-2">
//                   <a
//                     className="btn  btn-danger"
//                     style={{
//                       fontSize: "14px",
//                       backgroundColor: "#fed36d",
//                       borderColor: "#fed36d",
//                       color: "black",
//                     }}
//                     onClick={() => handleClear()}
//                   >
//                     Clear Filters
//                   </a>
//                   <button className="btn  btn-save btn-label me-1">
//                     <i className="fas fa-filter search-icon label-icon"></i>{" "}
//                     Filter
//                   </button>
//                   <a
//                     className="btn btn-red btn-label me-1"
//                     onClick={() => handleClose()}
//                   >
//                     <i className="dripicons-cross label-icon"></i> Close
//                   </a>
//                 </div>
//               </div>
//             </Form>
//           </ResizableBox>
//         </Draggable>
//       ) : null}

//       {/* Add Expense Modal */}

//       {/* <Modal isOpen={addExpense} size="xl" className="" centered>
//         <div className="modal-header pe-4">
//           <h5 className="modal-title mt-0">Add Expense</h5>
//           <button
//             type="button"
//             onClick={() => {
//               setAddExpense(false);
//             }}
//             className="btn-modal-close"
//           >
//             <span aria-hidden="true" className="btn-modal-span">
//               &times;
//             </span>
//           </button>
//         </div>

//         <div className="modal-body pe-4">
//           <Form
//             onSubmit={handleSubmit}
//             className="row d-flex justify-content-center align-items-center"
//           >
//             <div className="col-md-5 d-flex justify-content-end align-items-center ps-3">
//               <div className="text-center">
//                 <img src={addexpense} alt="Addepe" style={{ width: "90%" }} />
//               </div>
//             </div>

//             <div className="col-md-6 d-flex flex-column ">
//               <div className="col-md-12 d-flex mb-4 justify-content-start align-items-end">
//                 <div className="col-md-4  ps-2">
//                   <Label htmlFor="formrow-firstname-Input">
//                     Date <span className="text-danger">*</span>
//                   </Label>
//                   <div className="d-flex justify-content-start align-items-center gap-2">
//                     <Input
//                       required
//                       type="date"
//                       value={addDate}
//                       onChange={(e) => handleAddDate(e.target.value)}
//                       className="form-control"
//                     />
//                   </div>
//                 </div>
//                 <div className="col-md-4 ps-2">
//                   <Label htmlFor="formrow-firstname-Input">
//                     Location <span className="text-danger">*</span>
//                   </Label>
//                   <Select
//                     // value={lead_belong}
//                     placeholder="Select Location"
//                     className="basic-multi-select"
//                     classNamePrefix=" select"
//                     // styles={colourStyles}
//                     options={location}
//                     value={locationValue}
//                     onChange={(selectedOption) =>
//                       setLocationValue(selectedOption)
//                     }
//                   />
//                 </div>
//                 <div className="col-md-4 ps-2">
//                   <Label htmlFor="formrow-firstname-Input">
//                     Currency <span className="text-danger">*</span>
//                   </Label>
//                   <Select
//                     // value={lead_belong}
//                     placeholder="Select Currency"
//                     className="basic-multi-select"
//                     classNamePrefix=" select"
//                     // styles={colourStyles}
//                     options={Currency}
//                     value={currencyValue}
//                     onChange={(selectedOption) =>
//                       setCurrencyValue(selectedOption)
//                     }
//                   />
//                 </div>
//               </div>
//               <div className="col-md-12 d-flex mb-4 justify-content-start align-items-end">
//                 <div className="col-md-6 ps-2">
//                   <Label htmlFor="formrow-firstname-Input">
//                     Payment Via <span className="text-danger">*</span>
//                   </Label>
//                   <Select
//                     // value={lead_belong}
//                     placeholder="Payment Via"
//                     className="basic-multi-select"
//                     classNamePrefix=" select"
//                     // styles={colourStyles}
//                     options={paymentsOption}
//                     value={paymentViaValue}
//                     onChange={(selectedOption) =>
//                       setPaymentViaValue(selectedOption)
//                     }
//                   />
//                 </div>
//                 <div className="col-md-6 ps-2">
//                   <Label htmlFor="formrow-firstname-Input">
//                     Category <span className="text-danger">*</span>
//                   </Label>
//                   <Select
//                     placeholder="Payment Category"
//                     className="basic-multi-select"
//                     classNamePrefix=" select"
//                     options={Categories}
//                     value={categoryValue}
//                     onChange={(selectedOption) =>
//                       setCategoryValue(selectedOption)
//                     }
//                   />
//                 </div>
//               </div>
//               <div className="col-md-12 d-flex flex-column justify-content-start align-items-start">
//                 <div className="col-md-12 ps-2 mb-4 row">
//                   <div className="col-md-10">
//                     <Label htmlFor="formrow-firstname-Input">
//                       Title <span className="text-danger">*</span>
//                     </Label>

//                     <div className="d-flex justify-content-start align-items-center gap-2">
//                       <Input
//                         type="text"
//                         className="form-control"
//                         // id="formrow-firstname-Input"
//                         placeholder="Enter Title"
//                         // style={{width : "80%"}}
//                         value={titleValue}
//                         onChange={(e) => setTitleValue(e.target.value)}
//                       />
//                     </div>
//                   </div>
//                   <div className="col-md-2 mb-2">
//                     <Label htmlFor="formrow-firstname-Input">Recurring</Label>
//                     <div className="form-switch form-switch-md ">
//                       <input
//                         type="checkbox"
//                         className="form-check-input mt-2"
//                         id="customSwitchsizemd"
//                         defaultChecked={recurring == 1 ? true : false}
//                         onChange={(e) => setRecurring(e.target.checked ? 1 : 0)}
//                       />
//                     </div>
//                   </div>
//                 </div>

//                 {recurring == 1 && (
//                   <div className="col-md-12 d-flex mb-4 ps-2 justify-content-start align-items-end gap-2">
//                     <>
//                       {" "}
//                       <div className="col-md-4">
//                         <Label htmlFor="formrow-firstname-Input">
//                           Recurring Period{" "}
//                           <span className="text-danger">*</span>
//                         </Label>
//                         <Select
//                           placeholder="Select recurring"
//                           className="basic-multi-select"
//                           classNamePrefix=" select"
//                           options={recurringOptions}
//                           value={recurringPeriod}
//                           onChange={(selectedOption) =>
//                             setRecurringPeriod(selectedOption)
//                           }
//                         />
//                       </div>
//                       <div className="col-md-4">
//                         <Label htmlFor="formrow-firstname-Input">
//                           Recurring End Date{" "}
//                           <span className="text-danger">*</span>
//                         </Label>
//                         <Input
//                           required
//                           type="date"
//                           className="form-control"
//                           placeholder="Enter Amount"
//                           value={recurringEndDate}
//                           onChange={(e) => setRecurringEndDate(e.target.value)}
//                           min={
//                             addDate
//                               ? new Date(addDate).toISOString().split("T")[0]
//                               : ""
//                           }
//                         />
//                       </div>
//                     </>
//                   </div>
//                 )}

//                 <div className="col-md-12 pb-4 ps-2 d-flex gap-2 border-bottom">
//                   <div className="col-4">
//                     <Label htmlFor="formrow-firstname-Input">
//                       Amount <span className="text-danger">*</span>
//                     </Label>

//                     <div className="d-flex justify-content-start align-items-center gap-2">
//                       <Input
//                         required
//                         type="number"
//                         className="form-control"
//                         // id="formrow-firstname-Input"
//                         placeholder="Enter Amount"
//                         style={{ width: "100%" }}
//                         value={amountValue}
//                         onChange={(e) => setAmountValue(e.target.value)}
//                       />
//                     </div>
//                   </div>
//                   <div className="col-4">
//                     <Label htmlFor="formrow-firstname-Input">GST</Label>

//                     <div className="d-flex justify-content-start align-items-center gap-2">
//                       <Input
//                         type="text"
//                         className="form-control"
//                         placeholder="Enter GST"
//                         style={{ width: "100%" }}
//                         value={gstValue}
//                         onChange={(e) => setGstValue(e.target.value)}
//                       />
//                     </div>
//                   </div>

//                   {isConvertedAmount && (
//                     <div className="col-md-4 ">
//                       <Label htmlFor="formrow-firstname-Input">
//                         Exchange Rate
//                       </Label>

//                       <div className="d-flex justify-content-start align-items-center gap-2">
//                         <Input
//                           type="text"
//                           className="form-control"
//                           // placeholder="Enter GST"
//                           readOnly
//                           style={{ width: "100%" }}
//                           value={convertInrAmount}
//                           onChange={(e) => setConvertInrAmount(e.target.value)}
//                         />
//                       </div>
//                     </div>
//                   )}
//                   <div className="col-4 ">
//                     <Label>Upload File</Label>
//                     <input type="file" className="form-control"></input>
//                   </div>
//                 </div> 

//                 <div className="col-md-12 mb-2 pt-3">
//                   <div className="d-flex align-items-center gap-3">

//                     <div>
//                       <Label htmlFor="introducerSwitch">Introducer</Label>
//                       <div className="form-switch form-switch-md">
//                         <input
//                           type="checkbox"
//                           className="form-check-input mt-2"
//                           id="introducerSwitch"
//                           defaultChecked={introducer == 1}
//                           onChange={(e) => {
//                             setIntroducer(e.target.checked ? 1 : 0);
//                             console.log(introducer);
//                           }}
//                         />
//                       </div>
//                     </div>

//                     {introducer == 1 && (
//                       <div className="d-flex align-items-center gap-3 flex-grow-1">

//                         <div className="flex-grow-1">
//                           <Label>Select Introducer</Label>
//                           <Select
//                             placeholder="Select Introducer"
//                             className="basic-multi-select"
//                             classNamePrefix="select"
//                             styles={colourStyles}
//                             options={introducerOptions}
//                             onChange={(selectedOption) =>
//                               setIntroducerValue(
//                                 selectedOption ? selectedOption.value : null
//                               )
//                             }
//                           />
//                         </div>

//                         <div>
//                           <Label htmlFor="recordPaymentSwitch">
//                             Charge Introducer
//                           </Label>
//                           <div className="form-switch form-switch-md">
//                             <input
//                               type="checkbox"
//                               className="form-check-input mt-2"
//                               id="recordPaymentSwitch"
//                               defaultChecked={recordPayment == 1}
//                               onChange={(e) => {
//                                 setRecordPayment(e.target.checked ? 1 : 0);
//                               }}
//                             />
//                           </div>
//                         </div>
//                       </div>
//                     )}
//                   </div>
//                 </div>
//               </div>

//               <div className="my-4 text-center">
//                 <button className=" btn btn-save btn-label">
//                   <i className="fas fa-save me-2 label-icon"></i>
//                   Save
//                 </button>
//                 <a
//                   onClick={() => setAddExpense(false)}
//                   className=" btn ms-md-2 btn-red btn-label"
//                 >
//                   <i className="dripicons-cross me-2 icon-center label-icon"></i>
//                   CANCEL
//                 </a>
//               </div>
//             </div>

//           </Form>
//         </div>
//       </Modal> */}

//       <Modal isOpen={addExpense} size="xl" className="" centered>
//         <div className="modal-header pe-4">
//           <h5 className="modal-title mt-0">Add Expense</h5>
//           <button
//             type="button"
//             onClick={() => {
//               setAddExpense(false)
//             }}
//             className="btn-modal-close"
//           >
//             <span aria-hidden="true" className="btn-modal-span">
//               &times;
//             </span>
//           </button>
//         </div>

//         <div className="modal-body pe-4">
//           <Form
//             onSubmit={handleSubmit}
//             className="row d-flex justify-content-center align-items-center"
//           >
//             <div className="col-md-5 d-flex justify-content-end align-items-center ps-3">
//               <div className="text-center">
//                 <img src={addexpense} alt="Addepe" style={{ width: "90%" }} />
//               </div>
//             </div>

//             <div className="col-md-6 d-flex flex-column ">
//               <div className="col-md-12 d-flex mb-4 justify-content-start align-items-end">
//                 <div className="col-md-4  ps-2">
//                   <Label htmlFor="formrow-firstname-Input">
//                     Date <span className="text-danger">*</span>
//                   </Label>
//                   <div className="d-flex justify-content-start align-items-center gap-2">
//                     <Input
//                       required
//                       type="date"
//                       value={addDate}
//                       onChange={e => handleAddDate(e.target.value)}
//                       className="form-control"
//                     />
//                   </div>
//                 </div>
//                 <div className="col-md-4 ps-2">
//                   <Label htmlFor="formrow-firstname-Input">
//                     Location <span className="text-danger">*</span>
//                   </Label>
//                   <Select
//                     // value={lead_belong}
//                     placeholder="Select Location"
//                     className="basic-multi-select"
//                     classNamePrefix=" select"
//                     // styles={colourStyles}
//                     options={location}
//                     value={locationValue}
//                     onChange={selectedOption =>
//                       setLocationValue(selectedOption)
//                     }
//                   />
//                 </div>
//                 <div className="col-md-4 ps-2">
//                   <Label htmlFor="formrow-firstname-Input">
//                     Currency <span className="text-danger">*</span>
//                   </Label>
//                   <Select
//                     // value={lead_belong}
//                     placeholder="Select Currency"
//                     className="basic-multi-select"
//                     classNamePrefix=" select"
//                     // styles={colourStyles}
//                     options={Currency}
//                     value={currencyValue}
//                     onChange={selectedOption =>
//                       setCurrencyValue(selectedOption)
//                     }
//                   />
//                 </div>
//               </div>
//               <div className="col-md-12 d-flex mb-4 justify-content-start align-items-end">
//                 <div className="col-md-6 ps-2">
//                   <Label htmlFor="formrow-firstname-Input">
//                     Payment Via <span className="text-danger">*</span>
//                   </Label>
//                   <Select
//                     // value={lead_belong}
//                     placeholder="Payment Via"
//                     className="basic-multi-select"
//                     classNamePrefix=" select"
//                     // styles={colourStyles}
//                     options={paymentsOption}
//                     value={paymentViaValue}
//                     onChange={selectedOption =>
//                       setPaymentViaValue(selectedOption)
//                     }
//                   />
//                 </div>
//                 <div className="col-md-6 ps-2">
//                   <Label htmlFor="formrow-firstname-Input">
//                     Category <span className="text-danger">*</span>
//                   </Label>
//                   <Select
//                     placeholder="Payment Category"
//                     className="basic-multi-select"
//                     classNamePrefix=" select"
//                     options={Categories}
//                     value={categoryValue}
//                     onChange={selectedOption =>
//                       setCategoryValue(selectedOption)
//                     }
//                   />
//                 </div>
//               </div>
//               <div className="col-md-12 d-flex flex-column justify-content-start align-items-start">
//                 <div className="col-md-12 ps-2 mb-4 row">
//                   <div className="col-md-10">
//                     <Label htmlFor="formrow-firstname-Input">
//                       Title <span className="text-danger">*</span>
//                     </Label>

//                     <div className="d-flex justify-content-start align-items-center gap-2">
//                       <Input
//                         type="text"
//                         className="form-control"
//                         // id="formrow-firstname-Input"
//                         placeholder="Enter Title"
//                         // style={{width : "80%"}}
//                         value={titleValue}
//                         onChange={e => setTitleValue(e.target.value)}
//                       />
//                     </div>
//                   </div>
//                   <div className="col-md-2 mb-2">
//                     <Label htmlFor="formrow-firstname-Input">Recurring</Label>
//                     <div className="form-switch form-switch-md ">
//                       <input
//                         type="checkbox"
//                         className="form-check-input mt-2"
//                         id="customSwitchsizemd"
//                         defaultChecked={recurring == 1 ? true : false}
//                         onChange={e => setRecurring(e.target.checked ? 1 : 0)}
//                       />
//                     </div>
//                   </div>
//                 </div>

//                 {recurring == 1 && (
//                   <div className="col-md-12 d-flex mb-4 ps-2 justify-content-start align-items-end gap-2">
//                     <>
//                       {" "}
//                       <div className="col-md-4">
//                         <Label htmlFor="formrow-firstname-Input">
//                           Recurring Period{" "}
//                           <span className="text-danger">*</span>
//                         </Label>
//                         <Select
//                           placeholder="Select recurring"
//                           className="basic-multi-select"
//                           classNamePrefix=" select"
//                           options={recurringOptions}
//                           value={recurringPeriod}
//                           onChange={selectedOption =>
//                             setRecurringPeriod(selectedOption)
//                           }
//                         />
//                       </div>
//                       <div className="col-md-4">
//                         <Label htmlFor="formrow-firstname-Input">
//                           Recurring End Date{" "}
//                           <span className="text-danger">*</span>
//                         </Label>
//                         <Input
//                           required
//                           type="date"
//                           className="form-control"
//                           placeholder="Enter Amount"
//                           value={recurringEndDate}
//                           onChange={e => setRecurringEndDate(e.target.value)}
//                           min={
//                             addDate
//                               ? new Date(addDate).toISOString().split("T")[0]
//                               : ""
//                           }
//                         />
//                       </div>
//                     </>
//                   </div>
//                 )}

//                 <div className="col-md-12 pb-4 ps-2 row border-bottom">
//                   <div className="col-4  mb-3">
//                     <Label htmlFor="formrow-firstname-Input">
//                       Amount <span className="text-danger">*</span>
//                     </Label>

//                     <div className="d-flex justify-content-start align-items-center gap-2">
//                       <Input
//                         required
//                         type="number"
//                         className="form-control"
//                         // id="formrow-firstname-Input"
//                         placeholder="Enter Amount"
//                         style={{ width: "100%" }}
//                         value={amountValue}
//                         onChange={e => setAmountValue(e.target.value)}
//                       />
//                     </div>
//                   </div>
//                   <div className="col-4">
//                     <Label htmlFor="formrow-firstname-Input">GST</Label>

//                     <div className="d-flex justify-content-start align-items-center gap-2">
//                       <Input
//                         type="text"
//                         className="form-control"
//                         placeholder="Enter GST"
//                         style={{ width: "100%" }}
//                         value={gstValue}
//                         onChange={e => setGstValue(e.target.value)}
//                       />
//                     </div>
//                   </div>

//                   {isConvertedAmount && (
//                     <div className="col-md-4 ">
//                       <Label htmlFor="formrow-firstname-Input">
//                         Exchange Rate
//                       </Label>

//                       <div className="d-flex justify-content-start align-items-center gap-2">
//                         <Input
//                           type="text"
//                           className="form-control"
//                           // placeholder="Enter GST"
//                           readOnly
//                           style={{ width: "100%" }}
//                           value={convertInrAmount}
//                           onChange={e => setConvertInrAmount(e.target.value)}
//                         />
//                       </div>
//                     </div>
//                   )}
//                   <div className="col-4">
//                     <Label>Upload File</Label>
//                     <input
//                       type="file"
//                       ref={expenseFileUpload}
//                       className="form-control"
//                     ></input>
//                   </div>
//                 </div>
//                 {/* <div className=""></div> */}

//                 <div className="col-md-12 mb-2 pt-3">
//                   <div className="d-flex align-items-center gap-3">
//                     {/* Introducer Toggle */}
//                     <div>
//                       <Label htmlFor="introducerSwitch">Introducer</Label>
//                       <div className="form-switch form-switch-md">
//                         <input
//                           type="checkbox"
//                           className="form-check-input mt-2"
//                           id="introducerSwitch"
//                           defaultChecked={introducer == 1}
//                           onChange={e => {
//                             setIntroducer(e.target.checked ? 1 : 0)
//                             console.log(introducer)
//                           }}
//                         />
//                       </div>
//                     </div>

//                     {/* Show only when introducer == 1 */}
//                     {introducer == 1 && (
//                       <div className="d-flex align-items-center gap-3 flex-grow-1">
//                         {/* Select Introducer */}
//                         <div className="flex-grow-1">
//                           <Label>Select Introducer</Label>
//                           <Select
//                             placeholder="Select Introducer"
//                             className="basic-multi-select"
//                             classNamePrefix="select"
//                             styles={colourStyles}
//                             options={introducerOptions}
//                             onChange={selectedOption =>
//                               setIntroducerValue(
//                                 selectedOption ? selectedOption.value : null
//                               )
//                             }
//                           />
//                         </div>

//                         {/* Record Payment Toggle */}
//                         <div>
//                           <Label htmlFor="recordPaymentSwitch">
//                             Charge Introducer
//                           </Label>
//                           <div className="form-switch form-switch-md">
//                             <input
//                               type="checkbox"
//                               className="form-check-input mt-2"
//                               id="recordPaymentSwitch"
//                               defaultChecked={recordPayment == 1}
//                               onChange={e => {
//                                 setRecordPayment(e.target.checked ? 1 : 0)
//                               }}
//                             />
//                           </div>
//                         </div>
//                       </div>
//                     )}
//                   </div>
//                 </div>
//               </div>

//               <div className="my-4 text-center">
//                 <button className=" btn btn-save btn-label">
//                   <i className="fas fa-save me-2 label-icon"></i>
//                   Save
//                 </button>
//                 <a
//                   onClick={() => setAddExpense(false)}
//                   className=" btn ms-md-2 btn-red btn-label"
//                 >
//                   <i className="dripicons-cross me-2 icon-center label-icon"></i>
//                   CANCEL
//                 </a>
//               </div>
//             </div>

//             {/* </div> */}
//           </Form>
//         </div>
//       </Modal>
//     </div>
//   );
// }

// const Expense = () => {
//   const [verticalActiveTab, setverticalActiveTab] = useState("1");
//   const [modal_fullscreen, setmodal_fullscreen] = useState(false);
//   const [isSelectDisabled, setIsSelectDisabled] = useState(true);
//   const [isConvertedAmount, setIsConvertedAmount] = useState(false);
//   const [convertInrAmount, setConvertInrAmount] = useState("");
//   const [isConvertedAmountPay, setIsConvertedAmountPay] = useState(false);
//   const [convertInrAmountPay, setConvertInrAmountPay] = useState("");
//   const [isFilter, setIsfilter] = useState(false);
//   const [introducer, setIntroducer] = useState(0);
//   const [recordPayment, setRecordPayment] = useState(0);
//   const [introducerOptions, setIntroducerOptions] = useState([]);
//   const [introducerValue, setIntroducerValue] = useState(null);
//   // const colourStyles = {
//   //   control: (styles, state) => ({
//   //     ...styles,
//   //     backgroundColor: state.isDisabled ? "gray" : "white",
//   //   }),
//   // }

//   const expenseFileUpload = useRef(null)


//   const toggleVertical = (tab) => {
//     if (verticalActiveTab !== tab) {
//       setverticalActiveTab(tab);
//     }
//   };

//   const toggleLoading = (loading) => {
//     setLoading(loading);
//   };

//   const fetchIntroducers = async () => {
//     try {
//       toggleLoading(true);
//       const data = await fetchNodeData(
//         toggleLoading,
//         "introducerOptions/0",
//         secureLocalStorage.getItem("auth_token")
//       );
//       if (data.status && data.introducers) {
//         const options = data.introducers.map((introducer) => ({
//           value: introducer.id,
//           label: introducer.company,
//         }));
//         setIntroducerOptions(options);
//       }
//     } catch (error) {
//       console.error("Error fetching introducers:", error);
//       Swal.fire({
//         icon: "error",
//         text: "Failed to fetch introducers.",
//       });
//     } finally {
//       toggleLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchIntroducers();
//   }, []);

//   document.title = "Expense | Zithas Crm";

//   const [data, setDatas] = useState([]);
//   const [viewBudgetData, setViewBudgetData] = useState(null);
//   const [allData, setAllData] = useState(null);
//   const [balanceAmount, setBalanceAmount] = useState(null);

//   const [view_customer, setVeiwCustomer] = useState([]);
//   const [isLoading, setLoading] = useState(false);

//   const [paymentMode, setPaymentMode] = useState(false);
//   const [editPaymentMode, setEditPaymentMode] = useState(false);
//   const [paymentModeOption, setPaymentModeOption] = useState([]);
//   const [payMentHistory, setPaymentHistory] = useState(false);
//   const [payMentHistoryData, setPaymentHistoryData] = useState([]);
//   const [editExpense, setEditExpense] = useState(false);
//   const [viewExpense, setViewExpense] = useState(false);

//   const [modal_Access, setAccessDenied] = useState(false);
//   const [location, setLocation] = useState([]);
//   const [Categories, setCategories] = useState([]);
//   const [payments, setPayments] = useState([]);
//   const [Currency, setCurrency] = useState([]);

//   // Edit expense states
//   const [editId, setEditId] = useState("");
//   const [updatedDate, setUpdatedDate] = useState(null);
//   const [updatedLocation, setUpdatedLocation] = useState(null);
//   const [updatedPayemntVia, setUpdatedPayemntVia] = useState(null);
//   const [updatedCategory, setUpdatedCategory] = useState(null);
//   const [updatedTitle, setUpdatedTitle] = useState(null);
//   const [updatedAmount, setUpdatedAmount] = useState(null);
//   const [updatedGst, setUpdatedGst] = useState(null);
//   const [updatedCurrency, setUpdatedCurrency] = useState(null);
//   const [updateRecurring, setupdateRecurring] = useState(0);
//   const [updateRecurringPeriod, setUpdateRecurringPeriod] = useState(null);
//   const [updateRecurringEndDate, setUpdateRecurringEndDate] = useState("");
//   const [recurringOptions, setRecurringOptions] = useState([
//     { value: 1, label: "1 Month" },
//     { value: 2, label: "2 Month" },
//     { value: 12, label: "1 Year" },
//   ]);
//   const [viewRecurring, setViewRecurring] = useState(0);
//   const [viewRecurringPeriod, setViewRecurringPeriod] = useState(null);
//   const [viewRecurringEndDate, setViewRecurringEndDate] = useState("");

//   // Add payment states
//   const [paymentId, setPaymentId] = useState("");
//   const [paymentDate, setPaymentDate] = useState("");
//   const [payPaymentMode, setPayPaymentMode] = useState(null);
//   const [payPaymentAmount, setPayPaymentAmount] = useState("");
//   const [payPaymentCurrency, setPayPaymentCurrency] = useState(null);
//   const [payPaymentFile, setPayPaymentFile] = useState("");
//   const [leftAmount, setLeftAmount] = useState(0);

//   const fetchData = async () => {
//     setLoading(true);
//     try {
//       const response = await axios({
//         method: "get",
//         url: `${configure.apiUrl}/budgetExpense/2`,
//         headers: {
//           Accept: "application/json",
//           "Content-Type": "multipart/form-data",
//         },
//       });
//       if (response) {
//         const expense = response.data.data?.expense?.filter((list) => {
//           const modifyAmount =
//             Number(list.amount)?.toFixed(1) - Number(list.tbal)?.toFixed(1);
//           return modifyAmount >= 1;
//         });
//         setDatas(expense);
//         setAllData(response?.data?.data);
//         setLoading(false);
//       }
//     } catch (err) {
//       console.log(err);
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchData();
//   }, []);

//   const paymentsOption = [
//     {
//       label: "Bank Account",
//       value: "1",
//     },
//     {
//       label: "Credit Card",
//       value: "2",
//     },
//     {
//       label: "Others",
//       value: "3",
//     },
//   ];

//   document.addEventListener("keydown", (e) => {
//     if (e.key === "Escape")
//       setPaymentMode(false),
//         setEditPaymentMode(false),
//         setPaymentHistory(false),
//         setEditExpense(false),
//         setViewExpense(false);
//   });

//   const navigate = useNavigate();

//   // const handlePayEditPayment = async paymentData => {
//   //   setLoading(true)
//   //   const formData = new FormData()
//   //   formData.append("user_id", localStorage.getItem("auth_id"))
//   //   formData.append("module_id", 41)
//   //   try {
//   //     await axios({
//   //       method: "post",
//   //       url: `${configure.apiUrl}/earth_permission`,
//   //       data: formData,
//   //       headers: {
//   //         Accept: "application/json",
//   //         "Content-Type": "multipart/form-data",
//   //       },
//   //     }).then(res => {
//   //       setLoading(false)
//   //       if (res.data.data.india[3] == 1 || res.data.data.uk[3] == 1) {
//   //         setPaymentId(paymentData.id)
//   //         setLeftAmount(paymentData.amount - (paymentData.tbal || 0))
//   //         const findOption = payments?.filter(item => {
//   //           return item.payment_via == paymentData.payment_via
//   //         })
//   //         setPaymentModeOption(findOption)

//   //         setPaymentDate(paymentData.date)
//   //         setPayPaymentMode(
//   //           payments.find(obj => obj.value == paymentData.payment_mode_id)
//   //         )
//   //         setPayPaymentAmount(paymentData.amount)
//   //         setPayPaymentCurrency(
//   //           Currency.find(obj => obj.value == paymentData.currency)
//   //         )
//   //         setEditPaymentMode(true)
//   //       } else {
//   //         setAccessDenied(true)
//   //       }
//   //     })
//   //   } catch (error) {
//   //     setLoading(false)
//   //     console.log(error)
//   //   }
//   // }
//   const [existingFile, setExistingFile] = useState(null);
//   const handlePayEditPayment = async (paymentData) => {
//     console.log("paymentData: ", paymentData);
//     setLoading(true);
//     const formData = new FormData();
//     formData.append("user_id", localStorage.getItem("auth_id"));
//     formData.append("module_id", 41);
//     try {
//       await axios({
//         method: "post",
//         url: `${configure.apiUrl}/earth_permission`,
//         data: formData,
//         headers: {
//           Accept: "application/json",
//           "Content-Type": "multipart/form-data",
//         },
//       }).then((res) => {
//         setLoading(false);
//         if (res.data.data.india[3] == 1 || res.data.data.uk[3] == 1) {
//           setPaymentId(paymentData.id);
//           setLeftAmount(paymentData.amount - (paymentData.tbal || 0));

//           // Existing
//           const findOption = payments?.filter((item) => {
//             return item.payment_via == paymentData.payment_via;
//           });
//           setPaymentModeOption(findOption);

//           // Add this: Set Payment Via
//           const paymentViaOption = paymentsOption?.find(
//             (obj) => obj.value == paymentData.payment_via
//           );
//           setPayPaymentVia(paymentViaOption);

//           // Rest of your code
//           setPaymentDate(paymentData.date);
//           setPayPaymentMode(
//             payments.find((obj) => obj.value == paymentData.payment_mode_id)
//           );
//           setPayPaymentAmount(paymentData.amount);
//           setExistingFile(paymentData.link + "?download=1");
//           setPayPaymentCurrency(
//             Currency.find((obj) => obj.value == paymentData.currency)
//           );
//           setEditPaymentMode(true);
//         } else {
//           setAccessDenied(true);
//         }
//       });
//     } catch (error) {
//       setLoading(false);
//       console.log(error);
//     }
//   };

//   const colourStyles = {
//     menuList: (styles) => ({
//       ...styles,
//       background: "white",
//     }),
//     menu: (base) => ({
//       ...base,
//       zIndex: 1200,
//     }),
//   };
//   // const

//   const [paymentCurrency, setPaymentCurrency] = useState(null);
//   const columns = useMemo(
//     () => [
//       {
//         Header: "ID",
//         accessor: "id",
//         isInfoIcon: false,
//         isShortIcon: true,
//         className: "text-center exp-1",
//       },
//       {
//         Header: () => {
//           return <div style={{ textAlign: "center" }}>Location</div>;
//         },
//         accessor: "location",
//         grow: false,
//         isShortIcon: true,
//         className: "location-box exp-2",
//         Cell: (cellProps) => {
//           return (
//             <div className="text-center d-flex justify-content-center align-items-center">
//               {cellProps.row.original.location == 1 ? (
//                 <img
//                   src={India}
//                   className=" mx-1 location-img text-center"
//                   alt="flag"
//                   height="20"
//                   width="30"
//                 />
//               ) : (
//                 <img
//                   src={Uk}
//                   className=" mx-1 location-img"
//                   alt="flag"
//                   height="20"
//                   width="30"
//                 />
//               )}
//             </div>
//           );
//         },
//         isInfoIcon: true,
//       },
//       {
//         Header: () => {
//           return <div style={{ textAlign: "center" }}>Date</div>;
//         },
//         accessor: "date",
//         isInfoIcon: true,
//         isShortIcon: true,
//         className: "exp-3 text-center",
//         Cell: (row) => {
//           return (
//             <div style={{ textAlign: "center" }}>
//               {moment(row.value).format("DD-MM-YYYY")}
//             </div>
//           );
//         },
//       },
//       {
//         Header: "Title",
//         accessor: "title",
//         isInfoIcon: true,
//         isShortIcon: true,
//         className: "exp-4",
//       },
//       {
//         Header: "Category",
//         accessor: "category_name",
//         isInfoIcon: true,
//         isShortIcon: true,
//         className: "exp-5",
//       },
//       {
//         Header: "Amount",
//         accessor: "amount",
//         isInfoIcon: true,
//         isShortIcon: true,
//         className: "text-center exp-6",
//         Cell: (cellProps) => {
//           const currencyIdToCode = {
//             1: "GBP",
//             2: "INR",
//             3: "CAD",
//             4: "USD",
//             5: "AUD",
//             6: "AED",
//             7: "SGD",
//           };
//           const currencySymbols = {
//             GBP: "£",
//             INR: "₹",
//             CAD: "CA$",
//             USD: "$",
//             AUD: "A$",
//             AED: "د.إ",
//             SGD: "S$",
//           };
//           const { currency, amount } = cellProps.row.original;
//           const currencyCode = currencyIdToCode[currency];
//           const symbol = currencySymbols[currencyCode] || "";
//           return (
//             <>
//               {symbol} {Number(cellProps.row.original.amount).toFixed(2)}
//             </>
//           );
//         },
//       },
//       {
//         Header: "Bal Amount",
//         accessor: "balance_amount",
//         isInfoIcon: true,
//         isShortIcon: true,
//         className: `text-center exp-7`,
//         Cell: (cellProps) => {
//           const currencyIdToCode = {
//             1: "GBP",
//             2: "INR",
//             3: "CAD",
//             4: "USD",
//             5: "AUD",
//             6: "AED",
//             7: "SGD",
//           };
//           const currencySymbols = {
//             GBP: "£",
//             INR: "₹",
//             CAD: "CA$",
//             USD: "$",
//             AUD: "A$",
//             AED: "د.إ",
//             SGD: "S$",
//           };
//           const { currency } = cellProps.row.original;
//           const currencyCode = currencyIdToCode[currency];
//           const symbol = currencySymbols[currencyCode] || "";
//           const modifyAmount =
//             parseFloat(Number(cellProps.row.original.amount)?.toFixed(1)) -
//             parseFloat(Number(cellProps.row.original.tbal)?.toFixed(1));
//           return (
//             <span>
//               {modifyAmount <= 0 ? (
//                 <div className="font-size-12 badge-soft-success badge bg-secondary">
//                   Fully Paid
//                 </div>
//               ) : (
//                 <>
//                   {symbol} {Number(modifyAmount)?.toFixed(2)}
//                 </>
//               )}
//             </span>
//           );
//         },
//       },
//       {
//         Header: "GST",
//         accessor: "gst",
//         isInfoIcon: true,
//         isShortIcon: true,
//         className: "text-center exp-8",
//       },
//       // {
//       //   Header: "Action",
//       //   accessor: "action",
//       //   classNames: "text-center exp-9",
//       //   Cell: (cellProps) => {
//       //     const isDelete = async () => {
//       //       setLoading(true);
//       //       const formData = new FormData();
//       //       formData.append("user_id", localStorage.getItem("auth_id"));
//       //       formData.append("module_id", 41);
//       //       try {
//       //         await axios({
//       //           method: "post",
//       //           url: `${configure.apiUrl}/earth_permission`,
//       //           data: formData,
//       //           headers: {
//       //             Accept: "application/json",
//       //             "Content-Type": "multipart/form-data",
//       //           },
//       //         }).then((res) => {
//       //           setLoading(false);
//       //           if (res.data.data.india[5] == 1 || res.data.data.uk[5] == 1) {
//       //             Swal.fire({
//       //               title: "Are you sure?",
//       //               text: "You want to delete this expense !",
//       //               icon: "warning",
//       //               buttons: true,
//       //               showCancelButton: true,
//       //             }).then(async (willDelete) => {
//       //               if (willDelete.isConfirmed) {
//       //                 setLoading(true);
//       //                 try {
//       //                   const response = await axios({
//       //                     method: "get",
//       //                     url: `${configure.apiUrl}/deleteBudgetExpense/${cellProps.row.original.id}/2`,
//       //                     headers: {
//       //                       Accept: "application/json",
//       //                       "Content-Type": "multipart/form-data",
//       //                     },
//       //                   }).then((response) => {
//       //                     Swal.fire({
//       //                       icon: "success",
//       //                       text: "Expense deleted successfully",
//       //                     }).then((data) => {
//       //                       const expense = response.data.data?.expense?.filter(
//       //                         (list) => {
//       //                           const modifyAmount =
//       //                             Number(list.amount)?.toFixed(1) -
//       //                             Number(list.tbal)?.toFixed(1);
//       //                           return modifyAmount >= 1;
//       //                         }
//       //                       );
//       //                       setDatas(expense);
//       //                       setAllData(response?.data?.data);
//       //                     });
//       //                     setLoading(false);
//       //                   });
//       //                 } catch (err) {
//       //                   Swal.fire({
//       //                     icon: "error",
//       //                     text: "Something went wrong",
//       //                   });
//       //                   setLoading(false);
//       //                 }
//       //               }
//       //             });
//       //           } else {
//       //             setAccessDenied(true);
//       //           }
//       //         });
//       //       } catch (error) {
//       //         console.log(error);
//       //       }
//       //     };
//       //     const handleView = (viewData) => {
//       //       const payment_method = paymentsOption?.find(
//       //         (obj) => obj.value == viewData.payment_method
//       //       );
//       //       const category_name = Categories?.find(
//       //         (obj) => obj.value == viewData.category_id
//       //       );
//       //       const currency = Currency?.find(
//       //         (obj) => obj.value == cellProps.row.original.currency
//       //       );
//       //       const recurrenceOp = recurringOptions?.find(
//       //         (obj) => obj.value == cellProps.row.original.recurrence_period
//       //       );
//       //       const modifyArr = {
//       //         date: viewData.date,
//       //         location: location?.find(
//       //           (obj) => obj.value == cellProps.row.original.location
//       //         ),
//       //         amount: cellProps.row.original.amount,
//       //         paymentMethod: payment_method,
//       //         categoryName: category_name,
//       //         currency: currency,
//       //         title: cellProps.row.original.title,
//       //         gst: cellProps.row.original.gst ? cellProps.row.original.gst : "",
//       //         currency_rate: cellProps.row.original.currency_rate,
//       //       };
//       //       setViewBudgetData(modifyArr);
//       //       setViewRecurring(cellProps.row.original.recurrence);
//       //       setViewRecurringPeriod(recurrenceOp);
//       //       setViewRecurringEndDate(cellProps.row.original.recurrence_date);
//       //       setViewExpense(true);
//       //     };
//       //     const handleSubmitEdit = async (viewData) => {
//       //       console.log(viewData);
//       //       setLoading(true);
//       //       const formData = new FormData();
//       //       formData.append("user_id", localStorage.getItem("auth_id"));
//       //       formData.append("module_id", 41);
//       //       try {
//       //         await axios({
//       //           method: "post",
//       //           url: `${configure.apiUrl}/earth_permission`,
//       //           data: formData,
//       //           headers: {
//       //             Accept: "application/json",
//       //             "Content-Type": "multipart/form-data",
//       //           },
//       //         }).then((res) => {
//       //           setLoading(false);
//       //           if (res.data.data.india[4] == 1 || res.data.data.uk[4] == 1) {
//       //             const locationFind = location?.find(
//       //               (obj) => obj.value == viewData.location
//       //             );
//       //             const paymentmethod = paymentsOption?.find(
//       //               (obj) => obj.value == viewData.payment_method
//       //             );
//       //             const categoryname = Categories?.find(
//       //               (obj) => obj.value == viewData.category_id
//       //             );
//       //             const currencyEdit = Currency?.find(
//       //               (obj) => obj.value == cellProps.row.original.currency
//       //             );
//       //             const recurrenceOp = recurringOptions?.find(
//       //               (obj) =>
//       //                 obj.value == cellProps.row.original.recurrence_period
//       //             );
//       //             setEditId(cellProps.row.original.id);
//       //             setUpdatedDate(viewData.date);
//       //             setIntroducer(viewData?.introducer_id != 0 ? 1 : 0);
//       //             console.log("introducer Added? : ", introducer);
//       //             console.log(introducerOptions);
//       //             setIntroducerValue(
//       //               introducerOptions?.find(
//       //                 (obj) => obj?.value == viewData?.introducer_id
//       //               )
//       //             );
//       //             setRecordPayment(viewData?.recordPayment);
//       //             setUpdatedLocation(locationFind);
//       //             setUpdatedPayemntVia(paymentmethod);
//       //             setUpdatedCategory(categoryname);
//       //             setUpdatedTitle(cellProps.row.original.title);
//       //             setUpdatedAmount(cellProps.row.original.amount);
//       //             setUpdatedGst(
//       //               cellProps.row.original.gst ? cellProps.row.original.gst : ""
//       //             );
//       //             setUpdatedCurrency(currencyEdit);
//       //             setupdateRecurring(cellProps.row.original.recurrence);
//       //             setUpdateRecurringPeriod(recurrenceOp);
//       //             setUpdateRecurringEndDate(
//       //               cellProps.row.original.recurrence_date
//       //             );

//       //             setEditExpense(true);
//       //           } else {
//       //             setAccessDenied(true);
//       //           }
//       //         });
//       //       } catch (error) {
//       //         setLoading(false);
//       //         console.log(error);
//       //       }
//       //     };
//       //     const handlePaymentHistory = async () => {
//       //       setLoading(true);
//       //       try {
//       //         const response = await axios({
//       //           method: "get",
//       //           url: `${configure.apiUrl}/viewPaidexpense/${cellProps.row.original.id}`,
//       //           headers: {
//       //             Accept: "application/json",
//       //             "Content-Type": "multipart/form-data",
//       //           },
//       //         });
//       //         if (response) {
//       //           setPaymentHistoryData(response.data.data);
//       //           setPaymentHistory(true);
//       //           setEditId(cellProps.row.original.id);
//       //           setLoading(false);
//       //         }
//       //       } catch (err) {
//       //         console.log(err);
//       //         setLoading(false);
//       //       }
//       //     };
//       //     const handlePayAddPayment = async (data) => {
//       //       console.log("========== handlePayAddPayment triggered ==========");
//       //       console.log("Incoming payment row data: ", data);
//       //       console.log("payments array: ", payments);
//       //       console.log("paymentsOption array: ", paymentsOption);

//       //       setLoading(true);
//       //       const formData = new FormData();
//       //       formData.append("user_id", localStorage.getItem("auth_id"));
//       //       formData.append("module_id", 41);
//       //       try {
//       //         await axios({
//       //           method: "post",
//       //           url: `${configure.apiUrl}/earth_permission`,
//       //           data: formData,
//       //           headers: {
//       //             Accept: "application/json",
//       //             "Content-Type": "multipart/form-data",
//       //           },
//       //         }).then((res) => {
//       //           setLoading(false);
//       //           if (res.data.data.india[3] == 1 || res.data.data.uk[3] == 1) {
//       //             setPaymentId(cellProps.row.original.id);
//       //             setLeftAmount(
//       //               cellProps.row.original.amount - cellProps.row.original.tbal
//       //             );

//       //             // correct mapping

//       //             const paymentViaOption = paymentsOption?.find((obj) => 
//       //               obj.value == data?.payment_method
//       //             );
//       //             console.log("Resolved paymentViaOption: ", paymentViaOption);

//       //             setPayPaymentVia(paymentViaOption);
//       //             console.log("Set PayPaymentVia done");

//       //             const selectedModeObj = payments.find(
//       //               (obj) => obj.value == data?.payment_method
//       //             );
//       //             console.log(
//       //               "Resolved selected PaymentMode: ",
//       //               selectedModeObj
//       //             );

//       //             console.log(
//       //               "filtering based on data.payment_via => ",
//       //               data?.payment_via
//       //             );
//       //             const findOption = payments?.filter((item) => {
//       //               console.log(
//       //                 "compare -> item.payment_via:",
//       //                 item.payment_via,
//       //                 "==",
//       //                 data?.payment_via
//       //               );
//       //               return item.payment_via == paymentViaOption?.value;
//       //             });
//       //             console.log("Result of findOption: ", findOption);

//       //             setPayPaymentMode(selectedModeObj);
//       //             console.log("Set PayPaymentMode done");

//       //             setPaymentModeOption(findOption);
//       //             console.log("Set PaymentModeOption done => ", findOption);

//       //             setBalanceAmount(
//       //               parseFloat(
//       //                 Number(cellProps.row.original.amount)?.toFixed(1)
//       //               ) -
//       //                 parseFloat(
//       //                   Number(cellProps.row.original.tbal)?.toFixed(1)
//       //                 )
//       //             );

//       //             setPayPaymentAmount(
//       //               parseFloat(
//       //                 Number(cellProps.row.original.amount)?.toFixed(1)
//       //               ) -
//       //                 parseFloat(
//       //                   Number(cellProps.row.original.tbal)?.toFixed(1)
//       //                 )
//       //             );

//       //             setPaymentMode(true);
//       //           } else {
//       //             setAccessDenied(true);
//       //           }
//       //         });
//       //       } catch (error) {
//       //         setLoading(false);
//       //         console.log("handlePayAddPayment Error: ", error);
//       //       }
//       //     };

//       //     return (
//       //       <div className="d-flex justify-content-center">
//       //         <button
//       //           onClick={() => {
//       //             handleView(cellProps.row.original);
//       //           }}
//       //           className="btn btn-sm me-1 btn-outline-secondary"
//       //         >
//       //           <i className="fas fa-eye"></i>
//       //         </button>
//       //         <button
//       //           onClick={() => {
//       //             handleSubmitEdit(cellProps.row.original);
//       //           }}
//       //           className="btn btn-sm me-1 btn-outline-secondary"
//       //         >
//       //           <i className="fa fa-pencil-alt"></i>
//       //         </button>
//       //         <button
//       //           onClick={() => {
//       //             handlePaymentHistory();
//       //           }}
//       //           className="btn btn-sm me-1 btn-outline-secondary"
//       //           title="Payment History"
//       //         >
//       //           <i className="bi bi-credit-card-2-front-fill"></i>
//       //         </button>

//       //         <UncontrolledDropdown
//       //           className="dropdown"
//       //           style={{ width: "29px" }}
//       //         >
//       //           <DropdownToggle
//       //             className="btn btn-sm btn-outline-secondary w-100"
//       //             color="white"
//       //           >
//       //             <i className="mdi mdi-dots-horizontal"></i>
//       //           </DropdownToggle>
//       //           <DropdownMenu className="dropdown-menu-end">
//       //             {cellProps.row.original.amount -
//       //               cellProps.row.original.tbal <=
//       //             0 ? (
//       //               ""
//       //             ) : (
//       //               <Link
//       //                 onClick={() => {
//       //                   console.log("AllData: ", cellProps.row.original);
//       //                   setPaymentCurrency(
//       //                     Currency.find(
//       //                       (obj) =>
//       //                         obj.value == cellProps.row.original.currency
//       //                     )
//       //                   );

//       //                   handlePayAddPayment(cellProps.row.original);
//       //                 }}
//       //                 title="Payment Mode"
//       //                 className="dropdown-item"
//       //               >
//       //                 <i className="bi bi-currency-dollar pr-10 fill-green"></i>{" "}
//       //                 Paid
//       //               </Link>
//       //             )}

//       //             <a
//       //               onClick={() => isDelete()}
//       //               className="dropdown-item"
//       //               title="delete"
//       //             >
//       //               <i className="fas fa-trash-alt pr-10 text-danger"></i>{" "}
//       //               Delete Expense
//       //             </a>
//       //           </DropdownMenu>
//       //         </UncontrolledDropdown>
//       //       </div>
//       //     );
//       //   },
//       // },
//       {
//         Header: "Action",
//         accessor: "action",
//         classNames: "text-center exp-9",
//         Cell: (cellProps) => {
//           const isDelete = async () => {
//             setLoading(true);
//             const formData = new FormData();
//             formData.append("user_id", localStorage.getItem("auth_id"));
//             formData.append("module_id", 41);
//             try {
//               await axios({
//                 method: "post",
//                 url: `${configure.apiUrl}/earth_permission`,
//                 data: formData,
//                 headers: {
//                   Accept: "application/json",
//                   "Content-Type": "multipart/form-data",
//                 },
//               }).then((res) => {
//                 setLoading(false);
//                 if (res.data.data.india[5] == 1 || res.data.data.uk[5] == 1) {
//                   Swal.fire({
//                     title: "Are you sure?",
//                     text: "You want to delete this expense !",
//                     icon: "warning",
//                     buttons: true,
//                     showCancelButton: true,
//                   }).then(async (willDelete) => {
//                     if (willDelete.isConfirmed) {
//                       setLoading(true);
//                       try {
//                         const response = await axios({
//                           method: "get",
//                           url: `${configure.apiUrl}/deleteBudgetExpense/${cellProps.row.original.id}/2`,
//                           headers: {
//                             Accept: "application/json",
//                             "Content-Type": "multipart/form-data",
//                           },
//                         }).then((response) => {
//                           Swal.fire({
//                             icon: "success",
//                             text: "Expense deleted successfully",
//                           }).then((data) => {
//                             const expense = response.data.data?.expense?.filter(
//                               (list) => {
//                                 const modifyAmount =
//                                   Number(list.amount)?.toFixed(1) -
//                                   Number(list.tbal)?.toFixed(1);
//                                 return modifyAmount >= 1;
//                               }
//                             );
//                             setDatas(expense);
//                             setAllData(response?.data?.data);
//                           });
//                           setLoading(false);
//                         });
//                       } catch (err) {
//                         Swal.fire({
//                           icon: "error",
//                           text: "Something went wrong",
//                         });
//                         setLoading(false);
//                       }
//                     }
//                   });
//                 } else {
//                   setAccessDenied(true);
//                 }
//               });
//             } catch (error) {
//               console.log(error);
//             }
//           };
//           const handleView = (viewData) => {
//             const payment_method = paymentsOption?.find(
//               (obj) => obj.value == viewData.payment_method
//             );
//             const category_name = Categories?.find(
//               (obj) => obj.value == viewData.category_id
//             );
//             const currency = Currency?.find(
//               (obj) => obj.value == cellProps.row.original.currency
//             );
//             const recurrenceOp = recurringOptions?.find(
//               (obj) => obj.value == cellProps.row.original.recurrence_period
//             );
//             const modifyArr = {
//               date: viewData.date,
//               location: location?.find(
//                 (obj) => obj.value == cellProps.row.original.location
//               ),
//               amount: cellProps.row.original.amount,
//               paymentMethod: payment_method,
//               categoryName: category_name,
//               currency: currency,
//               title: cellProps.row.original.title,
//               gst: cellProps.row.original.gst ? cellProps.row.original.gst : "",
//               currency_rate: cellProps.row.original.currency_rate,
//               link: cellProps?.row?.original?.link || null,
//             };
//             setViewBudgetData(modifyArr);
//             setViewRecurring(cellProps.row.original.recurrence);
//             setViewRecurringPeriod(recurrenceOp);
//             setViewRecurringEndDate(cellProps.row.original.recurrence_date);
//             setViewExpense(true);
//           };
//           const handleSubmitEdit = async (viewData) => {
//             console.log(viewData);
//             setLoading(true);
//             const formData = new FormData();
//             formData.append("user_id", localStorage.getItem("auth_id"));
//             formData.append("module_id", 41);
//             try {
//               await axios({
//                 method: "post",
//                 url: `${configure.apiUrl}/earth_permission`,
//                 data: formData,
//                 headers: {
//                   Accept: "application/json",
//                   "Content-Type": "multipart/form-data",
//                 },
//               }).then((res) => {
//                 setLoading(false);
//                 if (res.data.data.india[4] == 1 || res.data.data.uk[4] == 1) {
//                   const locationFind = location?.find(
//                     (obj) => obj.value == viewData.location
//                   );
//                   const paymentmethod = paymentsOption?.find(
//                     (obj) => obj.value == viewData.payment_method
//                   );
//                   const categoryname = Categories?.find(
//                     (obj) => obj.value == viewData.category_id
//                   );
//                   const currencyEdit = Currency?.find(
//                     (obj) => obj.value == cellProps.row.original.currency
//                   );
//                   const recurrenceOp = recurringOptions?.find(
//                     (obj) =>
//                       obj.value == cellProps.row.original.recurrence_period
//                   );
//                   // console.log("viewData", viewData)
//                   setEditId(cellProps.row.original.id);
//                   setUpdatedDate(viewData.date);
//                   setIntroducer(viewData?.introducer_id != 0 ? 1 : 0);
//                   setIntroducerValue(
//                     introducerOptions?.find(
//                       (obj) => obj?.value == viewData?.introducer_id
//                     )
//                   );
//                   setRecordPayment(viewData?.recordPayment);
//                   setUpdatedLocation(locationFind);
//                   setUpdatedPayemntVia(paymentmethod);
//                   setUpdatedCategory(categoryname);
//                   setUpdatedTitle(cellProps.row.original.title);
//                   setUpdatedAmount(cellProps.row.original.amount);
//                   setUpdatedGst(
//                     cellProps.row.original.gst ? cellProps.row.original.gst : ""
//                   );
//                   setUpdatedCurrency(currencyEdit);
//                   setupdateRecurring(cellProps.row.original.recurrence);
//                   setUpdateRecurringPeriod(recurrenceOp);
//                   setUpdateRecurringEndDate(
//                     cellProps.row.original.recurrence_date
//                   );

//                   setEditExpense(true);
//                 } else {
//                   setAccessDenied(true);
//                 }
//               });
//             } catch (error) {
//               setLoading(false);
//               console.log(error);
//             }
//           };
//           const handlePaymentHistory = async () => {
//             setLoading(true);
//             try {
//               const response = await axios({
//                 method: "get",
//                 url: `${configure.apiUrl}/viewPaidexpense/${cellProps.row.original.id}`,
//                 headers: {
//                   Accept: "application/json",
//                   "Content-Type": "multipart/form-data",
//                 },
//               });
//               if (response) {
//                 setPaymentHistoryData(response.data.data);
//                 setPaymentHistory(true);
//                 setEditId(cellProps.row.original.id);
//                 setLoading(false);
//               }
//             } catch (err) {
//               console.log(err);
//               setLoading(false);
//             }
//           };
//           const handlePayAddPayment = async (data) => {
//             console.log("========== handlePayAddPayment triggered ==========");
//             console.log("Incoming payment row data: ", data);
//             console.log("payments array: ", payments);
//             console.log("paymentsOption array: ", paymentsOption);

//             setLoading(true);
//             const formData = new FormData();
//             formData.append("user_id", localStorage.getItem("auth_id"));
//             formData.append("module_id", 41);
//             try {
//               await axios({
//                 method: "post",
//                 url: `${configure.apiUrl}/earth_permission`,
//                 data: formData,
//                 headers: {
//                   Accept: "application/json",
//                   "Content-Type": "multipart/form-data",
//                 },
//               }).then((res) => {
//                 setLoading(false);
//                 if (res.data.data.india[3] == 1 || res.data.data.uk[3] == 1) {
//                   setPaymentId(cellProps.row.original.id);
//                   setLeftAmount(
//                     cellProps.row.original.amount - cellProps.row.original.tbal
//                   );

//                   // correct mapping

//                   const paymentViaOption = paymentsOption?.find(
//                     (obj) => obj.value == data?.payment_method
//                   );
//                   console.log("Resolved paymentViaOption: ", paymentViaOption);

//                   setPayPaymentVia(paymentViaOption);
//                   console.log("Set PayPaymentVia done");

//                   const selectedModeObj = payments.find(
//                     (obj) => obj.value == data?.payment_method
//                   );
//                   console.log(
//                     "Resolved selected PaymentMode: ",
//                     selectedModeObj
//                   );

//                   console.log(
//                     "filtering based on data.payment_via => ",
//                     data?.payment_via
//                   );
//                   const findOption = payments?.filter((item) => {
//                     console.log(
//                       "compare -> item.payment_via:",
//                       item.payment_via,
//                       "==",
//                       data?.payment_via
//                     );
//                     return item.payment_via == paymentViaOption?.value;
//                   });
//                   console.log("Result of findOption: ", findOption);

//                   setPayPaymentMode(selectedModeObj);
//                   console.log("Set PayPaymentMode done");

//                   setPaymentModeOption(findOption);
//                   console.log("Set PaymentModeOption done => ", findOption);

//                   setBalanceAmount(
//                     parseFloat(
//                       Number(cellProps.row.original.amount)?.toFixed(1)
//                     ) -
//                     parseFloat(
//                       Number(cellProps.row.original.tbal)?.toFixed(1)
//                     )
//                   );

//                   setPayPaymentAmount(
//                     parseFloat(
//                       Number(cellProps.row.original.amount)?.toFixed(1)
//                     ) -
//                     parseFloat(
//                       Number(cellProps.row.original.tbal)?.toFixed(1)
//                     )
//                   );

//                   setPaymentMode(true);
//                 } else {
//                   setAccessDenied(true);
//                 }
//               });
//             } catch (error) {
//               setLoading(false);
//               console.log("handlePayAddPayment Error: ", error);
//             }
//           };

//           return (
//             <div className="d-flex justify-content-center">
//               <button
//                 onClick={() => {
//                   handleView(cellProps.row.original);
//                 }}
//                 className="btn btn-sm me-1 btn-outline-secondary"
//               >
//                 <i className="fas fa-eye"></i>
//               </button>
//               <button
//                 onClick={() => {
//                   handleSubmitEdit(cellProps.row.original);
//                 }}
//                 className="btn btn-sm me-1 btn-outline-secondary"
//               >
//                 <i className="fa fa-pencil-alt"></i>
//               </button>
//               {/* <button
//                 onClick={() => {
//                   handlePaymentHistory();
//                 }}
//                 className="btn btn-sm me-1 btn-outline-secondary"
//                 title="Payment History"
//               >
//                 <i className="bi bi-credit-card-2-front-fill"></i>
//               </button> */}
//               {cellProps.row.original.amount -
//                 cellProps.row.original.tbal <=
//                 0 ? (
//                 ""
//               ) : (
//                 <button
//                   onClick={() => {
//                     console.log("AllData: ", cellProps.row.original);
//                     setPaymentCurrency(
//                       Currency.find(
//                         (obj) =>
//                           obj.value == cellProps.row.original.currency
//                       )
//                     );

//                     handlePayAddPayment(cellProps.row.original);
//                   }}
//                   title="Payment Mode"
//                   className="btn btn-sm me-1 btn-outline-secondary"
//                 >
//                   <i className="bi bi-currency-dollar pr-10 fill-green"></i>
//                 </button>
//               )}

//               <UncontrolledDropdown
//                 className="dropdown"
//                 style={{ width: "29px" }}
//               >
//                 <DropdownToggle
//                   className="btn btn-sm btn-outline-secondary w-100"
//                   color="white"
//                 >
//                   <i className="mdi mdi-dots-horizontal"></i>
//                 </DropdownToggle>
//                 <DropdownMenu className="dropdown-menu-end">

//                   <Link
//                     onClick={() => {
//                       handlePaymentHistory();
//                     }}
//                     title="Payment Mode"
//                     className="dropdown-item"
//                   >
//                     <i className="bi bi-credit-card-2-front-fill pr-10 fill-green"></i>{" "}
//                     Payment History
//                   </Link>

//                   <a
//                     onClick={() => isDelete()}
//                     className="dropdown-item"
//                     title="delete"
//                   >
//                     <i className="fas fa-trash-alt pr-10 text-danger"></i>{" "}
//                     Delete Expense
//                   </a>
//                 </DropdownMenu>
//               </UncontrolledDropdown>
//             </div>
//           );
//         },
//       },
//     ],
//     [payments, Categories, Currency, isFilter]
//   );

//   const fetchOptions = async () => {
//     setLoading(true);
//     try {
//       const response = await axios({
//         method: "get",
//         url: `${configure.apiUrl}/expenseData`,
//         headers: {
//           Accept: "application/json",
//           "Content-Type": "multipart/form-data",
//         },
//       });
//       if (response) {
//         const modifyLocation = response?.data?.data?.location?.map((items) => {
//           return {
//             label: items.location,
//             value: items.id,
//           };
//         });
//         const modifyCategories = response?.data?.data?.expense_category?.map(
//           (items) => {
//             return {
//               label: items.categoryname,
//               value: items.id,
//             };
//           }
//         );
//         const modifyModes = response?.data?.data?.modes?.map((items) => {
//           const labelD =
//             items.payment_via == 1
//               ? "Bank Account"
//               : items.payment_via == 2
//                 ? "Credit Card"
//                 : items.payment_via == 3
//                   ? "Others"
//                   : "";
//           return {
//             label: items.payment_mode,
//             value: items.id,
//             payment_via: items.payment_via,
//           };
//         });
//         const modifyCurrency = response?.data?.data?.currency?.map((items) => {
//           return {
//             label: items.currency,
//             value: items.id,
//           };
//         });

//         setCurrency(modifyCurrency);
//         setPayments(modifyModes);
//         console.log("modifyModes: ", modifyModes);
//         console.log("Payment Options: ", payments);
//         setLocation(modifyLocation);
//         setCategories(modifyCategories);
//       }
//     } catch (err) {
//       console.log(err);
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchOptions();
//   }, []);

//   const handleEditSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     const formData = new FormData();
//     formData.append("type", 2);
//     formData.append("date", updatedDate);
//     formData.append("location", updatedLocation?.value);
//     formData.append("payment_via", updatedPayemntVia?.value);
//     formData.append("category", updatedCategory?.value);
//     formData.append("title", updatedTitle);
//     formData.append("amount", updatedAmount);
//     formData.append("gst", updatedGst);
//     if (expenseFileUpload.current.files[0]) {
//       formData.append("file", expenseFileUpload.current.files[0])
//     }
//     formData.append("currency", updatedCurrency?.value);
//     formData.append("expense_id", editId);
//     if (isConvertedAmount) {
//       formData.append("currency_rate", convertInrAmount ? convertInrAmount : 1);
//     } else {
//       formData.append("currency_rate", 1);
//     }
//     if (updateRecurring == 1) {
//       formData.append("recurrence", updateRecurring);
//       formData.append("recurrence_period", updateRecurringPeriod?.value);
//       formData.append("recurrence_date", updateRecurringEndDate);
//     } else {
//       formData.append("recurrence", 0);
//       formData.append("recurrence_period", "");
//       formData.append("recurrence_date", "");
//     }
//     formData.append("introducer_id", introducerValue?.value || null);
//     formData.append("recordPayment", recordPayment || 0);
//     try {
//       const resp = await axios({
//         method: "put",
//         url: `${configure.nodeApi}/addBudgetExpense`,
//         data: formData,
//         headers: {
//           Accept: "application/json",
//           "Content-Type": "multipart/form-data",
//         },
//       });
//       if (resp) {
//         setLoading(false);
//         Swal.fire({
//           icon: "success",
//           text: "Expense edited successfully",
//         }).then(() => {
//           fetchData();
//           expenseFileUpload.current = null
//           setEditExpense(false);
//         });
//       }
//     } catch (error) {
//       setLoading(false);
//       console.log(error);
//     }
//   };

//   const handleAddPayment = async (e) => {
//     e.preventDefault();
//     setLoading(true);

//     const formData = new FormData();
//     formData.append("expense_id", paymentId);
//     formData.append("type", 2);
//     formData.append("date", paymentDate);
//     formData.append("payment_via", payPaymentMode?.value);
//     formData.append("payment_mode", payPaymentVia?.value);
//     formData.append("amount", payPaymentAmount);
//     formData.append("currency", payPaymentCurrency?.value);
//     formData.append("file", payPaymentFile);
//     if (isConvertedAmountPay) {
//       formData.append(
//         "currency_rate",
//         convertInrAmountPay ? convertInrAmountPay : 1
//       );
//     } else {
//       formData.append("currency_rate", 1);
//     }
//     try {
//       const resp = await axios({
//         method: "post",
//         url: `${configure.apiUrl}/paidExpense`,
//         data: formData,
//         headers: {
//           Accept: "application/json",
//           "Content-Type": "multipart/form-data",
//         },
//       });
//       if (resp) {
//         setLoading(false);
//         Swal.fire({
//           icon: "success",
//           text: "Payment added successfully",
//         }).then(() => {
//           setPaymentId("");
//           setPaymentDate("");
//           setPayPaymentMode(null);
//           setPayPaymentAmount("");
//           setPayPaymentCurrency(null);
//           setPayPaymentFile("");
//           const expense = resp.data.data?.expense?.filter((list) => {
//             const modifyAmount =
//               Number(list.amount)?.toFixed(1) - Number(list.tbal)?.toFixed(1);
//             return modifyAmount >= 1;
//           });
//           setDatas(expense);
//           setAllData(resp.data.data);
//           setPaymentMode(false);
//         });
//       }
//     } catch (error) {
//       setLoading(false);
//       console.log(error);
//     }
//   };

//   const handleEditPayment = async (e) => {
//     e.preventDefault();
//     setLoading(true);

//     const formData = new FormData();
//     formData.append("expense_id", editId);
//     formData.append("user_id", localStorage.getItem("auth_id"));
//     formData.append("date", paymentDate);
//     formData.append("payment_via", payPaymentMode?.value);
//     formData.append("payment_mode", payPaymentVia?.value);
//     formData.append("amount", payPaymentAmount);
//     formData.append("file", payPaymentFile);
//     formData.append(
//       "currency_rate",
//       isConvertedAmountPay && convertInrAmountPay ? convertInrAmountPay : 1
//     );

//     try {
//       const resp = await axios({
//         method: "put",
//         url: `${configure.nodeApi}/paidExpense/${paymentId}`,
//         data: formData,
//         headers: {
//           Accept: "application/json",
//           "Content-Type": "multipart/form-data",
//         },
//       });
//       if (resp) {
//         Swal.fire({
//           icon: "success",
//           text: "Payment updated successfully",
//         });
//         setPaymentHistoryData(resp.data?.data);
//         setPaymentHistory(true);
//         setLoading(false);
//       } else {
//         swal.fire({
//           icon: "error",
//           text: "Payment not updated",
//         });
//         setDatas([]);
//       }
//     } catch (error) {
//       console.error("Update failed:", error.response?.data || error.message);
//     }

//     setLoading(false);
//     setEditPaymentMode(false);
//     setPaymentId("");
//     setPaymentDate("");
//     setPayPaymentMode(null);
//     setPayPaymentAmount("");
//     setPayPaymentCurrency(null);
//     setPayPaymentFile("");
//     setIsConvertedAmountPay(false);
//   };

//   // Edit form currency conversion
//   useEffect(() => {
//     if (updatedDate && updatedCurrency && updatedAmount) {
//       if (updatedCurrency.label !== "INR") {
//         const fetchCurrencyRate = async () => {
//           setLoading(true);
//           try {
//             const response = await axios.get(
//               `https://api.apilayer.com/fixer/${updatedDate}?symbols=INR&base=${updatedCurrency.label}`,
//               {
//                 headers: {
//                   apikey: configure.exchangeKey,
//                 },
//               }
//             );
//             if (response) {
//               setLoading(false);
//               const rate = response.data.rates.INR;
//               const formattedRate = rate.toFixed(2);
//               setConvertInrAmount(formattedRate);
//             } else {
//               setLoading(false);
//             }
//           } catch (error) {
//             setLoading(false);
//             Swal.fire({
//               icon: "warning",
//               text:
//                 error.response?.data?.message || "Error fetching currency rate",
//             });
//             console.error("Error fetching currency rate:", error);
//           }
//         };
//         fetchCurrencyRate();
//         setIsConvertedAmount(true);
//       } else {
//         setIsConvertedAmount(false);
//       }
//     }
//   }, [updatedDate, updatedCurrency, updatedAmount]);

//   // Add/Edit Payment currency conversion
//   useEffect(() => {
//     if (paymentDate && payPaymentCurrency && payPaymentAmount) {
//       if (payPaymentCurrency.label !== "INR") {
//         const fetchCurrencyRate = async () => {
//           setLoading(true);
//           try {
//             const response = await axios.get(
//               `https://api.apilayer.com/fixer/${paymentDate}?symbols=INR&base=${payPaymentCurrency.label}`,
//               {
//                 headers: {
//                   apikey: configure.exchangeKey,
//                 },
//               }
//             );
//             if (response) {
//               setLoading(false);
//               const rate = response.data.rates.INR;
//               const formattedRate = rate.toFixed(2);
//               setConvertInrAmountPay(formattedRate);
//             } else {
//               setLoading(false);
//             }
//           } catch (error) {
//             setLoading(false);
//             Swal.fire({
//               icon: "warning",
//               text:
//                 error.response?.data?.message || "Error fetching currency rate",
//             });
//             console.error("Error fetching currency rate:", error);
//           }
//         };
//         fetchCurrencyRate();
//         setIsConvertedAmountPay(true);
//       } else {
//         setIsConvertedAmountPay(false);
//       }
//     }
//   }, [paymentDate, payPaymentCurrency, payPaymentAmount]);

//   const handlePayAmount = (value) => {
//     const numericValue = value;
//     if (numericValue > leftAmount) {
//       Swal.fire({
//         icon: "warning",
//         text: `You can only pay up to ${leftAmount}.`,
//       });
//     } else {
//       setPayPaymentAmount(numericValue);
//     }
//   };

//   const onReloadApi = (load) => {
//     if (load) {
//       fetchData();
//     }
//   };

//   const [payPaymentVia, setPayPaymentVia] = useState(null);

//   return (
//     <React.Fragment>
//       {isLoading && <Loader />}
//       <div className="page-content" id="expense">
//         <Container fluid>
//           <Breadcrumbs title={"Dashboard"} breadcrumbItem={"Expense"} />

//           <Row>
//             <Col lg={12} className="p-0">
//               <Card>
//                 <CardBody>
//                   <div className="responsive-table">
//                     <TableContainer
//                       columns={columns}
//                       data={data}
//                       setAccessDenied={setAccessDenied}
//                       setLoading={setLoading}
//                       location={location}
//                       Categories={Categories}
//                       payments={payments}
//                       Currency={Currency}
//                       setDatas={setDatas}
//                       allData={allData}
//                       setAllData={setAllData}
//                       fetchData={fetchData}
//                       paymentsOption={paymentsOption}
//                       setIsfilter={setIsfilter}
//                       introducerOptions={introducerOptions}
//                       onReloadApi={onReloadApi}
//                     />
//                   </div>
//                 </CardBody>
//               </Card>
//             </Col>
//           </Row>
//         </Container>
//       </div>

//       {/* Edit Expense Modal */}
//       {/* <Modal isOpen={editExpense} size="xl" className="" centered>
//         <div className="modal-header pe-4">
//           <h5 className="modal-title mt-0">Edit Expense</h5>
//           <button
//             type="button"
//             onClick={() => {
//               setEditExpense(false);
//             }}
//             className="btn-modal-close"
//           >
//             <span aria-hidden="true" className="btn-modal-span">
//               ×
//             </span>
//           </button>
//         </div>

//         <div className="modal-body pe-4">
//           <Form
//             onSubmit={handleEditSubmit}
//             className="row d-flex justify-content-center align-items-center"
//           >
//             <div className="col-md-5 d-flex justify-content-end align-items-center ps-3">
//               <div className="text-center">
//                 <img src={editexpense} alt="Addepe" style={{ width: "90%" }} />
//               </div>
//             </div>

//             <div className="col-md-6 d-flex flex-column ">
//               <div className="col-md-12 d-flex mb-4 justify-content-start align-items-end">
//                 <div className="col-md-4  ps-2">
//                   <Label htmlFor="formrow-firstname-Input">
//                     Date <span className="text-danger">*</span>
//                   </Label>
//                   <div className="d-flex justify-content-start align-items-center gap-2">
//                     <Input
//                       required
//                       type="date"
//                       value={updatedDate}
//                       onChange={(e) => setUpdatedDate(e.target.value)}
//                       className="form-control"
//                     />
//                   </div>
//                 </div>
//                 <div className="col-md-4 ps-2">
//                   <Label htmlFor="formrow-firstname-Input">
//                     Location <span className="text-danger">*</span>
//                   </Label>
//                   <Select
//                     placeholder="Select Location"
//                     className="basic-multi-select"
//                     classNamePrefix=" select"
//                     styles={colourStyles}
//                     options={location}
//                     value={updatedLocation}
//                     onChange={(selectedOption) =>
//                       setUpdatedLocation(selectedOption)
//                     }
//                   />
//                 </div>
//                 <div className="col-md-4 ps-2">
//                   <Label htmlFor="formrow-firstname-Input">
//                     Currency <span className="text-danger">*</span>
//                   </Label>
//                   <Select
//                     placeholder="Select Currency"
//                     className="basic-multi-select"
//                     classNamePrefix=" select"
//                     options={Currency}
//                     styles={colourStyles}
//                     value={updatedCurrency}
//                     onChange={(selectedOption) =>
//                       setUpdatedCurrency(selectedOption)
//                     }
//                   />
//                 </div>
//               </div>
//               <div className="col-md-12 d-flex mb-4 justify-content-start align-items-end">
//                 <div className="col-md-6 ps-2">
//                   <Label htmlFor="formrow-firstname-Input">
//                     Payment Via <span className="text-danger">*</span>
//                   </Label>
//                   <Select
//                     placeholder="Payment Via"
//                     className="basic-multi-select"
//                     classNamePrefix=" select"
//                     styles={colourStyles}
//                     options={paymentsOption}
//                     value={updatedPayemntVia}
//                     onChange={(selectedOption) =>
//                       setUpdatedPayemntVia(selectedOption)
//                     }
//                   />
//                 </div>
//                 <div className="col-md-6 ps-2">
//                   <Label htmlFor="formrow-firstname-Input">
//                     Category <span className="text-danger">*</span>
//                   </Label>
//                   <Select
//                     placeholder="Payment Category"
//                     className="basic-multi-select"
//                     classNamePrefix=" select"
//                     styles={colourStyles}
//                     options={Categories}
//                     value={updatedCategory}
//                     onChange={(selectedOption) =>
//                       setUpdatedCategory(selectedOption)
//                     }
//                   />
//                 </div>
//               </div>
//               <div className="col-md-12 d-flex flex-column justify-content-start align-items-start">
//                 <div className="col-md-12 mb-4 ps-2 row">
//                   <div className="col-md-10">
//                     <Label htmlFor="formrow-firstname-Input">
//                       Title <span className="text-danger">*</span>
//                     </Label>

//                     <div className="d-flex justify-content-start align-items-center gap-2">
//                       <Input
//                         required
//                         type="text"
//                         className="form-control"
//                         placeholder="Enter Title"
//                         value={updatedTitle}
//                         onChange={(e) => setUpdatedTitle(e.target.value)}
//                       />
//                     </div>
//                   </div>
//                   <div className="col-md-2 mb-2">
//                     <Label htmlFor="formrow-firstname-Input">Recurring</Label>
//                     <div className="form-switch form-switch-md ">
//                       <input
//                         type="checkbox"
//                         className="form-check-input mt-2"
//                         id="customSwitchsizemd"
//                         defaultChecked={updateRecurring == 1 ? true : false}
//                         onChange={(e) =>
//                           setupdateRecurring(e.target.checked ? 1 : 0)
//                         }
//                       />
//                     </div>
//                   </div>
//                 </div>

//                 {updateRecurring == 1 && (
//                   <div className="col-md-12 d-flex ps-2 mb-4 justify-content-start align-items-end gap-2">
//                     <>
//                       {" "}
//                       <div className="col-md-4">
//                         <Label htmlFor="formrow-firstname-Input">
//                           Recurring Period{" "}
//                           <span className="text-danger">*</span>
//                         </Label>
//                         <Select
//                           placeholder="Select recurring"
//                           className="basic-multi-select"
//                           classNamePrefix=" select"
//                           styles={colourStyles}
//                           options={recurringOptions}
//                           value={updateRecurringPeriod}
//                           onChange={(selectedOption) => {
//                             Swal.fire({
//                               icon: "warning",
//                               title: "Are you sure ?",
//                               text: "You want to change the recurring period.",
//                               showCancelButton: true,
//                             }).then((willOkay) => {
//                               if (willOkay.isConfirmed) {
//                                 setUpdateRecurringPeriod(selectedOption);
//                               }
//                             });
//                           }}
//                         />
//                       </div>
//                       <div className="col-md-4">
//                         <Label htmlFor="formrow-firstname-Input">
//                           Recurring End Date{" "}
//                           <span className="text-danger">*</span>
//                         </Label>
//                         <Input
//                           type="date"
//                           className="form-control"
//                           placeholder="Enter Amount"
//                           value={updateRecurringEndDate}
//                           onChange={(e) =>
//                             setUpdateRecurringEndDate(e.target.value)
//                           }
//                         />
//                       </div>
//                     </>
//                   </div>
//                 )}

//                 <div className="col-md-12 mb-4 ps-2 d-flex gap-2">
//                   <div className="col-md-4">
//                     <Label htmlFor="formrow-firstname-Input">
//                       Amount <span className="text-danger">*</span>
//                     </Label>

//                     <div className="d-flex justify-content-start align-items-center gap-2">
//                       <Input
//                         required
//                         type="number"
//                         className="form-control"
//                         placeholder="Enter Amount"
//                         style={{ width: "100%" }}
//                         value={updatedAmount}
//                         onChange={(e) => setUpdatedAmount(e.target.value)}
//                       />
//                     </div>
//                   </div>
//                   <div className="col-md-4 ">
//                     <Label htmlFor="formrow-firstname-Input">GST</Label>

//                     <div className="d-flex justify-content-start align-items-center gap-2">
//                       <Input
//                         type="text"
//                         className="form-control"
//                         placeholder="Enter GST"
//                         style={{ width: "100%" }}
//                         value={updatedGst}
//                         onChange={(e) => setUpdatedGst(e.target.value)}
//                       />
//                     </div>
//                   </div>
//                   {isConvertedAmount && (
//                     <div className="col-md-4 ">
//                       <Label htmlFor="formrow-firstname-Input">
//                         Exchange Rate
//                       </Label>
//                       <div className="d-flex justify-content-start align-items-center gap-2">
//                         <Input
//                           type="text"
//                           className="form-control"
//                           readOnly
//                           style={{ width: "100%" }}
//                           value={convertInrAmount}
//                           onChange={(e) => setConvertInrAmount(e.target.value)}
//                         />
//                       </div>
//                     </div>
//                   )}
//                 </div>
//               </div>
//               <div className="col-md-12 mb-2 pt-3">
//                 <div className="d-flex align-items-center gap-3">

//                   <div>
//                     <Label htmlFor="introducerSwitch">Introducer</Label>
//                     <div className="form-switch form-switch-md">
//                       <input
//                         type="checkbox"
//                         className="form-check-input mt-2"
//                         id="introducerSwitch"
//                         defaultChecked={introducer == 1}
//                         onChange={(e) => {
//                           setIntroducer(e.target.checked ? 1 : 0);
//                         }}
//                       />
//                     </div>
//                   </div>

//                   {introducer == 1 && (
//                     <div className="d-flex align-items-center gap-3 flex-grow-1">

//                       <div className="flex-grow-1">
//                         <Label>Select Introducer</Label>
//                         <Select
//                           placeholder="Select Introducer"
//                           className="basic-multi-select"
//                           classNamePrefix="select"
//                           styles={colourStyles}
//                           options={introducerOptions}
//                           value={introducerValue}
//                           onChange={(selectedOption) =>
//                             setIntroducerValue(selectedOption)
//                           }
//                         />
//                       </div>


//                       <div>
//                         <Label htmlFor="recordPaymentSwitch">
//                           Charge Introducer
//                         </Label>
//                         <div className="form-switch form-switch-md">
//                           <input
//                             type="checkbox"
//                             className="form-check-input mt-2"
//                             id="recordPaymentSwitch"
//                             defaultChecked={recordPayment == 1}
//                             onChange={(e) => {
//                               setRecordPayment(e.target.checked ? 1 : 0);
//                               console.log(recordPayment);
//                             }}
//                           />
//                         </div>
//                       </div>
//                     </div>
//                   )}
//                 </div>
//               </div>

//               <div className="my-4 text-center">
//                 <button className=" btn btn-save btn-label">
//                   <i className="fas fa-save me-2 label-icon"></i>
//                   Save
//                 </button>
//                 <a
//                   onClick={() => setEditExpense(false)}
//                   className=" btn ms-md-2 btn-red btn-label"
//                 >
//                   <i className="dripicons-cross me-2 icon-center label-icon"></i>
//                   CANCEL
//                 </a>
//               </div>
//             </div>
//           </Form>
//         </div>
//       </Modal> */}


//       {/* Add/Edit Payment Mode Modal */}
//       {/* <Modal
//         isOpen={paymentMode || editPaymentMode}
//         size="xl"
//         className=""
//         centered
//       >
//         <div className="modal-header pe-4">
//           <h5 className="modal-title mt-0">
//             {editPaymentMode ? "Edit Payment" : "Add Payment"}
//           </h5>
//           <button
//             type="button"
//             onClick={() => {
//               setPaymentMode(false);
//               setEditPaymentMode(false);
//               setPaymentId("");
//               setPaymentDate("");
//               setPayPaymentMode(null);
//               setPayPaymentAmount("");
//               setPayPaymentCurrency(null);
//               setPayPaymentFile("");
//               setIsConvertedAmountPay(false);
//             }}
//             className="btn-modal-close"
//           >
//             <span aria-hidden="true" className="btn-modal-span">
//               ×
//             </span>
//           </button>
//         </div>

//         <div className="modal-body pe-4 my-4">
//           <Form
//             onSubmit={editPaymentMode ? handleEditPayment : handleAddPayment}
//             className="row d-flex justify-content-center align-items-center"
//           >
//             <div className="col-md-5 d-flex justify-content-end align-items-center ps-3">
//               <div className="text-center">
//                 <img src={addexpense} alt="Addepe" style={{ width: "90%" }} />
//               </div>
//             </div>

//             <div className="col-md-5 d-flex flex-column ">
//               <div className="col-md-12 d-flex mb-4 justify-content-start align-items-center gap-2">
//                 <div className="col-md-4">
//                   <label htmlFor="">
//                     Date <span className="text-danger">*</span>
//                   </label>
//                   <input
//                     type="date"
//                     required
//                     value={paymentDate}
//                     onChange={(e) => setPaymentDate(e.target.value)}
//                     className="form-control"
//                   />
//                 </div>
//                 <div className="col-md-5 ps-2">
//                   <Label htmlFor="formrow-firstname-Input">
//                     Payment Via <span className="text-danger">*</span>
//                   </Label>
//                   <Select
//                     placeholder="Payment Via"
//                     className="basic-multi-select"
//                     classNamePrefix=" select"
//                     styles={colourStyles}
//                     options={paymentsOption}
//                     value={payPaymentVia}
//                     onChange={(selectedOption) => {
//                       console.log("selected Option: ", selectedOption);
//                       setPayPaymentVia(selectedOption);
//                       console.log("payPaymentVia: ", payPaymentVia);
//                       const findOption =
//                         payments?.filter((item) => {
//                           return item.payment_via == selectedOption.value;
//                         }) || [];
//                       setPaymentModeOption(findOption);
//                       setPayPaymentMode(null); // Reset mode when via changes
//                     }}
//                     required
//                   />
//                 </div>
//                 <div className="col-md-5">
//                   <Label htmlFor="formrow-firstname-Input">
//                     Payment Mode <span className="text-danger">*</span>
//                   </Label>
//                   <Select
//                     required
//                     placeholder="Payment Mode"
//                     className="basic-multi-select"
//                     classNamePrefix=" select"
//                     styles={colourStyles}
//                     options={
//                       paymentModeOption && paymentModeOption.length
//                         ? paymentModeOption
//                         : payments
//                     }
//                     value={payPaymentMode}
//                     onChange={(selectedOption) =>
//                       setPayPaymentMode(selectedOption)
//                     }
//                   />
//                 </div>
//               </div>

//               <div className="col-md-12 d-flex mb-4 justify-content-start align-items-end gap-2">
//                 <div className="col-md-4">
//                   <Label htmlFor="formrow-firstname-Input">
//                     Amount <span className="text-danger">*</span>
//                   </Label>
//                   <Input
//                     required
//                     type="number"
//                     className="form-control"
//                     placeholder="Enter Amount"
//                     value={payPaymentAmount}
//                     onChange={(e) => {
//                       editPaymentMode
//                         ? setPayPaymentAmount(e.target.value)
//                         : handlePayAmount(e.target.value);
//                     }}
//                   />
//                 </div>
//                 {!editPaymentMode ? (
//                   <>
//                     <div className="col-md-4 ">
//                       <Label htmlFor="formrow-firstname-Input">
//                         Currency <span className="text-danger">*</span>
//                       </Label>
//                       <Select
//                         placeholder="Select Currency"
//                         className="basic-multi-select"
//                         classNamePrefix=" select"
//                         styles={colourStyles}
//                         required
//                         options={Currency}
//                         value={paymentCurrency || payPaymentCurrency}
//                         onChange={(selectedOption) =>
//                           setPayPaymentCurrency(selectedOption)
//                         }
//                       />
//                     </div>
//                     {isConvertedAmountPay && (
//                       <div className="col-md-4 ">
//                         <Label htmlFor="formrow-firstname-Input">
//                           Exchange Rate
//                         </Label>
//                         <div className="d-flex justify-content-start align-items-center gap-2">
//                           <Input
//                             type="text"
//                             className="form-control"
//                             readOnly
//                             style={{ width: "100%" }}
//                             value={convertInrAmountPay}
//                             onChange={(e) =>
//                               setConvertInrAmountPay(e.target.value)
//                             }
//                           />
//                         </div>
//                       </div>
//                     )}
//                   </>
//                 ) : null}
//               </div>

//               <div className="col-md-12 d-flex mb-4 justify-content-start align-items-end gap-2">
//                 <div className="col-md-9 ">
//                   <label htmlFor="">Upload File</label>
//                   <input
//                     type="file"
//                     className="form-control"
//                     onChange={(e) => setPayPaymentFile(e.target.files[0])}
//                   />
//                 </div>
//                 {editPaymentMode && existingFile ? (
//                   <img
//                     src={existingFile}
//                     width={39}
//                     height={39}
//                     className="object-fit-cover"
//                     alt="existing Image"
//                     title="existing Image"
//                   />
//                 ) : null}
//               </div>

//               <div className="my-3 text-center pe-5 col-md-10">
//                 <button className=" btn btn-save btn-label">
//                   <i className="fas fa-save me-2 label-icon"></i>
//                   Save
//                 </button>
//                 <a
//                   onClick={() => {
//                     setPaymentMode(false);
//                     setEditPaymentMode(false);
//                     setPaymentId("");
//                     setPaymentDate("");
//                     setPayPaymentMode(null);
//                     setPayPaymentAmount("");
//                     setPayPaymentCurrency(null);
//                     setPayPaymentFile("");
//                     setIsConvertedAmountPay(false);
//                   }}
//                   className=" btn ms-md-2 btn-red btn-label"
//                 >
//                   <i className="dripicons-cross me-2 icon-center label-icon"></i>
//                   CANCEL
//                 </a>
//               </div>
//             </div>
//           </Form>
//         </div>
//       </Modal> */}


//       {/* Edit Expense Modal */}
//       <Modal isOpen={editExpense} size="xl" className="" centered>
//         <div className="modal-header pe-4">
//           <h5 className="modal-title mt-0">Edit Expense</h5>
//           <button
//             type="button"
//             onClick={() => {
//               setEditExpense(false)
//             }}
//             className="btn-modal-close"
//           >
//             <span aria-hidden="true" className="btn-modal-span">
//               ×
//             </span>
//           </button>
//         </div>

//         <div className="modal-body pe-4">
//           <Form
//             onSubmit={handleEditSubmit}
//             className="row d-flex justify-content-center align-items-center"
//           >
//             <div className="col-md-5 d-flex justify-content-end align-items-center ps-3">
//               <div className="text-center">
//                 <img src={editexpense} alt="Addepe" style={{ width: "90%" }} />
//               </div>
//             </div>

//             <div className="col-md-6 d-flex flex-column ">
//               <div className="col-md-12 d-flex mb-4 justify-content-start align-items-end">
//                 <div className="col-md-4  ps-2">
//                   <Label htmlFor="formrow-firstname-Input">
//                     Date <span className="text-danger">*</span>
//                   </Label>
//                   <div className="d-flex justify-content-start align-items-center gap-2">
//                     <Input
//                       required
//                       type="date"
//                       value={updatedDate}
//                       onChange={e => setUpdatedDate(e.target.value)}
//                       className="form-control"
//                     />
//                   </div>
//                 </div>
//                 <div className="col-md-4 ps-2">
//                   <Label htmlFor="formrow-firstname-Input">
//                     Location <span className="text-danger">*</span>
//                   </Label>
//                   <Select
//                     placeholder="Select Location"
//                     className="basic-multi-select"
//                     classNamePrefix=" select"
//                     styles={colourStyles}
//                     options={location}
//                     value={updatedLocation}
//                     onChange={selectedOption =>
//                       setUpdatedLocation(selectedOption)
//                     }
//                   />
//                 </div>
//                 <div className="col-md-4 ps-2">
//                   <Label htmlFor="formrow-firstname-Input">
//                     Currency <span className="text-danger">*</span>
//                   </Label>
//                   <Select
//                     placeholder="Select Currency"
//                     className="basic-multi-select"
//                     classNamePrefix=" select"
//                     options={Currency}
//                     styles={colourStyles}
//                     value={updatedCurrency}
//                     onChange={selectedOption =>
//                       setUpdatedCurrency(selectedOption)
//                     }
//                   />
//                 </div>
//               </div>
//               <div className="col-md-12 d-flex mb-4 justify-content-start align-items-end">
//                 <div className="col-md-6 ps-2">
//                   <Label htmlFor="formrow-firstname-Input">
//                     Payment Via <span className="text-danger">*</span>
//                   </Label>
//                   <Select
//                     placeholder="Payment Via"
//                     className="basic-multi-select"
//                     classNamePrefix=" select"
//                     styles={colourStyles}
//                     options={paymentsOption}
//                     value={updatedPayemntVia}
//                     onChange={selectedOption =>
//                       setUpdatedPayemntVia(selectedOption)
//                     }
//                   />
//                 </div>
//                 <div className="col-md-6 ps-2">
//                   <Label htmlFor="formrow-firstname-Input">
//                     Category <span className="text-danger">*</span>
//                   </Label>
//                   <Select
//                     placeholder="Payment Category"
//                     className="basic-multi-select"
//                     classNamePrefix=" select"
//                     styles={colourStyles}
//                     options={Categories}
//                     value={updatedCategory}
//                     onChange={selectedOption =>
//                       setUpdatedCategory(selectedOption)
//                     }
//                   />
//                 </div>
//               </div>
//               <div className="col-md-12 d-flex flex-column justify-content-start align-items-start">
//                 <div className="col-md-12 mb-4 ps-2 row">
//                   <div className="col-md-10">
//                     <Label htmlFor="formrow-firstname-Input">
//                       Title <span className="text-danger">*</span>
//                     </Label>

//                     <div className="d-flex justify-content-start align-items-center gap-2">
//                       <Input
//                         required
//                         type="text"
//                         className="form-control"
//                         placeholder="Enter Title"
//                         value={updatedTitle}
//                         onChange={e => setUpdatedTitle(e.target.value)}
//                       />
//                     </div>
//                   </div>
//                   <div className="col-md-2 mb-2">
//                     <Label htmlFor="formrow-firstname-Input">Recurring</Label>
//                     <div className="form-switch form-switch-md ">
//                       <input
//                         type="checkbox"
//                         className="form-check-input mt-2"
//                         id="customSwitchsizemd"
//                         defaultChecked={updateRecurring == 1 ? true : false}
//                         onChange={e =>
//                           setupdateRecurring(e.target.checked ? 1 : 0)
//                         }
//                       />
//                     </div>
//                   </div>
//                 </div>

//                 {updateRecurring == 1 && (
//                   <div className="col-md-12 d-flex ps-2 mb-4 justify-content-start align-items-end gap-2">
//                     <>
//                       {" "}
//                       <div className="col-md-4">
//                         <Label htmlFor="formrow-firstname-Input">
//                           Recurring Period{" "}
//                           <span className="text-danger">*</span>
//                         </Label>
//                         <Select
//                           placeholder="Select recurring"
//                           className="basic-multi-select"
//                           classNamePrefix=" select"
//                           styles={colourStyles}
//                           options={recurringOptions}
//                           value={updateRecurringPeriod}
//                           onChange={selectedOption => {
//                             Swal.fire({
//                               icon: "warning",
//                               title: "Are you sure ?",
//                               text: "You want to change the recurring period.",
//                               showCancelButton: true,
//                             }).then(willOkay => {
//                               if (willOkay.isConfirmed) {
//                                 setUpdateRecurringPeriod(selectedOption)
//                               }
//                             })
//                           }}
//                         />
//                       </div>
//                       <div className="col-md-4">
//                         <Label htmlFor="formrow-firstname-Input">
//                           Recurring End Date{" "}
//                           <span className="text-danger">*</span>
//                         </Label>
//                         <Input
//                           type="date"
//                           className="form-control"
//                           placeholder="Enter Amount"
//                           value={updateRecurringEndDate}
//                           onChange={e =>
//                             setUpdateRecurringEndDate(e.target.value)
//                           }
//                         />
//                       </div>
//                     </>
//                   </div>
//                 )}

//                 <div className="col-md-12 mb-4 ps-2 d-flex gap-2">
//                   <div className="col-md-4">
//                     <Label htmlFor="formrow-firstname-Input">
//                       Amount <span className="text-danger">*</span>
//                     </Label>

//                     <div className="d-flex justify-content-start align-items-center gap-2">
//                       <Input
//                         required
//                         type="number"
//                         className="form-control"
//                         placeholder="Enter Amount"
//                         style={{ width: "100%" }}
//                         value={updatedAmount}
//                         onChange={e => setUpdatedAmount(e.target.value)}
//                       />
//                     </div>
//                   </div>
//                   <div className="col-md-4 ">
//                     <Label htmlFor="formrow-firstname-Input">GST</Label>

//                     <div className="d-flex justify-content-start align-items-center gap-2">
//                       <Input
//                         type="text"
//                         className="form-control"
//                         placeholder="Enter GST"
//                         style={{ width: "100%" }}
//                         value={updatedGst}
//                         onChange={e => setUpdatedGst(e.target.value)}
//                       />
//                     </div>
//                   </div>

//                   <div className="col-md-4 ">
//                     <Label>Upload File</Label>
//                     <input
//                       type="file"
//                       ref={expenseFileUpload}
//                       className="form-control"
//                     ></input>
//                   </div>

//                   {isConvertedAmount && (
//                     <div className="col-md-4 ">
//                       <Label htmlFor="formrow-firstname-Input">
//                         Exchange Rate
//                       </Label>
//                       <div className="d-flex justify-content-start align-items-center gap-2">
//                         <Input
//                           type="text"
//                           className="form-control"
//                           readOnly
//                           style={{ width: "100%" }}
//                           value={convertInrAmount}
//                           onChange={e => setConvertInrAmount(e.target.value)}
//                         />
//                       </div>
//                     </div>
//                   )}
//                 </div>
//               </div>
//               <div className="col-md-12 mb-2 pt-3">
//                 <div className="d-flex align-items-center gap-3">
//                   {/* Introducer Toggle */}
//                   <div>
//                     <Label htmlFor="introducerSwitch">Introducer</Label>
//                     <div className="form-switch form-switch-md">
//                       <input
//                         type="checkbox"
//                         className="form-check-input mt-2"
//                         id="introducerSwitch"
//                         defaultChecked={introducer == 1}
//                         onChange={e => {
//                           setIntroducer(e.target.checked ? 1 : 0)
//                         }}
//                       />
//                     </div>
//                   </div>

//                   {/* Show only when introducer == 1 */}
//                   {introducer == 1 && (
//                     <div className="d-flex align-items-center gap-3 flex-grow-1">
//                       {/* Select Introducer */}
//                       <div className="flex-grow-1">
//                         <Label>Select Introducer</Label>
//                         <Select
//                           placeholder="Select Introducer"
//                           className="basic-multi-select"
//                           classNamePrefix="select"
//                           styles={colourStyles}
//                           options={introducerOptions}
//                           value={introducerValue}
//                           onChange={selectedOption =>
//                             setIntroducerValue(selectedOption)
//                           }
//                         />
//                       </div>

//                       {/* Record Payment Toggle */}
//                       <div>
//                         <Label htmlFor="recordPaymentSwitch">
//                           Charge Introducer
//                         </Label>
//                         <div className="form-switch form-switch-md">
//                           <input
//                             type="checkbox"
//                             className="form-check-input mt-2"
//                             id="recordPaymentSwitch"
//                             defaultChecked={recordPayment == 1}
//                             onChange={e => {
//                               setRecordPayment(e.target.checked ? 1 : 0)
//                               console.log(recordPayment)
//                             }}
//                           />
//                         </div>
//                       </div>
//                     </div>
//                   )}
//                 </div>
//               </div>

//               <div className="my-4 text-center">
//                 <button className=" btn btn-save btn-label">
//                   <i className="fas fa-save me-2 label-icon"></i>
//                   Save
//                 </button>
//                 <a
//                   onClick={() => setEditExpense(false)}
//                   className=" btn ms-md-2 btn-red btn-label"
//                 >
//                   <i className="dripicons-cross me-2 icon-center label-icon"></i>
//                   CANCEL
//                 </a>
//               </div>
//             </div>
//           </Form>
//         </div>
//       </Modal>

//       {/* View Expense Modal */}
//       <Modal isOpen={viewExpense} size="xl" className="" centered>
//         <div className="modal-header pe-4">
//           <h5 className="modal-title mt-0">View Expense</h5>
//           <button
//             type="button"
//             onClick={() => {
//               setViewExpense(false)
//             }}
//             className="btn-modal-close"
//           >
//             <span aria-hidden="true" className="btn-modal-span">
//               ×
//             </span>
//           </button>
//         </div>

//         <div className="modal-body pe-4">
//           <Form className="row d-flex justify-content-center align-items-center">
//             <div className="col-md-5 d-flex justify-content-end align-items-center ps-3">
//               <div className="text-center">
//                 <img src={viewexpense} alt="Addepe" style={{ width: "90%" }} />
//               </div>
//             </div>

//             <div className="col-md-6 d-flex flex-column ">
//               <div className="col-md-12 d-flex mb-4 justify-content-start align-items-end">
//                 <div className="col-md-4  ps-2">
//                   <Label htmlFor="formrow-firstname-Input">
//                     Date <span className="text-danger">*</span>
//                   </Label>
//                   <div className="d-flex justify-content-start align-items-center gap-2">
//                     <Input
//                       type="date"
//                       value={viewBudgetData?.date}
//                       className="form-control"
//                       disabled
//                     />
//                   </div>
//                 </div>
//                 <div className="col-md-4 ps-2">
//                   <Label htmlFor="formrow-firstname-Input">
//                     Location <span className="text-danger">*</span>
//                   </Label>
//                   <Select
//                     isDisabled="true"
//                     placeholder="Select Location"
//                     className="basic-multi-select"
//                     classNamePrefix=" select"
//                     styles={colourStyles}
//                     value={viewBudgetData?.location}
//                     options={location}
//                   />
//                 </div>
//                 <div className="col-md-4 ps-2">
//                   <Label htmlFor="formrow-firstname-Input">
//                     Currency <span className="text-danger">*</span>
//                   </Label>
//                   <Select
//                     isDisabled="true"
//                     placeholder="Select Currency"
//                     className="basic-multi-select"
//                     classNamePrefix=" select"
//                     styles={colourStyles}
//                     options={Currency}
//                     value={viewBudgetData?.currency}
//                   />
//                 </div>
//               </div>
//               <div className="col-md-12 d-flex mb-4 justify-content-start align-items-end">
//                 <div className="col-md-6 ps-2">
//                   <Label htmlFor="formrow-firstname-Input">
//                     Payment Via <span className="text-danger">*</span>
//                   </Label>
//                   <Select
//                     placeholder="Payment Via"
//                     className="basic-multi-select"
//                     classNamePrefix=" select"
//                     isDisabled="true"
//                     styles={colourStyles}
//                     options={payments}
//                     value={viewBudgetData?.paymentMethod}
//                   />
//                 </div>
//                 <div className="col-md-6 ps-2">
//                   <Label htmlFor="formrow-firstname-Input">
//                     Category <span className="text-danger">*</span>
//                   </Label>
//                   <Select
//                     isDisabled="true"
//                     placeholder="Payment Category"
//                     className="basic-multi-select"
//                     classNamePrefix=" select"
//                     styles={colourStyles}
//                     options={Categories}
//                     value={viewBudgetData?.categoryName}
//                   />
//                 </div>
//               </div>
//               <div className="col-md-12 d-flex flex-column justify-content-start align-items-start">
//                 <div className="col-md-12 mb-4 ps-2 mb-4 row">
//                   <div className="col-md-10">
//                     <Label htmlFor="formrow-firstname-Input">
//                       Title <span className="text-danger">*</span>
//                     </Label>

//                     <div className="d-flex justify-content-start align-items-center gap-2">
//                       <Input
//                         type="text"
//                         className="form-control"
//                         placeholder="Enter Title"
//                         value={viewBudgetData?.title}
//                         disabled={true}
//                       />
//                     </div>
//                   </div>
//                   <div className="col-md-2 mb-2">
//                     <Label htmlFor="formrow-firstname-Input">Recurring</Label>
//                     <div className="form-switch form-switch-md ">
//                       <input
//                         type="checkbox"
//                         className="form-check-input mt-2"
//                         id="customSwitchsizemd"
//                         defaultChecked={viewRecurring == 1 ? true : false}
//                         disabled={true}
//                       />
//                     </div>
//                   </div>
//                 </div>
//                 {viewRecurring == 1 && (
//                   <div className="col-md-12 d-flex ps-2 mb-4 justify-content-start align-items-end gap-2">
//                     <>
//                       {" "}
//                       <div className="col-md-4">
//                         <Label htmlFor="formrow-firstname-Input">
//                           Recurring Period{" "}
//                           <span className="text-danger">*</span>
//                         </Label>
//                         <Select
//                           placeholder="Select recurring"
//                           className="basic-multi-select"
//                           classNamePrefix=" select"
//                           styles={colourStyles}
//                           options={recurringOptions}
//                           value={viewRecurringPeriod}
//                           isDisabled={true}
//                         />
//                       </div>
//                       <div className="col-md-4">
//                         <Label htmlFor="formrow-firstname-Input">
//                           Recurring End Date{" "}
//                           <span className="text-danger">*</span>
//                         </Label>
//                         <Input
//                           type="date"
//                           className="form-control"
//                           placeholder="Enter Amount"
//                           value={viewRecurringEndDate}
//                           disabled={true}
//                         />
//                       </div>
//                     </>
//                   </div>
//                 )}
//                 <div className="col-md-10 mb-4 ps-2 d-flex gap-2">
//                   <div className="col-md-4">
//                     <Label htmlFor="formrow-firstname-Input">
//                       Amount <span className="text-danger">*</span>
//                     </Label>

//                     <div className="d-flex justify-content-start align-items-center gap-2">
//                       <Input
//                         disabled
//                         type="number"
//                         className="form-control"
//                         placeholder="Enter Amount"
//                         style={{ width: "100%" }}
//                         value={viewBudgetData?.amount}
//                       />
//                     </div>
//                   </div>
//                   <div className="col-md-4 ">
//                     <Label htmlFor="formrow-firstname-Input">GST</Label>

//                     <div className="d-flex justify-content-start align-items-center gap-2">
//                       <Input
//                         disabled
//                         type="text"
//                         className="form-control"
//                         placeholder="Enter GST"
//                         style={{ width: "100%" }}
//                         value={viewBudgetData?.gst}
//                       />
//                     </div>
//                   </div>
//                   {viewBudgetData?.currency_rate && (
//                     <div className="col-md-3">
//                       <Label htmlFor="formrow-firstname-Input">
//                         Exchange Rate
//                       </Label>
//                       <div className="d-flex justify-content-start align-items-center gap-2">
//                         <Input
//                           type="text"
//                           className="form-control"
//                           disabled
//                           style={{ width: "100%" }}
//                           value={viewBudgetData?.currency_rate}
//                         />
//                       </div>
//                     </div>
//                   )}
//                 </div>
//                 {viewBudgetData?.link ? (
//                   <div className="col-md-10 mb-4 ps-2 d-flex gap-2">
//                     <p>
//                       <i className="mdi mdi-chevron-right text-primary me-1"></i>{" "}
//                       <span className="text-purple fw-bold">Files</span> :{" "}
//                       <a
//                         className="text-light badge bg-primary me-2"
//                         title="Click To Open"
//                         style={{ cursor: "pointer", fontSize: "0.8rem" }}
//                         target="_blank"
//                         href={viewBudgetData?.link}
//                         rel="noreferrer"
//                       >
//                         Click Here
//                       </a>
//                     </p>
//                   </div>
//                 ) : null}
//               </div>
//             </div>
//           </Form>
//         </div>
//       </Modal>

//       {/* Add/Edit Payment Mode Modal */}
//       <Modal
//         isOpen={paymentMode || editPaymentMode}
//         size="xl"
//         className=""
//         centered
//       >
//         <div className="modal-header pe-4">
//           <h5 className="modal-title mt-0">
//             {editPaymentMode ? "Edit Payment" : "Add Payment"}
//           </h5>
//           <button
//             type="button"
//             onClick={() => {
//               setPaymentMode(false)
//               setEditPaymentMode(false)
//               setPaymentId("")
//               setPaymentDate("")
//               setPayPaymentMode(null)
//               setPayPaymentAmount("")
//               setPayPaymentCurrency(null)
//               setPayPaymentFile("")
//               setIsConvertedAmountPay(false)
//             }}
//             className="btn-modal-close"
//           >
//             <span aria-hidden="true" className="btn-modal-span">
//               ×
//             </span>
//           </button>
//         </div>

//         <div className="modal-body pe-4 my-4">
//           <Form
//             onSubmit={editPaymentMode ? handleEditPayment : handleAddPayment}
//             className="row d-flex justify-content-center align-items-center"
//           >
//             <div className="col-md-5 d-flex justify-content-end align-items-center ps-3">
//               <div className="text-center">
//                 <img src={addexpense} alt="Addepe" style={{ width: "90%" }} />
//               </div>
//             </div>

//             <div className="col-md-5 d-flex flex-column ">
//               <div className="col-md-12 d-flex mb-4 justify-content-start align-items-center gap-2">
//                 <div className="col-md-4">
//                   <label htmlFor="">
//                     Date <span className="text-danger">*</span>
//                   </label>
//                   <input
//                     type="date"
//                     required
//                     value={paymentDate}
//                     onChange={e => setPaymentDate(e.target.value)}
//                     className="form-control"
//                   />
//                 </div>
//                 <div className="col-md-5 ps-2">
//                   <Label htmlFor="formrow-firstname-Input">
//                     Payment Via <span className="text-danger">*</span>
//                   </Label>
//                   <Select
//                     placeholder="Payment Via"
//                     className="basic-multi-select"
//                     classNamePrefix=" select"
//                     styles={colourStyles}
//                     options={paymentsOption}
//                     value={payPaymentVia}
//                     onChange={selectedOption => {
//                       console.log("selected Option: ", selectedOption)
//                       setPayPaymentVia(selectedOption)
//                       console.log("payPaymentVia: ", payPaymentVia)
//                       const findOption =
//                         payments?.filter(item => {
//                           return item.payment_via == selectedOption.value
//                         }) || []
//                       setPaymentModeOption(findOption)
//                       setPayPaymentMode(null) // Reset mode when via changes
//                     }}
//                     required
//                   />
//                 </div>
//                 <div className="col-md-5">
//                   <Label htmlFor="formrow-firstname-Input">
//                     Payment Mode <span className="text-danger">*</span>
//                   </Label>
//                   <Select
//                     required
//                     placeholder="Payment Mode"
//                     className="basic-multi-select"
//                     classNamePrefix=" select"
//                     styles={colourStyles}
//                     options={
//                       paymentModeOption && paymentModeOption.length
//                         ? paymentModeOption
//                         : payments
//                     }
//                     value={payPaymentMode}
//                     onChange={selectedOption =>
//                       setPayPaymentMode(selectedOption)
//                     }
//                   />
//                 </div>
//               </div>

//               <div className="col-md-12 d-flex mb-4 justify-content-start align-items-end gap-2">
//                 <div className="col-md-4">
//                   <Label htmlFor="formrow-firstname-Input">
//                     Amount <span className="text-danger">*</span>
//                   </Label>
//                   <Input
//                     required
//                     type="number"
//                     className="form-control"
//                     placeholder="Enter Amount"
//                     value={payPaymentAmount}
//                     onChange={e => {
//                       editPaymentMode
//                         ? setPayPaymentAmount(e.target.value)
//                         : handlePayAmount(e.target.value)
//                     }}
//                   />
//                 </div>
//                 {!editPaymentMode ? (
//                   <>
//                     <div className="col-md-4 ">
//                       <Label htmlFor="formrow-firstname-Input">
//                         Currency <span className="text-danger">*</span>
//                       </Label>
//                       <Select
//                         placeholder="Select Currency"
//                         className="basic-multi-select"
//                         classNamePrefix=" select"
//                         styles={colourStyles}
//                         required
//                         options={Currency}
//                         value={paymentCurrency || payPaymentCurrency}
//                         onChange={selectedOption =>
//                           setPayPaymentCurrency(selectedOption)
//                         }
//                       />
//                     </div>
//                     {isConvertedAmountPay && (
//                       <div className="col-md-4 ">
//                         <Label htmlFor="formrow-firstname-Input">
//                           Exchange Rate
//                         </Label>
//                         <div className="d-flex justify-content-start align-items-center gap-2">
//                           <Input
//                             type="text"
//                             className="form-control"
//                             readOnly
//                             style={{ width: "100%" }}
//                             value={convertInrAmountPay}
//                             onChange={e =>
//                               setConvertInrAmountPay(e.target.value)
//                             }
//                           />
//                         </div>
//                       </div>
//                     )}
//                   </>
//                 ) : null}
//               </div>

//               <div className="col-md-12 d-flex mb-4 justify-content-start align-items-end gap-2">
//                 <div className="col-md-9 ">
//                   <label htmlFor="">Upload File</label>
//                   <input
//                     type="file"
//                     className="form-control"
//                     onChange={e => setPayPaymentFile(e.target.files[0])}
//                   />
//                 </div>
//                 {editPaymentMode && existingFile ? (
//                   <img
//                     src={existingFile}
//                     width={39}
//                     height={39}
//                     className="object-fit-cover"
//                     alt="existing Image"
//                     title="existing Image"
//                   />
//                 ) : null}
//               </div>

//               <div className="my-3 text-center pe-5 col-md-10">
//                 <button className=" btn btn-save btn-label">
//                   <i className="fas fa-save me-2 label-icon"></i>
//                   Save
//                 </button>
//                 <a
//                   onClick={() => {
//                     setPaymentMode(false)
//                     setEditPaymentMode(false)
//                     setPaymentId("")
//                     setPaymentDate("")
//                     setPayPaymentMode(null)
//                     setPayPaymentAmount("")
//                     setPayPaymentCurrency(null)
//                     setPayPaymentFile("")
//                     setIsConvertedAmountPay(false)
//                   }}
//                   className=" btn ms-md-2 btn-red btn-label"
//                 >
//                   <i className="dripicons-cross me-2 icon-center label-icon"></i>
//                   CANCEL
//                 </a>
//               </div>
//             </div>
//           </Form>
//         </div>
//       </Modal>

//       {/* Payment History Modal */}
//       <Modal isOpen={payMentHistory} size="xl" className="" centered>
//         <div className="modal-header pe-4">
//           <h5 className="modal-title mt-0">Payment History</h5>
//           <button
//             type="button"
//             onClick={() => {
//               setPaymentHistory(false);
//             }}
//             className="btn-modal-close"
//           >
//             <span aria-hidden="true" className="btn-modal-span">
//               ×
//             </span>
//           </button>
//         </div>

//         <div className="modal-body pe-4 my-5">
//           <div className="row d-flex justify-content-center align-items-center">
//             <div className="col-md-4 d-flex justify-content-end align-items-center ps-3">
//               <div className="text-center">
//                 <img src={viewbill} alt="Addepe" style={{ width: "80%" }} />
//               </div>
//             </div>
//             <div className="col-md-8">
//               <Table bordered hover responsive size="" striped>
//                 <thead>
//                   <tr>
//                     <th className="text-center credit-bill-col-1">Sr. No</th>
//                     <th className="credit-bill-col-2">Payment Mode</th>
//                     <th className="credit-bill-col-3 text-center">Amount</th>
//                     <th className="credit-bill-col-4 text-center">Date</th>
//                     <th className="text-center credit-bill-col-5">Receipt</th>
//                     <th className="text-center credit-bill-col-3">Action</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {payMentHistoryData?.map((items, index) => {
//                     const filterPayment = payments.find((obj) => {
//                       return items.payment_mode_id == obj.value;
//                     });
//                     return (
//                       <tr key={items.id}>
//                         <td
//                           scope="row"
//                           className="text-center credit-bill-col-1"
//                         >
//                           {index + 1}
//                         </td>
//                         <td className="credit-bill-col-2">
//                           {filterPayment?.label}
//                         </td>
//                         <td className="credit-bill-col-3 text-center">
//                           {items.amount}
//                         </td>
//                         <td className="credit-bill-col-4 text-center">
//                           {moment(items.date).format("DD-MM-YYYY")}
//                         </td>
//                         <td className="text-center credit-bill-col-5">
//                           {items.link ? (
//                             <a
//                               href={items.link}
//                               download={true}
//                               target="_blank"
//                               rel="noreferrer"
//                               className="btn btn-download bg-purple"
//                             >
//                               <i className="fas fa-download label-icon"></i>
//                             </a>
//                           ) : (
//                             "-"
//                           )}
//                         </td>
//                         <td className="credit-bill-col-3 text-center">
//                           <button
//                             onClick={() => {
//                               console.log("items: ", items);
//                               handlePayEditPayment(items);
//                             }}
//                             className="btn btn-sm me-1 btn-outline-secondary"
//                           >
//                             <i className="fa fa-pencil-alt"></i>
//                           </button>
//                         </td>
//                       </tr>
//                     );
//                   })}
//                   {payMentHistoryData.length == 0 && (
//                     <tr className="text-center">
//                       <td colSpan={8}>No History Found</td>
//                     </tr>
//                   )}
//                 </tbody>
//               </Table>
//             </div>
//           </div>
//         </div>
//       </Modal>

//       <AccessDeniedPopup
//         modal_Access={modal_Access}
//         setAccessDenied={setAccessDenied}
//       />
//     </React.Fragment>
//   );
// };

// export default Expense;




















import React, { useEffect, useRef, useState } from "react"
import {
  Container,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  Form,
  Input,
  Label,
} from "reactstrap"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { Link, useNavigate } from "react-router-dom"
import { useMemo } from "react"
import {
  useTable,
  useSortBy,
  usePagination,
  useGlobalFilter,
} from "react-table"
import India from "../../../assets/images/flags/india.png"
import Uk from "../../../assets/images/flags/uk.png"
import Select from "react-select"
import "../../../assets/css/Finance/Style/ExpenseSection/expense.css"
import addexpense from "../../../assets/images/Expenses/addExpense.jpg"
import editexpense from "../../../assets/images/Expenses/editExpense.jpg"
import viewexpense from "../../../assets/images/Expenses/viewExpense.jpg"
import viewbill from "../../../assets/images/Expenses/View_Bill.jpg"
import { Table, Row, Col, Card, CardBody, Modal } from "reactstrap"
import axios from "axios"
import Loader from "pages/Separate/Loader"
import swal from "sweetalert"
import configure from "configure"
import Swal from "sweetalert2"
import AccessDeniedPopup from "routes/AccessDeniedPopup"
import moment from "moment"
import NewPagination from "components/Common/Newpagination"
import Draggable, { DraggableCore } from "react-draggable"
import { Resizable, ResizableBox } from "react-resizable"
import { sum } from "lodash"
import { formatDate } from "devextreme/localization"
import { fetchNodeData } from "utils/common-fetchData"
import secureLocalStorage from "react-secure-storage"
import { colourStyles } from "utils/common-options"

function TableContainer({
  columns,
  data,
  setAccessDenied,
  setLoading,
  location,
  Categories,
  payments,
  Currency,
  setDatas,
  allData,
  fetchData,
  setAllData,
  paymentsOption,
  setIsfilter,
  introducerOptions,
  onReloadApi,
}) {
  const [fixedContent, setFixedContent] = useState(false)
  const [status, setStatus] = useState(false)
  const [formPopup, setFormPopup] = useState(false)
  const [addExpense, setAddExpense] = useState(false)
  const [isConvertedAmount, setIsConvertedAmount] = useState(false)
  const [convertInrAmount, setConvertInrAmount] = useState("")
  const [recurring, setRecurring] = useState(0)
  const [introducer, setIntroducer] = useState(0)
  const [recordPayment, setRecordPayment] = useState(0)
  const [recurringPeriod, setRecurringPeriod] = useState(null)
  const [recurringEndDate, setRecurringEndDate] = useState("")
  const [recurringOptions, setRecurringOptions] = useState([
    { value: 1, label: "1 Month" },
    { value: 2, label: "2 Month" },
    { value: 12, label: "1 Year" },
  ])
  const [boxWidth, setBoxWidth] = useState(0)
  const [fStartDate, setFStartDate] = useState("")
  const [fendDate, setFendDate] = useState("")

  document.addEventListener("keydown", e => {
    if (e.key === "Escape") setAddExpense(false), setFormPopup(false)
  })

  const expenseFileUpload = useRef(null)

  const navigate = useNavigate()

  document.addEventListener("scroll", () => {
    if (window.scrollY > 300) {
      setFixedContent(true)
    } else {
      setFixedContent(false)
    }
  })
  // Use the state and functions returned from useTable to build your UI
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    state,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    gotoPage,
    setPageSize,
    pageOptions,
    setGlobalFilter,
    pageCount,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
      initialState: {
        sortBy: [
          {
            id: "id",
            desc: true,
          },
        ],
      },
    },

    useGlobalFilter,
    useSortBy,
    usePagination
  )

  const { pageIndex, pageSize, globalFilter } = state
  useEffect(() => setPageSize(50), [])

  useEffect(() => {
    if (!data || data.length === 0) return // Handle empty data case

    // const totalExpense = data.reduce((acc, item) => acc + (item.amount || 0), 0);
    const totalExpense = data.reduce(
      (acc, item) => acc + (parseFloat(item.amount) || 0),
      0
    )

    const bankTotal = data
      .filter(list => list.payment_method === "1")
      .reduce((acc, item) => acc + (item.amount - item.tbal || 0), 0)

    const creditTotal = data
      .filter(list => list.payment_method === "2")
      .reduce((acc, item) => acc + (item.amount - item.tbal || 0), 0)

    const otherTotal = data
      .filter(list => list.payment_method === "3")
      .reduce((acc, item) => acc + (item.amount - item.tbal || 0), 0)

    const modifyArray = {
      ...allData,
      budgetExpense: totalExpense,
      bank: bankTotal,
      credit_card: creditTotal,
      others: otherTotal,
    }
    setAllData(modifyArray)
  }, [data])

  const [title, setTitle] = useState("")
  const [name_modal, setNameModal] = useState(false)
  const [addDate, setAddDate] = useState("")
  const [locationValue, setLocationValue] = useState(null)
  const [paymentViaValue, setPaymentViaValue] = useState(null)
  const [categoryValue, setCategoryValue] = useState(null)
  const [currencyValue, setCurrencyValue] = useState(null)
  const [titleValue, setTitleValue] = useState("")
  const [amountValue, setAmountValue] = useState("")
  const [gstValue, setGstValue] = useState("")
  const [fromDate, setFromDate] = useState(new Date())
  const [toDate, setToDate] = useState(new Date())

  const [fromDateFilter, setFromDateFilter] = useState("")
  const [toDateFilter, setToDateFilter] = useState("")
  const [filterPayment, setFilterPayment] = useState(null)
  const [filterCategory, setFilterCategory] = useState(null)
  const [filterCurrency, setFilterCurrency] = useState(null)
  const [introducerValue, setIntroducerValue] = useState(null)

  useEffect(() => {
    const newDate = new Date(fromDate)
    newDate.setMonth(newDate.getMonth() + 1)
    setToDate(newDate)
  }, [])

  const handleSubmit = async e => {
    e.preventDefault()
    const isRecurring = recurring == 1 ? recurringPeriod !== null : true
    if (
      locationValue !== null &&
      paymentViaValue !== null &&
      categoryValue !== null &&
      currencyValue !== null &&
      isRecurring
    ) {
      setLoading(true)
      const formData = new FormData()
      formData.append("type", 2)
      formData.append("date", addDate)
      formData.append("location", locationValue?.value)
      formData.append("payment_via", paymentViaValue?.value)
      formData.append("category", categoryValue?.value)
      formData.append("title", titleValue)
      formData.append("amount", amountValue)
      formData.append("currency", currencyValue?.value)
      formData.append("gst", gstValue)

      if (expenseFileUpload.current.files[0]) {
        formData.append("file", expenseFileUpload.current.files[0])
      }

      if (isConvertedAmount) {
        formData.append(
          "currency_rate",
          convertInrAmount ? convertInrAmount : 1
        )
      } else {
        formData.append("currency_rate", 1)
      }
      if (recurring == 1) {
        formData.append("recurrence", recurring)
        formData.append("recurrence_period", recurringPeriod?.value)
        formData.append("recurrence_date", recurringEndDate)
      }
      formData.append("introducer_id", introducerValue)
      formData.append("recordPayment", recordPayment)

      console.log("Add Form Data", formData)
      try {
        const response = await axios.post(
          `${configure.nodeApi}/addBudgetExpense`,
          formData,
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "multipart/form-data",
            },
          }
        )
        if (response.data.success) {
          setLoading(false)
          Swal.fire({
            icon: "success",
            text: "Expense added",
          }).then(() => {
            setIsConvertedAmount(false)
            setConvertInrAmount("")
            setAddDate("")
            setLocationValue(null)
            setPaymentViaValue(null)
            setCategoryValue(null)
            setTitleValue("")
            setAmountValue("")
            setCurrencyValue(null)
            setGstValue("")
            expenseFileUpload.current = null
            setAddExpense(false)
            setIntroducerValue(null) // Reset introducer
            // // const expense = response.data.data?.expense?.filter((list) => {
            // //   const modifyAmount =
            // //     Number(list.amount)?.toFixed(1) - Number(list.tbal)?.toFixed(1);
            // //   return modifyAmount >= 1;
            // // });
            // // setDatas(expense);
            // // setAllData(response?.data?.data);
            setRecurring(0)
            setRecurringPeriod(null)
            setRecurringEndDate("")
            onReloadApi(true)
          })
        } else {
          setLoading(false)
          Swal.fire({
            icon: "warning",
            text: `${response.data.data}`,
          })
        }
      } catch (error) {
        console.error("Error", error)
        setLoading(false)
      }
    } else {
      Swal.fire({
        icon: "warning",
        text: "Please fill all fields",
      })
    }
  }

  // const handleFilter = e => {
  //   e.preventDefault()

  //   if (
  //     fromDateFilter &&
  //     toDateFilter &&
  //     moment(fromDateFilter).isAfter(toDateFilter)
  //   ) {
  //     Swal.fire({
  //       icon: "warning",
  //       title: "Invalid date range",
  //       text: "end date must be after the start date.",
  //     })
  //     return
  //   }

  //   if (fromDateFilter || toDateFilter || filterPayment || filterCategory) {
  //     setIsfilter(true)
  //     try {
  //       let filteredData = allData?.expense || []

  //       if (fromDateFilter) {
  //         filteredData = filteredData.filter(item =>
  //           moment(item.created_at).isSameOrAfter(moment(fromDateFilter))
  //         )
  //       }

  //       if (toDateFilter) {
  //         filteredData = filteredData.filter(item =>
  //           moment(item.created_at).isSameOrBefore(moment(toDateFilter))
  //         )
  //       }

  //       if (filterPayment) {
  //         filteredData = filteredData.filter(item => {
  //           return item.payment_method == filterPayment?.value
  //         })
  //       }

  //       if (filterCategory) {
  //         filteredData = filteredData.filter(
  //           item => item.category_id == filterCategory?.value
  //         )
  //       }

  //       filteredData = filteredData.sort(
  //         (a, b) => new Date(a.created_at) - new Date(b.created_at)
  //       )
  //       setDatas([...filteredData])
  //     } catch (error) {
  //       console.error(error)
  //       Swal.fire({
  //         icon: "error",
  //         title: "Something went wrong",
  //         text: "Unable to apply filters. please try again.",
  //       })
  //     }
  //   } else {
  //     Swal.fire({
  //       icon: "warning",
  //       text: "Please enter at least one filter criterion to proceed.",
  //     })
  //   }
  // }
  const handleFilter = e => {
    e.preventDefault()

    // Validate date range: fromDate must be before toDate
    if (
      fromDateFilter &&
      toDateFilter &&
      moment(fromDateFilter).isAfter(moment(toDateFilter))
    ) {
      Swal.fire({
        icon: "warning",
        title: "Invalid date range",
        text: "End date must be after the start date.",
      })
      return
    }

    if (fromDateFilter || toDateFilter || filterPayment || filterCategory) {
      setIsfilter(true)
      try {
        let filteredData = allData?.expense ?? []

        // Filter entries with date >= fromDateFilter
        if (fromDateFilter) {
          filteredData = filteredData.filter(item =>
            moment(item.date).isSameOrAfter(moment(fromDateFilter), "day")
          )
        }

        // Filter entries with date <= toDateFilter
        if (toDateFilter) {
          filteredData = filteredData.filter(item =>
            moment(item.date).isSameOrBefore(moment(toDateFilter), "day")
          )
        }

        // Filter by payment method if selected
        if (filterPayment) {
          filteredData = filteredData.filter(
            item => item.payment_method === filterPayment.value
          )
        }

        // Filter by category if selected
        if (filterCategory) {
          filteredData = filteredData.filter(
            item => item.category_id === filterCategory.value
          )
        }

        // Sort by date descending (latest first)
        filteredData = filteredData.sort(
          (a, b) => new Date(b.date) - new Date(a.date)
        )

        setDatas([...filteredData])
      } catch (error) {
        console.error(error)
        Swal.fire({
          icon: "error",
          title: "Something went wrong",
          text: "Unable to apply filters. Please try again.",
        })
      }
    } else {
      Swal.fire({
        icon: "warning",
        text: "Please enter at least one filter criterion to proceed.",
      })
    }
  }

  const handleClear = () => {
    setIsfilter(false)
    setFromDateFilter("")
    setToDateFilter("")
    setFilterPayment(null)
    setFilterCategory(null)
    setFilterCurrency(null)
    const expense = allData?.expense?.filter(list => {
      const modifyAmount =
        Number(list.amount)?.toFixed(1) - Number(list.tbal)?.toFixed(1)
      return modifyAmount >= 1
    })
    setDatas(expense)
  }
  const handleClose = async () => {
    if (
      fromDateFilter ||
      toDateFilter ||
      filterPayment ||
      filterCategory ||
      filterCurrency
    ) {
      setIsfilter(false)
      setFormPopup(!formPopup)
      setFromDateFilter("")
      setToDateFilter("")
      setFilterPayment(null)
      setFilterCategory(null)
      setFilterCurrency(null)
      const expense = allData?.expense?.filter(list => {
        const modifyAmount =
          Number(list.amount)?.toFixed(1) - Number(list.tbal)?.toFixed(1)
        return modifyAmount >= 1
      })
      setDatas(expense)
      Swal.fire({
        icon: "success",
        text: "Filter cleared and popup closed.",
      })
    } else {
      setFormPopup(!formPopup)
    }
  }

  const handleAddDate = async date => {
    setAddDate(date)
  }
  useEffect(() => {
    if (addDate && currencyValue && amountValue) {
      if (currencyValue.label !== "INR") {
        const fetchCurrencyRate = async () => {
          setLoading(true)
          try {
            const response = await axios.get(
              `https://api.apilayer.com/fixer/${addDate}?symbols=INR&base=${currencyValue.label}`,
              {
                headers: {
                  apikey: configure.exchangeKey,
                },
              }
            )
            if (response) {
              setLoading(false)
              const rate = response.data.rates.INR
              const formattedRate = rate.toFixed(2)
              setConvertInrAmount(formattedRate) // Calculate the converted amount
            } else {
              setLoading(false)
            }
          } catch (error) {
            setLoading(false)
            Swal.fire({
              icon: "warning",
              text:
                error.response?.data?.message || "Error fetching currency rate",
            })
            console.error("Error fetching currency rate:", error)
          }
        }
        fetchCurrencyRate()
        setIsConvertedAmount(true)
      } else {
        setIsConvertedAmount(false)
      }
    }
  }, [addDate, currencyValue, amountValue])

  useEffect(() => {
    const updateWidth = () => {
      const viewportWidth = window.innerWidth
      setBoxWidth(viewportWidth * 0.9)
    }
    updateWidth()
    window.addEventListener("resize", updateWidth)
    return () => window.removeEventListener("resize", updateWidth)
  }, [])

  const handleAddE = async () => {
    setLoading(true)
    const formData = new FormData()
    formData.append("user_id", localStorage.getItem("auth_id"))
    formData.append("module_id", 41)
    try {
      await axios({
        method: "post",
        url: `${configure.apiUrl}/earth_permission`,
        data: formData,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      }).then(res => {
        setLoading(false)
        if (res.data.data.india[3] == 1 || res.data.data.uk[3] == 1) {
          setAddExpense(true)
        } else {
          setAccessDenied(true)
        }
      })
    } catch (error) {
      console.log(error)
    }
  }

  const fianancial_year = [
    { label: "2024 to 2025", value: "2024 to 2025" },
    { label: "2023 to 2024", value: "2023 to 2024" },
    { label: "2022 to 2023", value: "2022 to 2023" },
  ]

  return (
    <div>
      {/* fixed buttons */}
      <div
        className={`flex-column fixed-buttons pt-2 ${fixedContent ? "d-flex" : "d-none"
          }`}
      >
        <Link
          onClick={() => handleAddE()}
          className="btn btn-save  fix-btn btn-label pe-0"
        >
          <i className="fas fa-plus me-2 icon-size label-icon"></i>
          <span>Expense</span>
        </Link>
        <button
          onClick={() => navigate(-1)}
          className="btn btn-red  fix-btn btn-label pe-0"
        >
          <i className="dripicons-cross me-2 icon-center label-icon"></i>
          <span>Cancel</span>
        </button>
      </div>

      <Row className="d-flex mt-4">
        <div className="d-flex col-md-8 justify-flex-start align-items-center gap-2">
          <div
            className={`col-md-2 budget_status text-success pt-2 px-2 me-5 rounded proposal-status text-center total-expesne`}
          >
            <h6>Total Expense</h6>
            <h3>
              ₹{" "}
              {allData?.budgetExpense
                ? Number(allData?.budgetExpense)?.toFixed(2)
                : 0}
            </h3>
          </div>
          <div
            className={`col-md-2 budget_status text-primary"  pt-2 px-1 rounded proposal-status text-center`}
          >
            <h6>Total Payable</h6>
            <h3> ₹ 0</h3>
          </div>
          <div
            className={`col-md-2 budget_status text-primary" pt-2 px-1 rounded proposal-status text-center`}
          >
            <h6>Total Bank</h6>
            <h3> ₹ {allData?.bank ? Number(allData?.bank)?.toFixed(2) : 0}</h3>
          </div>
          <div
            className={`col-md-2 budget_status text-primary
          pt-2 px-2 rounded proposal-status text-center total-credit-card`}
          >
            <h6>Total Credit Card</h6>
            <h3>
              ₹{" "}
              {allData?.credit_card
                ? Number(allData?.credit_card)?.toFixed(2)
                : 0}
            </h3>
          </div>
          <div
            className={`col-md-2 budget_status text-success pt-2 px-2 rounded proposal-status text-center`}
          >
            <h6>Other </h6>
            <h3>
              ₹ {allData?.others ? Number(allData?.others)?.toFixed(2) : 0}
            </h3>
          </div>
        </div>
        <div className="col-md-4 text-end">
          <div className="">
            <button
              onClick={() => setFormPopup(!formPopup)}
              className="btn btn-outline-secondary  me-3"
            >
              <i className="fas fa-filter"></i>
            </button>
            <button
              className=" btn btn-save btn-label"
              onClick={() => handleAddE()}
            >
              <i className="fas fa-plus me-2 label-icon"></i>
              Expense
            </button>
          </div>
        </div>
      </Row>
      <Row className="m-0 d-flex justify-space-between align-items-center">
        <div className="p-0 col-md-2">
          <select
            className=" form-select mt-4"
            style={{ width: "100px" }}
            value={pageSize}
            onChange={e => setPageSize(e.target.value)}
          >
            {[10, 25, 50, 100].map(pageSize => (
              <option key={pageSize} value={pageSize}>
                Show {pageSize}
              </option>
            ))}
          </select>
        </div>
        <div className="p-0 col-md-2">
          <div className="search-box my-xxl-0 d-inline-block ">
            <div className="position-relative  mt-4">
              <label htmlFor="search-bar-0" className="search-label">
                <span id="search-bar-0-label" className="sr-only">
                  Search this table
                </span>
                <input
                  onChange={e => setGlobalFilter(e.target.value)}
                  id="search-bar-0"
                  type="text"
                  className=" form-control rounded h-100 "
                  placeholder={` Search...`}
                  value={globalFilter || ""}
                />
              </label>
              <i className="bx bx-search-alt search-icon"></i>
            </div>
          </div>
        </div>
      </Row>
      <div className="position-relative">
        <Table className="table table-bordered mt-4" {...getTableProps()}>
          <thead
            className={`${fixedContent && page.length >= 10 ? "fix-header" : ""
              } fix-introducer-header`}
          >
            {headerGroups.map((headerGroup, i) => (
              <tr key={i} {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column, index) => (
                  <th
                    key={index}
                    className={`t-col-${index + 1} ${column.className}`}
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                  >
                    <div className="d-flex align-items-center">
                      <span className="flex-grow-1 text-center header-text">
                        {column.render("Header")}
                      </span>
                      {column.isShortIcon && (
                        <span
                          onClick={() =>
                            column.getSortByToggleProps().onClick()
                          }
                          className="d-flex align-items-center ms-2"
                        >
                          <i
                            title="Ascending"
                            className={`bi bi-arrow-up info-icon ${column.isSorted && !column.isSortedDesc
                              ? "text-dark"
                              : ""
                              }`}
                          ></i>
                          <i
                            title="Descending"
                            className={`bi bi-arrow-down info-icon ${column.isSorted && column.isSortedDesc
                              ? "text-dark"
                              : ""
                              }`}
                          ></i>
                        </span>
                      )}
                    </div>
                  </th>
                ))}
              </tr>
            ))}
          </thead>

          <tbody className="fix-introducer-header" {...getTableBodyProps()}>
            {page.map((row, i) => {
              prepareRow(row)
              return (
                <tr className="row-hover" {...row.getRowProps()} key={i}>
                  {row.cells.map((cell, index) => {
                    return (
                      <td
                        key={index}
                        className={`t-col-${index + 1} ${cell.column.className
                          }`}
                        {...cell.getCellProps()}
                      >
                        {cell.render("Cell")}
                      </td>
                    )
                  })}
                </tr>
              )
            })}
            {page.length == 0 && (
              <tr className="text-center">
                <td colSpan={8}>No Data Found</td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>

      {/* Pagination */}
      <Row className="justify-content-md-end justify-content-center align-items-center">
        <NewPagination
          gotoPage={gotoPage}
          canPreviousPag={canPreviousPage}
          canNextPage={canNextPage}
          pageIndex={pageIndex}
          pageOptions={pageOptions}
          pageSize={pageSize}
          page={page}
          data={data}
        />
      </Row>

      {/* Filter Modal  */}
      {/* {formPopup ? (
        <Draggable>
        <ResizableBox
          width={boxWidth}
          style={{
            position: "fixed",
            top: "30%",
            right: "3%",
            zIndex: "1055",
            backgroundColor: "#fff",
          }}
        >
        <div className="expense-filter">
          <div className="popup-form p-4">
            <Form
              onSubmit={handleFilter}
              className="row d-flex justify-content-center align-items-center"
            >
              <div className="col-md-12 d-flex ">
                <div className="col-md-2 ps-2">
                  <Label htmlFor="formrow-firstname-Input">From Date</Label>
                  <Input
                    type="date"
                    value={fromDate}
                    onChange={e => setFromDate(e.target.value)}
                  />
                
                </div>
                <div className="col-md-2 ps-2">
                  <Label htmlFor="formrow-firstname-Input">To Date</Label>
                  <Input
                    type="date"
                    value={toDate}
                    onChange={e => setToDate(e.target.value)}
                  />
                 
                </div>
                <div className="col-md-2 ps-2 mb-4">
                  <Label htmlFor="formrow-firstname-Input">Payment Via</Label>
                  <Select
                    placeholder="Payment Via"
                    className="basic-multi-select"
                    classNamePrefix=" select"
                  
                    options={payments}
                    value={filterPayment}
                    onChange={selectedOption =>
                      setFilterPayment(selectedOption)
                    }
                  />
                </div>
                <div className="col-md-2 ps-2">
                  <Label htmlFor="formrow-firstname-Input">Category</Label>
                  <Select
                
                    placeholder="Payment Category"
                    className="basic-multi-select"
                    classNamePrefix=" select"
                  
                    options={Categories}
                    value={filterCategory}
                    onChange={selectedOption =>
                      setFilterCategory(selectedOption)
                    }
                  />
                </div>
             
                <div className="col-md-4 d-flex justify-content-end align-items-center gap-2">
                  <a
                    className="btn  btn-danger"
                    style={{
                      fontSize: "14px",
                      backgroundColor: "#fed36d",
                      borderColor: "#fed36d",
                      color: "black",
                    }}
                    onClick={() => handleClear()}
                  >
                    Clear Filters
                  </a>
                  <button className="btn  btn-save btn-label me-1">
                    <i className="fas fa-filter search-icon label-icon"></i>{" "}
                    Filter
                  </button>
                  <a
                    className="btn btn-red btn-label me-1"
                    onClick={() => setFormPopup(!formPopup)}
                  >
                    <i className="dripicons-cross label-icon"></i> Close
                  </a>
                </div>

            
              </div>
            </Form>
            <i className="bi bi-triangle-fill pop-icon"></i>
          </div>
        </div>
        </ResizableBox>
        </Draggable>
      ) : null} */}
      {formPopup ? (
        <Draggable>
          <ResizableBox
            width={boxWidth}
            style={{
              position: "fixed",
              top: "30%",
              right: "3%",
              zIndex: "1055",
              backgroundColor: "#fff",
            }}
          >
            {/* <div className="expense-filter">
          <div className="popup-form p-4"> */}
            <Form
              onSubmit={handleFilter}
              className="row d-flex justify-content-center align-items-center"
            >
              <div className="col-md-12 d-flex ">
                <div className="col-md-2 ps-2">
                  <Label htmlFor="formrow-firstname-Input">From Date</Label>
                  <Input
                    type="date"
                    required={toDateFilter ? true : false}
                    value={fromDateFilter}
                    onChange={e => setFromDateFilter(e.target.value)}
                  />
                </div>
                <div className="col-md-2 ps-2">
                  <Label htmlFor="formrow-firstname-Input">To Date</Label>
                  <Input
                    type="date"
                    value={toDateFilter}
                    onChange={e => setToDateFilter(e.target.value)}
                  />
                </div>
                <div className="col-md-2 ps-2 mb-4">
                  <Label htmlFor="formrow-firstname-Input">Payment Via</Label>
                  <Select
                    placeholder="Payment Via"
                    className="basic-multi-select"
                    classNamePrefix=" select"
                    options={paymentsOption}
                    value={filterPayment}
                    onChange={selectedOption =>
                      setFilterPayment(selectedOption)
                    }
                  />
                </div>
                <div className="col-md-2 ps-2">
                  <Label htmlFor="formrow-firstname-Input">
                    Payment Category
                  </Label>
                  <Select
                    placeholder="Payment Category"
                    className="basic-multi-select"
                    classNamePrefix=" select"
                    options={Categories}
                    value={filterCategory}
                    onChange={selectedOption =>
                      setFilterCategory(selectedOption)
                    }
                  />
                </div>

                <div className="col-md-4 d-flex justify-content-end align-items-center gap-2">
                  <a
                    className="btn  btn-danger"
                    style={{
                      fontSize: "14px",
                      backgroundColor: "#fed36d",
                      borderColor: "#fed36d",
                      color: "black",
                    }}
                    onClick={() => handleClear()}
                  >
                    Clear Filters
                  </a>
                  <button className="btn  btn-save btn-label me-1">
                    <i className="fas fa-filter search-icon label-icon"></i>{" "}
                    Filter
                  </button>
                  <a
                    className="btn btn-red btn-label me-1"
                    onClick={() => handleClose()}
                  >
                    <i className="dripicons-cross label-icon"></i> Close
                  </a>
                </div>
              </div>
            </Form>
          </ResizableBox>
        </Draggable>
      ) : null}

      {/* Add Expense Modal */}

      <Modal isOpen={addExpense} size="xl" className="" centered>
        <div className="modal-header pe-4">
          <h5 className="modal-title mt-0">Add Expense</h5>
          <button
            type="button"
            onClick={() => {
              setIntroducer(0)
              setRecurring(0)
              setAddDate("")
              setLocationValue(null)
              setCurrencyValue(null)
              setPaymentViaValue(null)
              setCategoryValue(null)
              setTitleValue("")
              setRecurringPeriod(null)
              setRecurringEndDate(null)
              setGstValue("")
              setAmountValue("")
              setIntroducerValue(null)
              setConvertInrAmount("")
              setRecordPayment(0)
              setAddExpense(false)
            }}
            className="btn-modal-close"
          >
            <span aria-hidden="true" className="btn-modal-span">
              &times;
            </span>
          </button>
        </div>

        <div className="modal-body pe-4">
          <Form
            onSubmit={handleSubmit}
            className="row d-flex justify-content-center align-items-center"
          >
            <div className="col-md-5 d-flex justify-content-end align-items-center ps-3">
              <div className="text-center">
                <img src={addexpense} alt="Addepe" style={{ width: "90%" }} />
              </div>
            </div>

            <div className="col-md-6 d-flex flex-column ">
              <div className="col-md-12 d-flex mb-4 justify-content-start align-items-end">
                <div className="col-md-4  ps-2">
                  <Label htmlFor="formrow-firstname-Input">
                    Date <span className="text-danger">*</span>
                  </Label>
                  <div className="d-flex justify-content-start align-items-center gap-2">
                    <Input
                      required
                      type="date"
                      value={addDate}
                      onChange={e => handleAddDate(e.target.value)}
                      className="form-control"
                    />
                  </div>
                </div>
                <div className="col-md-4 ps-2">
                  <Label htmlFor="formrow-firstname-Input">
                    Location <span className="text-danger">*</span>
                  </Label>
                  <Select
                    // value={lead_belong}
                    placeholder="Select Location"
                    className="basic-multi-select"
                    classNamePrefix=" select"
                    // styles={colourStyles}
                    options={location}
                    value={locationValue}
                    onChange={selectedOption =>
                      setLocationValue(selectedOption)
                    }
                  />
                </div>
                <div className="col-md-4 ps-2">
                  <Label htmlFor="formrow-firstname-Input">
                    Currency <span className="text-danger">*</span>
                  </Label>
                  <Select
                    // value={lead_belong}
                    placeholder="Select Currency"
                    className="basic-multi-select"
                    classNamePrefix=" select"
                    // styles={colourStyles}
                    options={Currency}
                    value={currencyValue}
                    onChange={selectedOption =>
                      setCurrencyValue(selectedOption)
                    }
                  />
                </div>
              </div>
              <div className="col-md-12 d-flex mb-4 justify-content-start align-items-end">
                <div className="col-md-6 ps-2">
                  <Label htmlFor="formrow-firstname-Input">
                    Payment Via <span className="text-danger">*</span>
                  </Label>
                  <Select
                    // value={lead_belong}
                    placeholder="Payment Via"
                    className="basic-multi-select"
                    classNamePrefix=" select"
                    // styles={colourStyles}
                    options={paymentsOption}
                    value={paymentViaValue}
                    onChange={selectedOption =>
                      setPaymentViaValue(selectedOption)
                    }
                  />
                </div>
                <div className="col-md-6 ps-2">
                  <Label htmlFor="formrow-firstname-Input">
                    Category <span className="text-danger">*</span>
                  </Label>
                  <Select
                    placeholder="Payment Category"
                    className="basic-multi-select"
                    classNamePrefix=" select"
                    options={Categories}
                    value={categoryValue}
                    onChange={selectedOption =>
                      setCategoryValue(selectedOption)
                    }
                  />
                </div>
              </div>
              <div className="col-md-12 d-flex flex-column justify-content-start align-items-start">
                <div className="col-md-12 ps-2 mb-4 row">
                  <div className="col-md-10">
                    <Label htmlFor="formrow-firstname-Input">
                      Title <span className="text-danger">*</span>
                    </Label>

                    <div className="d-flex justify-content-start align-items-center gap-2">
                      <Input
                        type="text"
                        className="form-control"
                        // id="formrow-firstname-Input"
                        placeholder="Enter Title"
                        // style={{width : "80%"}}
                        value={titleValue}
                        onChange={e => setTitleValue(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-md-2 mb-2">
                    <Label htmlFor="formrow-firstname-Input">Recurring</Label>
                    <div className="form-switch form-switch-md ">
                      <input
                        type="checkbox"
                        className="form-check-input mt-2"
                        id="customSwitchsizemd"
                        defaultChecked={recurring == 1 ? true : false}
                        onChange={e => setRecurring(e.target.checked ? 1 : 0)}
                      />
                    </div>
                  </div>
                </div>

                {recurring == 1 && (
                  <div className="col-md-12 d-flex mb-4 ps-2 justify-content-start align-items-end gap-2">
                    <>
                      {" "}
                      <div className="col-md-4">
                        <Label htmlFor="formrow-firstname-Input">
                          Recurring Period{" "}
                          <span className="text-danger">*</span>
                        </Label>
                        <Select
                          placeholder="Select recurring"
                          className="basic-multi-select"
                          classNamePrefix=" select"
                          options={recurringOptions}
                          value={recurringPeriod}
                          onChange={selectedOption =>
                            setRecurringPeriod(selectedOption)
                          }
                        />
                      </div>
                      <div className="col-md-4">
                        <Label htmlFor="formrow-firstname-Input">
                          Recurring End Date{" "}
                          <span className="text-danger">*</span>
                        </Label>
                        <Input
                          required
                          type="date"
                          className="form-control"
                          placeholder="Enter Amount"
                          value={recurringEndDate}
                          onChange={e => setRecurringEndDate(e.target.value)}
                          min={
                            addDate
                              ? new Date(addDate).toISOString().split("T")[0]
                              : ""
                          }
                        />
                      </div>
                    </>
                  </div>
                )}

                <div className="col-md-12 pb-4 ps-2 row flex-wrap border-bottom">
                  <div className="col-4">
                    <Label htmlFor="formrow-firstname-Input">
                      Amount <span className="text-danger">*</span>
                    </Label>

                    <div className="d-flex justify-content-start align-items-center gap-2">
                      <Input
                        required
                        type="number"
                        className="form-control"
                        // id="formrow-firstname-Input"
                        placeholder="Enter Amount"
                        style={{ width: "100%" }}
                        value={amountValue}
                        onChange={e => setAmountValue(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-4">
                    <Label htmlFor="formrow-firstname-Input">GST</Label>

                    <div className="d-flex justify-content-start align-items-center gap-2">
                      <Input
                        type="text"
                        className="form-control"
                        placeholder="Enter GST"
                        style={{ width: "100%" }}
                        value={gstValue}
                        onChange={e => setGstValue(e.target.value)}
                      />
                    </div>
                  </div>

                  {isConvertedAmount && (
                    <div className="col-md-4 ">
                      <Label htmlFor="formrow-firstname-Input">
                        Exchange Rate
                      </Label>

                      <div className="d-flex justify-content-start align-items-center gap-2">
                        <Input
                          type="text"
                          className="form-control"
                          // placeholder="Enter GST"
                          readOnly
                          style={{ width: "100%" }}
                          value={convertInrAmount}
                          onChange={e => setConvertInrAmount(e.target.value)}
                        />
                      </div>
                    </div>
                  )}
                  <div className="col-4 ">
                    <Label>Upload Bill</Label>
                    <input
                      type="file"
                      ref={expenseFileUpload}
                      className="form-control"
                    ></input>
                  </div>
                </div>
                {/* <div className=""></div> */}

                <div className="col-md-12 mb-2 pt-3">
                  <div className="d-flex align-items-center gap-3">
                    {/* Introducer Toggle */}
                    <div>
                      <Label htmlFor="introducerSwitch">Introducer</Label>
                      <div className="form-switch form-switch-md">
                        <input
                          type="checkbox"
                          className="form-check-input mt-2"
                          id="introducerSwitch"
                          defaultChecked={introducer == 1}
                          onChange={e => {
                            setIntroducer(e.target.checked ? 1 : 0)
                            console.log(introducer)
                          }}
                        />
                      </div>
                    </div>

                    {/* Show only when introducer == 1 */}
                    {introducer == 1 && (
                      <div className="d-flex align-items-center gap-3 flex-grow-1">
                        {/* Select Introducer */}
                        <div className="flex-grow-1">
                          <Label>Select Introducer</Label>
                          <Select
                            placeholder="Select Introducer"
                            className="basic-multi-select"
                            classNamePrefix="select"
                            styles={colourStyles}
                            options={introducerOptions}
                            onChange={selectedOption =>
                              setIntroducerValue(
                                selectedOption ? selectedOption.value : null
                              )
                            }
                          />
                        </div>

                        {/* Record Payment Toggle */}
                        <div>
                          <Label htmlFor="recordPaymentSwitch">
                            Charge Introducer
                          </Label>
                          <div className="form-switch form-switch-md">
                            <input
                              type="checkbox"
                              className="form-check-input mt-2"
                              id="recordPaymentSwitch"
                              defaultChecked={recordPayment == 1}
                              onChange={e => {
                                setRecordPayment(e.target.checked ? 1 : 0)
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div className="my-4 text-center">
                <button className=" btn btn-save btn-label">
                  <i className="fas fa-save me-2 label-icon"></i>
                  Save
                </button>
                <a
                  onClick={() => {
                    setIntroducer(0)
                    setRecurring(0)
                    setAddDate("")
                    setLocationValue(null)
                    setCurrencyValue(null)
                    setPaymentViaValue(null)
                    setCategoryValue(null)
                    setTitleValue("")
                    setRecurringPeriod(null)
                    setRecurringEndDate(null)
                    setGstValue("")
                    setAmountValue("")
                    setIntroducerValue(null)
                    setConvertInrAmount("")
                    setRecordPayment(0)
                    setAddExpense(false)

                  }}
                  className=" btn ms-md-2 btn-red btn-label"
                >
                  <i className="dripicons-cross me-2 icon-center label-icon" ></i>
                  CANCEL
                </a>
              </div>
            </div>

            {/* </div> */}
          </Form>
        </div>
      </Modal>
    </div>
  )
}

const Expense = () => {
  const [verticalActiveTab, setverticalActiveTab] = useState("1")
  const [modal_fullscreen, setmodal_fullscreen] = useState(false)
  const [isSelectDisabled, setIsSelectDisabled] = useState(true)
  const [isConvertedAmount, setIsConvertedAmount] = useState(false)
  const [convertInrAmount, setConvertInrAmount] = useState("")
  const [isConvertedAmountPay, setIsConvertedAmountPay] = useState(false)
  const [convertInrAmountPay, setConvertInrAmountPay] = useState("")
  const [isFilter, setIsfilter] = useState(false)
  const [introducer, setIntroducer] = useState(0)
  const [recordPayment, setRecordPayment] = useState(0)
  const [introducerOptions, setIntroducerOptions] = useState([])
  const [introducerValue, setIntroducerValue] = useState(null)
  // const colourStyles = {
  //   control: (styles, state) => ({
  //     ...styles,
  //     backgroundColor: state.isDisabled ? "gray" : "white",
  //   }),
  // }

  const expenseFileUpload = useRef(null)

  const toggleVertical = tab => {
    if (verticalActiveTab !== tab) {
      setverticalActiveTab(tab)
    }
  }

  const toggleLoading = loading => {
    setLoading(loading)
  }

  const fetchIntroducers = async () => {
    try {
      toggleLoading(true)
      const data = await fetchNodeData(
        toggleLoading,
        "introducerOptions/0",
        secureLocalStorage.getItem("auth_token")
      )
      if (data.status && data.introducers) {
        const options = data.introducers.map(introducer => ({
          value: introducer.id,
          label: introducer.company,
        }))

        setIntroducerOptions(options)
      }
    } catch (error) {
      console.error("Error fetching introducers:", error)
      Swal.fire({
        icon: "error",
        text: "Failed to fetch introducers.",
      })
    } finally {
      toggleLoading(false)
    }
  }

  useEffect(() => {
    fetchIntroducers()
  }, [])

  document.title = "Expense | Zithas Crm"

  const [data, setDatas] = useState([])
  const [viewBudgetData, setViewBudgetData] = useState(null)
  const [allData, setAllData] = useState(null)
  const [balanceAmount, setBalanceAmount] = useState(null)

  const [view_customer, setVeiwCustomer] = useState([])
  const [isLoading, setLoading] = useState(false)

  const [paymentMode, setPaymentMode] = useState(false)
  const [editPaymentMode, setEditPaymentMode] = useState(false)
  const [paymentModeOption, setPaymentModeOption] = useState([])
  const [payMentHistory, setPaymentHistory] = useState(false)
  const [payMentHistoryData, setPaymentHistoryData] = useState([])
  const [editExpense, setEditExpense] = useState(false)
  const [viewExpense, setViewExpense] = useState(false)

  const [modal_Access, setAccessDenied] = useState(false)
  const [location, setLocation] = useState([])
  const [Categories, setCategories] = useState([])
  const [payments, setPayments] = useState([])
  const [Currency, setCurrency] = useState([])











  // Edit expense states
  const [editId, setEditId] = useState("")
  const [updatedDate, setUpdatedDate] = useState(null)
  const [updatedLocation, setUpdatedLocation] = useState(null)
  const [updatedPayemntVia, setUpdatedPayemntVia] = useState(null)
  const [updatedCategory, setUpdatedCategory] = useState(null)
  const [updatedTitle, setUpdatedTitle] = useState(null)
  const [updatedAmount, setUpdatedAmount] = useState(null)
  const [updatedGst, setUpdatedGst] = useState(null)
  const [updatedCurrency, setUpdatedCurrency] = useState(null)
  const [updateRecurring, setupdateRecurring] = useState(0)
  const [link, setLink] = useState("");
  const [updateRecurringPeriod, setUpdateRecurringPeriod] = useState(null)
  const [updateRecurringEndDate, setUpdateRecurringEndDate] = useState("")
  const [recurringOptions, setRecurringOptions] = useState([
    { value: 1, label: "1 Month" },
    { value: 2, label: "2 Month" },
    { value: 12, label: "1 Year" },
  ])
  const [viewRecurring, setViewRecurring] = useState(0)
  const [viewRecurringPeriod, setViewRecurringPeriod] = useState(null)
  const [viewRecurringEndDate, setViewRecurringEndDate] = useState("")

  // Add payment states
  const [paymentId, setPaymentId] = useState("")
  const [editPaymentLink, setEditPaymentLink] = useState("")
  const [paymentDate, setPaymentDate] = useState("")
  const [payPaymentMode, setPayPaymentMode] = useState(null)
  const [payPaymentAmount, setPayPaymentAmount] = useState("")
  const [payPaymentCurrency, setPayPaymentCurrency] = useState(null)
  const [payPaymentFile, setPayPaymentFile] = useState("")
  const [leftAmount, setLeftAmount] = useState(0)

  const fetchData = async () => {
    setLoading(true)
    try {
      const response = await axios({
        method: "get",
        url: `${configure.apiUrl}/budgetExpense/2`,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      })
      if (response) {
        const expense = response.data.data?.expense?.filter(list => {
          const modifyAmount =
            Number(list.amount)?.toFixed(1) - Number(list.tbal)?.toFixed(1)
          return modifyAmount >= 1
        })
        setDatas(expense)
        setAllData(response?.data?.data)
        setLoading(false)
      }
    } catch (err) {
      console.log(err)
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchData()
  }, [])

  const paymentsOption = [
    {
      label: "Bank Account",
      value: "1",
    },
    {
      label: "Credit Card",
      value: "2",
    },
    {
      label: "Others",
      value: "3",
    },
  ]

  document.addEventListener("keydown", e => {
    if (e.key === "Escape")
      setPaymentMode(false),
        setEditPaymentMode(false),
        setPaymentHistory(false),
        setEditExpense(false),
        setViewExpense(false)
  })

  const navigate = useNavigate()

  // const handlePayEditPayment = async paymentData => {
  //   setLoading(true)
  //   const formData = new FormData()
  //   formData.append("user_id", localStorage.getItem("auth_id"))
  //   formData.append("module_id", 41)
  //   try {
  //     await axios({
  //       method: "post",
  //       url: `${configure.apiUrl}/earth_permission`,
  //       data: formData,
  //       headers: {
  //         Accept: "application/json",
  //         "Content-Type": "multipart/form-data",
  //       },
  //     }).then(res => {
  //       setLoading(false)
  //       if (res.data.data.india[3] == 1 || res.data.data.uk[3] == 1) {
  //         setPaymentId(paymentData.id)
  //         setLeftAmount(paymentData.amount - (paymentData.tbal || 0))
  //         const findOption = payments?.filter(item => {
  //           return item.payment_via == paymentData.payment_via
  //         })
  //         setPaymentModeOption(findOption)

  //         setPaymentDate(paymentData.date)
  //         setPayPaymentMode(
  //           payments.find(obj => obj.value == paymentData.payment_mode_id)
  //         )
  //         setPayPaymentAmount(paymentData.amount)
  //         setPayPaymentCurrency(
  //           Currency.find(obj => obj.value == paymentData.currency)
  //         )
  //         setEditPaymentMode(true)
  //       } else {
  //         setAccessDenied(true)
  //       }
  //     })
  //   } catch (error) {
  //     setLoading(false)
  //     console.log(error)
  //   }
  // }
  const [existingFile, setExistingFile] = useState(null)
  const handlePayEditPayment = async paymentData => {
    setLoading(true)
    const formData = new FormData()
    formData.append("user_id", localStorage.getItem("auth_id"))
    formData.append("module_id", 41)
    try {
      await axios({
        method: "post",
        url: `${configure.apiUrl}/earth_permission`,
        data: formData,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      }).then(res => {
        setLoading(false)

        console.log("Payment Data", paymentData)
        setEditPaymentLink(paymentData.link)
        if (res.data.data.india[3] == 1 || res.data.data.uk[3] == 1) {
          setPaymentId(paymentData.id)
          setLeftAmount(paymentData.amount - (paymentData.tbal || 0))

          // Existing
          const findOption = payments?.filter(item => {
            return item.payment_via == paymentData.payment_via
          })
          setPaymentModeOption(findOption)

          // Add this: Set Payment Via
          const paymentViaOption = paymentsOption?.find(
            obj => obj.value == paymentData.payment_via
          )
          setPayPaymentVia(paymentViaOption)

          // Rest of your code
          setPaymentDate(paymentData.date)
          setPayPaymentMode(
            payments.find(obj => obj.value == paymentData.payment_mode_id)
          )
          setPayPaymentAmount(paymentData.amount)
          setExistingFile(paymentData.link + "?download=1")
          setPayPaymentCurrency(
            Currency.find(obj => obj.value == paymentData.currency)
          )
          setEditPaymentMode(true)
        } else {
          setAccessDenied(true)
        }
      })
    } catch (error) {
      setLoading(false)
      console.log(error)
    }
  }

  const colourStyles = {
    menuList: styles => ({
      ...styles,
      background: "white",
    }),
    menu: base => ({
      ...base,
      zIndex: 1200,
    }),
  }
  // const

  const [paymentCurrency, setPaymentCurrency] = useState(null)
 

  const columns = useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
        isInfoIcon: false,
        isShortIcon: true,
        className: "text-center exp-1",
      },
      {
        Header: () => {
          return <div style={{ textAlign: "center" }}>Location</div>;
        },
        accessor: "location",
        grow: false,
        isShortIcon: true,
        className: "location-box exp-2",
        Cell: (cellProps) => {
          return (
            <div className="text-center d-flex justify-content-center align-items-center">
              {cellProps.row.original.location == 1 ? (
                <img
                  src={India}
                  className=" mx-1 location-img text-center"
                  alt="flag"
                  height="20"
                  width="30"
                />
              ) : (
                <img
                  src={Uk}
                  className=" mx-1 location-img"
                  alt="flag"
                  height="20"
                  width="30"
                />
              )}
            </div>
          );
        },
        isInfoIcon: true,
      },
      {
        Header: () => {
          return <div style={{ textAlign: "center" }}>Date</div>;
        },
        accessor: "date",
        isInfoIcon: true,
        isShortIcon: true,
        className: "exp-3 text-center",
        Cell: (row) => {
          return (
            <div style={{ textAlign: "center" }}>
              {moment(row.value).format("DD-MM-YYYY")}
            </div>
          );
        },
      },
      {
        Header: "Title",
        accessor: "title",
        isInfoIcon: true,
        isShortIcon: true,
        className: "exp-4",
      },
      {
        Header: "Category",
        accessor: "category_name",
        isInfoIcon: true,
        isShortIcon: true,
        className: "exp-5",
      },
      {
        Header: "Amount",
        accessor: "amount",
        isInfoIcon: true,
        isShortIcon: true,
        className: "text-center exp-6",
        Cell: (cellProps) => {
          const currencyIdToCode = {
            1: "GBP",
            2: "INR",
            3: "CAD",
            4: "USD",
            5: "AUD",
            6: "AED",
            7: "SGD",
          };
          const currencySymbols = {
            GBP: "£",
            INR: "₹",
            CAD: "CA$",
            USD: "$",
            AUD: "A$",
            AED: "د.إ",
            SGD: "S$",
          };
          const { currency, amount } = cellProps.row.original;
          const currencyCode = currencyIdToCode[currency];
          const symbol = currencySymbols[currencyCode] || "";
          return (
            <>
              {symbol} {Number(cellProps.row.original.amount).toFixed(2)}
            </>
          );
        },
      },
      {
        Header: "Bal Amount",
        accessor: "balance_amount",
        isInfoIcon: true,
        isShortIcon: true,
        className: `text-center exp-7`,
        Cell: (cellProps) => {
          const currencyIdToCode = {
            1: "GBP",
            2: "INR",
            3: "CAD",
            4: "USD",
            5: "AUD",
            6: "AED",
            7: "SGD",
          };
          const currencySymbols = {
            GBP: "£",
            INR: "₹",
            CAD: "CA$",
            USD: "$",
            AUD: "A$",
            AED: "د.إ",
            SGD: "S$",
          };
          const { currency } = cellProps.row.original;
          const currencyCode = currencyIdToCode[currency];
          const symbol = currencySymbols[currencyCode] || "";
          const modifyAmount =
            parseFloat(Number(cellProps.row.original.amount)?.toFixed(1)) -
            parseFloat(Number(cellProps.row.original.tbal)?.toFixed(1));
          return (
            <span>
              {modifyAmount <= 0 ? (
                <div className="font-size-12 badge-soft-success badge bg-secondary">
                  Fully Paid
                </div>
              ) : (
                <>
                  {symbol} {Number(modifyAmount)?.toFixed(2)}
                </>
              )}
            </span>
          );
        },
      },
      {
        Header: "GST",
        accessor: "gst",
        isInfoIcon: true,
        isShortIcon: true,
        className: "text-center exp-8",
      },
      // {
      //   Header: "Action",
      //   accessor: "action",
      //   classNames: "text-center exp-9",
      //   Cell: (cellProps) => {
      //     const isDelete = async () => {
      //       setLoading(true);
      //       const formData = new FormData();
      //       formData.append("user_id", localStorage.getItem("auth_id"));
      //       formData.append("module_id", 41);
      //       try {
      //         await axios({
      //           method: "post",
      //           url: `${configure.apiUrl}/earth_permission`,
      //           data: formData,
      //           headers: {
      //             Accept: "application/json",
      //             "Content-Type": "multipart/form-data",
      //           },
      //         }).then((res) => {
      //           setLoading(false);
      //           if (res.data.data.india[5] == 1 || res.data.data.uk[5] == 1) {
      //             Swal.fire({
      //               title: "Are you sure?",
      //               text: "You want to delete this expense !",
      //               icon: "warning",
      //               buttons: true,
      //               showCancelButton: true,
      //             }).then(async (willDelete) => {
      //               if (willDelete.isConfirmed) {
      //                 setLoading(true);
      //                 try {
      //                   const response = await axios({
      //                     method: "get",
      //                     url: `${configure.apiUrl}/deleteBudgetExpense/${cellProps.row.original.id}/2`,
      //                     headers: {
      //                       Accept: "application/json",
      //                       "Content-Type": "multipart/form-data",
      //                     },
      //                   }).then((response) => {
      //                     Swal.fire({
      //                       icon: "success",
      //                       text: "Expense deleted successfully",
      //                     }).then((data) => {
      //                       const expense = response.data.data?.expense?.filter(
      //                         (list) => {
      //                           const modifyAmount =
      //                             Number(list.amount)?.toFixed(1) -
      //                             Number(list.tbal)?.toFixed(1);
      //                           return modifyAmount >= 1;
      //                         }
      //                       );
      //                       setDatas(expense);
      //                       setAllData(response?.data?.data);
      //                     });
      //                     setLoading(false);
      //                   });
      //                 } catch (err) {
      //                   Swal.fire({
      //                     icon: "error",
      //                     text: "Something went wrong",
      //                   });
      //                   setLoading(false);
      //                 }
      //               }
      //             });
      //           } else {
      //             setAccessDenied(true);
      //           }
      //         });
      //       } catch (error) {
      //         console.log(error);
      //       }
      //     };
      //     const handleView = (viewData) => {
      //       const payment_method = paymentsOption?.find(
      //         (obj) => obj.value == viewData.payment_method
      //       );
      //       const category_name = Categories?.find(
      //         (obj) => obj.value == viewData.category_id
      //       );
      //       const currency = Currency?.find(
      //         (obj) => obj.value == cellProps.row.original.currency
      //       );
      //       const recurrenceOp = recurringOptions?.find(
      //         (obj) => obj.value == cellProps.row.original.recurrence_period
      //       );
      //       const modifyArr = {
      //         date: viewData.date,
      //         location: location?.find(
      //           (obj) => obj.value == cellProps.row.original.location
      //         ),
      //         amount: cellProps.row.original.amount,
      //         paymentMethod: payment_method,
      //         categoryName: category_name,
      //         currency: currency,
      //         title: cellProps.row.original.title,
      //         gst: cellProps.row.original.gst ? cellProps.row.original.gst : "",
      //         currency_rate: cellProps.row.original.currency_rate,
      //       };
      //       setViewBudgetData(modifyArr);
      //       setViewRecurring(cellProps.row.original.recurrence);
      //       setViewRecurringPeriod(recurrenceOp);
      //       setViewRecurringEndDate(cellProps.row.original.recurrence_date);
      //       setViewExpense(true);
      //     };
      //     const handleSubmitEdit = async (viewData) => {
      //       console.log(viewData);
      //       setLoading(true);
      //       const formData = new FormData();
      //       formData.append("user_id", localStorage.getItem("auth_id"));
      //       formData.append("module_id", 41);
      //       try {
      //         await axios({
      //           method: "post",
      //           url: `${configure.apiUrl}/earth_permission`,
      //           data: formData,
      //           headers: {
      //             Accept: "application/json",
      //             "Content-Type": "multipart/form-data",
      //           },
      //         }).then((res) => {
      //           setLoading(false);
      //           if (res.data.data.india[4] == 1 || res.data.data.uk[4] == 1) {
      //             const locationFind = location?.find(
      //               (obj) => obj.value == viewData.location
      //             );
      //             const paymentmethod = paymentsOption?.find(
      //               (obj) => obj.value == viewData.payment_method
      //             );
      //             const categoryname = Categories?.find(
      //               (obj) => obj.value == viewData.category_id
      //             );
      //             const currencyEdit = Currency?.find(
      //               (obj) => obj.value == cellProps.row.original.currency
      //             );
      //             const recurrenceOp = recurringOptions?.find(
      //               (obj) =>
      //                 obj.value == cellProps.row.original.recurrence_period
      //             );
      //             setEditId(cellProps.row.original.id);
      //             setUpdatedDate(viewData.date);
      //             setIntroducer(viewData?.introducer_id != 0 ? 1 : 0);
      //             console.log("introducer Added? : ", introducer);
      //             console.log(introducerOptions);
      //             setIntroducerValue(
      //               introducerOptions?.find(
      //                 (obj) => obj?.value == viewData?.introducer_id
      //               )
      //             );
      //             setRecordPayment(viewData?.recordPayment);
      //             setUpdatedLocation(locationFind);
      //             setUpdatedPayemntVia(paymentmethod);
      //             setUpdatedCategory(categoryname);
      //             setUpdatedTitle(cellProps.row.original.title);
      //             setUpdatedAmount(cellProps.row.original.amount);
      //             setUpdatedGst(
      //               cellProps.row.original.gst ? cellProps.row.original.gst : ""
      //             );
      //             setUpdatedCurrency(currencyEdit);
      //             setupdateRecurring(cellProps.row.original.recurrence);
      //             setUpdateRecurringPeriod(recurrenceOp);
      //             setUpdateRecurringEndDate(
      //               cellProps.row.original.recurrence_date
      //             );

      //             setEditExpense(true);
      //           } else {
      //             setAccessDenied(true);
      //           }
      //         });
      //       } catch (error) {
      //         setLoading(false);
      //         console.log(error);
      //       }
      //     };
      //     const handlePaymentHistory = async () => {
      //       setLoading(true);
      //       try {
      //         const response = await axios({
      //           method: "get",
      //           url: `${configure.apiUrl}/viewPaidexpense/${cellProps.row.original.id}`,
      //           headers: {
      //             Accept: "application/json",
      //             "Content-Type": "multipart/form-data",
      //           },
      //         });
      //         if (response) {
      //           setPaymentHistoryData(response.data.data);
      //           setPaymentHistory(true);
      //           setEditId(cellProps.row.original.id);
      //           setLoading(false);
      //         }
      //       } catch (err) {
      //         console.log(err);
      //         setLoading(false);
      //       }
      //     };
      //     const handlePayAddPayment = async (data) => {
      //       console.log("========== handlePayAddPayment triggered ==========");
      //       console.log("Incoming payment row data: ", data);
      //       console.log("payments array: ", payments);
      //       console.log("paymentsOption array: ", paymentsOption);

      //       setLoading(true);
      //       const formData = new FormData();
      //       formData.append("user_id", localStorage.getItem("auth_id"));
      //       formData.append("module_id", 41);
      //       try {
      //         await axios({
      //           method: "post",
      //           url: `${configure.apiUrl}/earth_permission`,
      //           data: formData,
      //           headers: {
      //             Accept: "application/json",
      //             "Content-Type": "multipart/form-data",
      //           },
      //         }).then((res) => {
      //           setLoading(false);
      //           if (res.data.data.india[3] == 1 || res.data.data.uk[3] == 1) {
      //             setPaymentId(cellProps.row.original.id);
      //             setLeftAmount(
      //               cellProps.row.original.amount - cellProps.row.original.tbal
      //             );

      //             // correct mapping

      //             const paymentViaOption = paymentsOption?.find((obj) => 
      //               obj.value == data?.payment_method
      //             );
      //             console.log("Resolved paymentViaOption: ", paymentViaOption);

      //             setPayPaymentVia(paymentViaOption);
      //             console.log("Set PayPaymentVia done");

      //             const selectedModeObj = payments.find(
      //               (obj) => obj.value == data?.payment_method
      //             );
      //             console.log(
      //               "Resolved selected PaymentMode: ",
      //               selectedModeObj
      //             );

      //             console.log(
      //               "filtering based on data.payment_via => ",
      //               data?.payment_via
      //             );
      //             const findOption = payments?.filter((item) => {
      //               console.log(
      //                 "compare -> item.payment_via:",
      //                 item.payment_via,
      //                 "==",
      //                 data?.payment_via
      //               );
      //               return item.payment_via == paymentViaOption?.value;
      //             });
      //             console.log("Result of findOption: ", findOption);

      //             setPayPaymentMode(selectedModeObj);
      //             console.log("Set PayPaymentMode done");

      //             setPaymentModeOption(findOption);
      //             console.log("Set PaymentModeOption done => ", findOption);

      //             setBalanceAmount(
      //               parseFloat(
      //                 Number(cellProps.row.original.amount)?.toFixed(1)
      //               ) -
      //                 parseFloat(
      //                   Number(cellProps.row.original.tbal)?.toFixed(1)
      //                 )
      //             );

      //             setPayPaymentAmount(
      //               parseFloat(
      //                 Number(cellProps.row.original.amount)?.toFixed(1)
      //               ) -
      //                 parseFloat(
      //                   Number(cellProps.row.original.tbal)?.toFixed(1)
      //                 )
      //             );

      //             setPaymentMode(true);
      //           } else {
      //             setAccessDenied(true);
      //           }
      //         });
      //       } catch (error) {
      //         setLoading(false);
      //         console.log("handlePayAddPayment Error: ", error);
      //       }
      //     };

      //     return (
      //       <div className="d-flex justify-content-center">
      //         <button
      //           onClick={() => {
      //             handleView(cellProps.row.original);
      //           }}
      //           className="btn btn-sm me-1 btn-outline-secondary"
      //         >
      //           <i className="fas fa-eye"></i>
      //         </button>
      //         <button
      //           onClick={() => {
      //             handleSubmitEdit(cellProps.row.original);
      //           }}
      //           className="btn btn-sm me-1 btn-outline-secondary"
      //         >
      //           <i className="fa fa-pencil-alt"></i>
      //         </button>
      //         <button
      //           onClick={() => {
      //             handlePaymentHistory();
      //           }}
      //           className="btn btn-sm me-1 btn-outline-secondary"
      //           title="Payment History"
      //         >
      //           <i className="bi bi-credit-card-2-front-fill"></i>
      //         </button>

      //         <UncontrolledDropdown
      //           className="dropdown"
      //           style={{ width: "29px" }}
      //         >
      //           <DropdownToggle
      //             className="btn btn-sm btn-outline-secondary w-100"
      //             color="white"
      //           >
      //             <i className="mdi mdi-dots-horizontal"></i>
      //           </DropdownToggle>
      //           <DropdownMenu className="dropdown-menu-end">
      //             {cellProps.row.original.amount -
      //               cellProps.row.original.tbal <=
      //             0 ? (
      //               ""
      //             ) : (
      //               <Link
      //                 onClick={() => {
      //                   console.log("AllData: ", cellProps.row.original);
      //                   setPaymentCurrency(
      //                     Currency.find(
      //                       (obj) =>
      //                         obj.value == cellProps.row.original.currency
      //                     )
      //                   );

      //                   handlePayAddPayment(cellProps.row.original);
      //                 }}
      //                 title="Payment Mode"
      //                 className="dropdown-item"
      //               >
      //                 <i className="bi bi-currency-dollar pr-10 fill-green"></i>{" "}
      //                 Paid
      //               </Link>
      //             )}

      //             <a
      //               onClick={() => isDelete()}
      //               className="dropdown-item"
      //               title="delete"
      //             >
      //               <i className="fas fa-trash-alt pr-10 text-danger"></i>{" "}
      //               Delete Expense
      //             </a>
      //           </DropdownMenu>
      //         </UncontrolledDropdown>
      //       </div>
      //     );
      //   },
      // },
      {
        Header: "Action",
        accessor: "action",
        classNames: "text-center exp-9",
        Cell: (cellProps) => {
          const isDelete = async () => {
            setLoading(true);
            const formData = new FormData();
            formData.append("user_id", localStorage.getItem("auth_id"));
            formData.append("module_id", 41);
            try {
              await axios({
                method: "post",
                url: `${configure.apiUrl}/earth_permission`,
                data: formData,
                headers: {
                  Accept: "application/json",
                  "Content-Type": "multipart/form-data",
                },
              }).then((res) => {
                setLoading(false);
                if (res.data.data.india[5] == 1 || res.data.data.uk[5] == 1) {
                  Swal.fire({
                    title: "Are you sure?",
                    text: "You want to delete this expense !",
                    icon: "warning",
                    buttons: true,
                    showCancelButton: true,
                  }).then(async (willDelete) => {
                    if (willDelete.isConfirmed) {
                      setLoading(true);
                      try {
                        const response = await axios({
                          method: "get",
                          url: `${configure.apiUrl}/deleteBudgetExpense/${cellProps.row.original.id}/2`,
                          headers: {
                            Accept: "application/json",
                            "Content-Type": "multipart/form-data",
                          },
                        }).then((response) => {
                          Swal.fire({
                            icon: "success",
                            text: "Expense deleted successfully",
                          }).then((data) => {
                            const expense = response.data.data?.expense?.filter(
                              (list) => {
                                const modifyAmount =
                                  Number(list.amount)?.toFixed(1) -
                                  Number(list.tbal)?.toFixed(1);
                                return modifyAmount >= 1;
                              }
                            );
                            setDatas(expense);
                            setAllData(response?.data?.data);
                          });
                          setLoading(false);
                        });
                      } catch (err) {
                        Swal.fire({
                          icon: "error",
                          text: "Something went wrong",
                        });
                        setLoading(false);
                      }
                    }
                  });
                } else {
                  setAccessDenied(true);
                }
              });
            } catch (error) {
              console.log(error);
            }
          };
          const handleView = viewData => {
            const payment_method = paymentsOption?.find(
              obj => obj.value == viewData.payment_method
            )
            const category_name = Categories?.find(
              obj => obj.value == viewData.category_id
            )
            const currency = Currency?.find(
              obj => obj.value == cellProps.row.original.currency
            )
            const recurrenceOp = recurringOptions?.find(
              obj => obj.value == cellProps.row.original.recurrence_period
            )

            console.log("propdata", cellProps.row.original)
            const modifyArr = {
              date: viewData.date,
              location: location?.find(
                obj => obj.value == cellProps.row.original.location
              ),
              amount: cellProps.row.original.amount,
              paymentMethod: payment_method,
              categoryName: category_name,
              currency: currency,
              title: cellProps.row.original.title,
              gst: cellProps.row.original.gst ? cellProps.row.original.gst : "",
              currency_rate: cellProps.row.original.currency_rate,
              link: cellProps?.row?.original?.link || null,
              introducer_id: cellProps?.row?.original?.introducer_id || null,
              recordPayment: cellProps?.row?.original?.recordPayment,
            }
            setViewBudgetData(modifyArr)
            setViewRecurring(cellProps.row.original.recurrence)
            setViewRecurringPeriod(recurrenceOp)
            setViewRecurringEndDate(cellProps.row.original.recurrence_date)
            console.log("viewBudgetData", viewBudgetData)
            setViewExpense(true)
          }
          const handleSubmitEdit = async (viewData) => {
            console.log(viewData);
            setLoading(true);
            const formData = new FormData();
            formData.append("user_id", localStorage.getItem("auth_id"));
            formData.append("module_id", 41);
            try {
              await axios({
                method: "post",
                url: `${configure.apiUrl}/earth_permission`,
                data: formData,
                headers: {
                  Accept: "application/json",
                  "Content-Type": "multipart/form-data",
                },
              }).then((res) => {
                setLoading(false);
                if (res.data.data.india[4] == 1 || res.data.data.uk[4] == 1) {
                  const locationFind = location?.find(
                    (obj) => obj.value == viewData.location
                  );
                  const paymentmethod = paymentsOption?.find(
                    (obj) => obj.value == viewData.payment_method
                  );
                  const categoryname = Categories?.find(
                    (obj) => obj.value == viewData.category_id
                  );
                  const currencyEdit = Currency?.find(
                    (obj) => obj.value == cellProps.row.original.currency
                  );
                  const recurrenceOp = recurringOptions?.find(
                    (obj) =>
                      obj.value == cellProps.row.original.recurrence_period
                  );
                  // console.log("viewData", viewData)
                  setEditId(cellProps.row.original.id);
                  setUpdatedDate(viewData.date);
                  setIntroducer(viewData?.introducer_id != 0 ? 1 : 0);
                  setIntroducerValue(
                    introducerOptions?.find(
                      (obj) => obj?.value == viewData?.introducer_id
                    )
                  );
                  setRecordPayment(viewData?.recordPayment);
                  setUpdatedLocation(locationFind);
                  setUpdatedPayemntVia(paymentmethod);
                  setUpdatedCategory(categoryname);
                  setUpdatedTitle(cellProps.row.original.title);
                  setUpdatedAmount(cellProps.row.original.amount);
                  setUpdatedGst(
                    cellProps.row.original.gst ? cellProps.row.original.gst : ""
                  );
                  setUpdatedCurrency(currencyEdit);
                  setupdateRecurring(cellProps.row.original.recurrence);
                  setUpdateRecurringPeriod(recurrenceOp);
                  setUpdateRecurringEndDate(
                    cellProps.row.original.recurrence_date
                  );

                  setEditExpense(true);
                } else {
                  setAccessDenied(true);
                }
              });
            } catch (error) {
              setLoading(false);
              console.log(error);
            }
          };
          const handlePaymentHistory = async () => {
            setLoading(true);
            try {
              const response = await axios({
                method: "get",
                url: `${configure.apiUrl}/viewPaidexpense/${cellProps.row.original.id}`,
                headers: {
                  Accept: "application/json",
                  "Content-Type": "multipart/form-data",
                },
              });
              if (response) {
                setPaymentHistoryData(response.data.data);
                setPaymentHistory(true);
                setEditId(cellProps.row.original.id);
                setLoading(false);
              }
            } catch (err) {
              console.log(err);
              setLoading(false);
            }
          };
          const handlePayAddPayment = async (data) => {
            console.log("========== handlePayAddPayment triggered ==========");
            console.log("Incoming payment row data: ", data);
            console.log("payments array: ", payments);
            console.log("paymentsOption array: ", paymentsOption);

            setLoading(true);
            const formData = new FormData();
            formData.append("user_id", localStorage.getItem("auth_id"));
            formData.append("module_id", 41);
            try {
              await axios({
                method: "post",
                url: `${configure.apiUrl}/earth_permission`,
                data: formData,
                headers: {
                  Accept: "application/json",
                  "Content-Type": "multipart/form-data",
                },
              }).then((res) => {
                setLoading(false);
                if (res.data.data.india[3] == 1 || res.data.data.uk[3] == 1) {
                  setPaymentId(cellProps.row.original.id);
                  setLeftAmount(
                    cellProps.row.original.amount - cellProps.row.original.tbal
                  );

                  // correct mapping

                  const paymentViaOption = paymentsOption?.find(
                    (obj) => obj.value == data?.payment_method
                  );
                  console.log("Resolved paymentViaOption: ", paymentViaOption);

                  setPayPaymentVia(paymentViaOption);
                  console.log("Set PayPaymentVia done");

                  const selectedModeObj = payments.find(
                    (obj) => obj.value == data?.payment_method
                  );
                  console.log(
                    "Resolved selected PaymentMode: ",
                    selectedModeObj
                  );

                  console.log(
                    "filtering based on data.payment_via => ",
                    data?.payment_via
                  );
                  const findOption = payments?.filter((item) => {
                    console.log(
                      "compare -> item.payment_via:",
                      item.payment_via,
                      "==",
                      data?.payment_via
                    );
                    return item.payment_via == paymentViaOption?.value;
                  });
                  console.log("Result of findOption: ", findOption);

                  setPayPaymentMode(selectedModeObj);
                  console.log("Set PayPaymentMode done");

                  setPaymentModeOption(findOption);
                  console.log("Set PaymentModeOption done => ", findOption);

                  setBalanceAmount(
                    parseFloat(
                      Number(cellProps.row.original.amount)?.toFixed(1)
                    ) -
                    parseFloat(
                      Number(cellProps.row.original.tbal)?.toFixed(1)
                    )
                  );

                  setPayPaymentAmount(
                    parseFloat(
                      Number(cellProps.row.original.amount)?.toFixed(1)
                    ) -
                    parseFloat(
                      Number(cellProps.row.original.tbal)?.toFixed(1)
                    )
                  );

                  setPaymentMode(true);
                } else {
                  setAccessDenied(true);
                }
              });
            } catch (error) {
              setLoading(false);
              console.log("handlePayAddPayment Error: ", error);
            }
          };

          return (
            <div className="d-flex justify-content-center">
              <button
                onClick={() => {
                  handleView(cellProps.row.original);
                }}
                className="btn btn-sm me-1 btn-outline-secondary"
              >
                <i className="fas fa-eye"></i>
              </button>
              <button
                onClick={() => {
                  handleSubmitEdit(cellProps.row.original);
                }}
                className="btn btn-sm me-1 btn-outline-secondary"
              >
                <i className="fa fa-pencil-alt"></i>
              </button>
              {/* <button
                onClick={() => {
                  handlePaymentHistory();
                }}
                className="btn btn-sm me-1 btn-outline-secondary"
                title="Payment History"
              >
                <i className="bi bi-credit-card-2-front-fill"></i>
              </button> */}
              {cellProps.row.original.amount -
                cellProps.row.original.tbal <=
                0 ? (
                ""
              ) : (
                <button
                  onClick={() => {
                    console.log("AllData: ", cellProps.row.original);
                    setPaymentCurrency(
                      Currency.find(
                        (obj) =>
                          obj.value == cellProps.row.original.currency
                      )
                    );

                    handlePayAddPayment(cellProps.row.original);
                  }}
                  title="Payment Mode"
                  className="btn btn-sm me-1 btn-outline-secondary"
                >
                  <i className="bi bi-currency-dollar pr-10 fill-green"></i>
                </button>
              )}

              <UncontrolledDropdown
                className="dropdown"
                style={{ width: "29px" }}
              >
                <DropdownToggle
                  className="btn btn-sm btn-outline-secondary w-100"
                  color="white"
                >
                  <i className="mdi mdi-dots-horizontal"></i>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-end">

                  <Link
                    onClick={() => {
                      handlePaymentHistory();
                    }}
                    title="Payment Mode"
                    className="dropdown-item"
                  >
                    <i className="bi bi-credit-card-2-front-fill pr-10 fill-green"></i>{" "}
                    Payment History
                  </Link>

                  <a
                    onClick={() => isDelete()}
                    className="dropdown-item"
                    title="delete"
                  >
                    <i className="fas fa-trash-alt pr-10 text-danger"></i>{" "}
                    Delete Expense
                  </a>
                </DropdownMenu>
              </UncontrolledDropdown>
            </div>
          );
        },
      },
    ],
    [payments, Categories, Currency, isFilter]
  );

  const fetchOptions = async () => {
    setLoading(true)
    try {
      const response = await axios({
        method: "get",
        url: `${configure.apiUrl}/expenseData`,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      })
      if (response) {
        const modifyLocation = response?.data?.data?.location?.map(items => {
          return {
            label: items.location,
            value: items.id,
          }
        })
        const modifyCategories = response?.data?.data?.expense_category?.map(
          items => {
            return {
              label: items.categoryname,
              value: items.id,
            }
          }
        )
        const modifyModes = response?.data?.data?.modes?.map(items => {
          const labelD =
            items.payment_via == 1
              ? "Bank Account"
              : items.payment_via == 2
                ? "Credit Card"
                : items.payment_via == 3
                  ? "Others"
                  : ""
          return {
            label: items.payment_mode,
            value: items.id,
            payment_via: items.payment_via,
          }
        })
        const modifyCurrency = response?.data?.data?.currency?.map(items => {
          return {
            label: items.currency,
            value: items.id,
          }
        })

        setCurrency(modifyCurrency)
        setPayments(modifyModes)
        console.log("modifyModes: ", modifyModes)
        console.log("Payment Options: ", payments)
        setLocation(modifyLocation)
        setCategories(modifyCategories)
      }
    } catch (err) {
      console.log(err)
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchOptions()
  }, [])

  const handleEditSubmit = async e => {
    e.preventDefault()
    setLoading(true)
    const formData = new FormData()
    formData.append("type", 2)
    formData.append("date", updatedDate)
    formData.append("location", updatedLocation?.value)
    formData.append("payment_via", updatedPayemntVia?.value)
    formData.append("category", updatedCategory?.value)
    formData.append("title", updatedTitle)
    formData.append("amount", updatedAmount)
    formData.append("gst", updatedGst)
    if (expenseFileUpload.current.files[0]) {
      formData.append("file", expenseFileUpload.current.files[0])
    }
    formData.append("currency", updatedCurrency?.value)
    formData.append("expense_id", editId)
    if (isConvertedAmount) {
      formData.append("currency_rate", convertInrAmount ? convertInrAmount : 1)
    } else {
      formData.append("currency_rate", 1)
    }
    if (updateRecurring == 1) {
      formData.append("recurrence", updateRecurring)
      formData.append("recurrence_period", updateRecurringPeriod?.value)
      formData.append("recurrence_date", updateRecurringEndDate)
    } else {
      formData.append("recurrence", 0)
      formData.append("recurrence_period", "")
      formData.append("recurrence_date", "")
    }
    formData.append("introducer_id", introducerValue?.value || null)
    formData.append("recordPayment", recordPayment || 0)
    try {
      const resp = await axios({
        method: "put",
        url: `${configure.nodeApi}/addBudgetExpense`,
        data: formData,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      })
      if (resp) {
        setLoading(false)
        Swal.fire({
          icon: "success",
          text: "Expense edited successfully",
        }).then(() => {
          fetchData()
          expenseFileUpload.current = null
          setEditExpense(false)
        })
      }
    } catch (error) {
      setLoading(false)
      console.log(error)
    }
  }

  const handleAddPayment = async e => {
    e.preventDefault()
    setLoading(true)

    const formData = new FormData()
    formData.append("expense_id", paymentId)
    formData.append("type", 2)
    formData.append("date", paymentDate)
    formData.append("payment_via", payPaymentMode?.value)
    formData.append("payment_mode", payPaymentVia?.value)
    formData.append("amount", payPaymentAmount)
    formData.append("currency", payPaymentCurrency?.value)
    formData.append("file", payPaymentFile)
    if (isConvertedAmountPay) {
      formData.append(
        "currency_rate",
        convertInrAmountPay ? convertInrAmountPay : 1
      )
    } else {
      formData.append("currency_rate", 1)
    }
    try {
      const resp = await axios({
        method: "post",
        url: `${configure.apiUrl}/paidExpense`,
        data: formData,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      })
      if (resp) {
        setLoading(false)
        Swal.fire({
          icon: "success",
          text: "Payment added successfully",
        }).then(() => {
          setPaymentId("")
          setPaymentDate("")
          setPayPaymentMode(null)
          setPayPaymentAmount("")
          setPayPaymentCurrency(null)
          setPayPaymentFile("")
          const expense = resp.data.data?.expense?.filter(list => {
            const modifyAmount =
              Number(list.amount)?.toFixed(1) - Number(list.tbal)?.toFixed(1)
            return modifyAmount >= 1
          })
          setDatas(expense)
          setAllData(resp.data.data)
          setPaymentMode(false)
        })
      }
    } catch (error) {
      setLoading(false)
      console.log(error)
    }
  }

  const handleEditPayment = async e => {
    e.preventDefault()
    setLoading(true)

    const formData = new FormData()
    formData.append("expense_id", editId)
    formData.append("user_id", localStorage.getItem("auth_id"))
    formData.append("date", paymentDate)
    formData.append("payment_via", payPaymentMode?.value)
    formData.append("payment_mode", payPaymentVia?.value)
    formData.append("amount", payPaymentAmount)
    formData.append("file", payPaymentFile)
    formData.append(
      "currency_rate",
      isConvertedAmountPay && convertInrAmountPay ? convertInrAmountPay : 1
    )

    try {
      const resp = await axios({
        method: "put",
        url: `${configure.nodeApi}/paidExpense/${paymentId}`,
        data: formData,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      })
      if (resp) {
        Swal.fire({
          icon: "success",
          text: "Payment updated successfully",
        })
        setPaymentHistoryData(resp.data?.data)
        setPaymentHistory(true)
        setLoading(false)
      } else {
        swal.fire({
          icon: "error",
          text: "Payment not updated",
        })
        setDatas([])
      }
    } catch (error) {
      console.error("Update failed:", error.response?.data || error.message)
    }

    setLoading(false)
    setEditPaymentMode(false)
    setPaymentId("")
    setPaymentDate("")
    setPayPaymentMode(null)
    setPayPaymentAmount("")
    setPayPaymentCurrency(null)
    setPayPaymentFile("")
    setIsConvertedAmountPay(false)
  }

  // Edit form currency conversion
  useEffect(() => {
    if (updatedDate && updatedCurrency && updatedAmount) {
      if (updatedCurrency.label !== "INR") {
        const fetchCurrencyRate = async () => {
          setLoading(true)
          try {
            const response = await axios.get(
              `https://api.apilayer.com/fixer/${updatedDate}?symbols=INR&base=${updatedCurrency.label}`,
              {
                headers: {
                  apikey: configure.exchangeKey,
                },
              }
            )
            if (response) {
              setLoading(false)
              const rate = response.data.rates.INR
              const formattedRate = rate.toFixed(2)
              setConvertInrAmount(formattedRate)
            } else {
              setLoading(false)
            }
          } catch (error) {
            setLoading(false)
            Swal.fire({
              icon: "warning",
              text:
                error.response?.data?.message || "Error fetching currency rate",
            })
            console.error("Error fetching currency rate:", error)
          }
        }
        fetchCurrencyRate()
        setIsConvertedAmount(true)
      } else {
        setIsConvertedAmount(false)
      }
    }
  }, [updatedDate, updatedCurrency, updatedAmount])

  // Add/Edit Payment currency conversion
  useEffect(() => {
    if (paymentDate && payPaymentCurrency && payPaymentAmount) {
      if (payPaymentCurrency.label !== "INR") {
        const fetchCurrencyRate = async () => {
          setLoading(true)
          try {
            const response = await axios.get(
              `https://api.apilayer.com/fixer/${paymentDate}?symbols=INR&base=${payPaymentCurrency.label}`,
              {
                headers: {
                  apikey: configure.exchangeKey,
                },
              }
            )
            if (response) {
              setLoading(false)
              const rate = response.data.rates.INR
              const formattedRate = rate.toFixed(2)
              setConvertInrAmountPay(formattedRate)
            } else {
              setLoading(false)
            }
          } catch (error) {
            setLoading(false)
            Swal.fire({
              icon: "warning",
              text:
                error.response?.data?.message || "Error fetching currency rate",
            })
            console.error("Error fetching currency rate:", error)
          }
        }
        fetchCurrencyRate()
        setIsConvertedAmountPay(true)
      } else {
        setIsConvertedAmountPay(false)
      }
    }
  }, [paymentDate, payPaymentCurrency, payPaymentAmount])

  const handlePayAmount = value => {
    const numericValue = value
    if (numericValue > leftAmount) {
      Swal.fire({
        icon: "warning",
        text: `You can only pay up to ${leftAmount}.`,
      })
    } else {
      setPayPaymentAmount(numericValue)
    }
  }

  const onReloadApi = load => {
    if (load) {
      fetchData()
    }
  }

  const [payPaymentVia, setPayPaymentVia] = useState(null)

  return (
    <React.Fragment>
      {isLoading && <Loader />}
      <div className="page-content" id="expense">
        <Container fluid>
          <Breadcrumbs title={"Dashboard"} breadcrumbItem={"Expense"} />

          <Row>
            <Col lg={12} className="p-0">
              <Card>
                <CardBody>
                  <div className="responsive-table">
                    <TableContainer
                      columns={columns}
                      data={data}
                      setAccessDenied={setAccessDenied}
                      setLoading={setLoading}
                      location={location}
                      Categories={Categories}
                      payments={payments}
                      Currency={Currency}
                      setDatas={setDatas}
                      allData={allData}
                      setAllData={setAllData}
                      fetchData={fetchData}
                      paymentsOption={paymentsOption}
                      setIsfilter={setIsfilter}
                      introducerOptions={introducerOptions}
                      onReloadApi={onReloadApi}
                    />
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Edit Expense Modal */}
      <Modal isOpen={editExpense} size="xl" className="" centered>
        <div className="modal-header pe-4">
          <h5 className="modal-title mt-0">Edit Expense</h5>
          <button
            type="button"
            onClick={() => {
              setEditExpense(false)
            }}
            className="btn-modal-close"
          >
            <span aria-hidden="true" className="btn-modal-span">
              ×
            </span>
          </button>
        </div>

        <div className="modal-body pe-4">
          <Form
            onSubmit={handleEditSubmit}
            className="row d-flex justify-content-center align-items-center"
          >
            <div className="col-md-5 d-flex justify-content-end align-items-center ps-3">
              <div className="text-center">
                <img src={editexpense} alt="Addepe" style={{ width: "90%" }} />
              </div>
            </div>

            <div className="col-md-6 d-flex flex-column ">
              <div className="col-md-12 d-flex mb-4 justify-content-start align-items-end">
                <div className="col-md-4  ps-2">
                  <Label htmlFor="formrow-firstname-Input">
                    Date <span className="text-danger">*</span>
                  </Label>
                  <div className="d-flex justify-content-start align-items-center gap-2">
                    <Input
                      required
                      type="date"
                      value={updatedDate}
                      onChange={e => setUpdatedDate(e.target.value)}
                      className="form-control"
                    />
                  </div>
                </div>
                <div className="col-md-4 ps-2">
                  <Label htmlFor="formrow-firstname-Input">
                    Location <span className="text-danger">*</span>
                  </Label>
                  <Select
                    placeholder="Select Location"
                    className="basic-multi-select"
                    classNamePrefix=" select"
                    styles={colourStyles}
                    options={location}
                    value={updatedLocation}
                    onChange={selectedOption =>
                      setUpdatedLocation(selectedOption)
                    }
                  />
                </div>
                <div className="col-md-4 ps-2">
                  <Label htmlFor="formrow-firstname-Input">
                    Currency <span className="text-danger">*</span>
                  </Label>
                  <Select
                    placeholder="Select Currency"
                    className="basic-multi-select"
                    classNamePrefix=" select"
                    options={Currency}
                    styles={colourStyles}
                    value={updatedCurrency}
                    onChange={selectedOption =>
                      setUpdatedCurrency(selectedOption)
                    }
                  />
                </div>
              </div>
              <div className="col-md-12 d-flex mb-4 justify-content-start align-items-end">
                <div className="col-md-6 ps-2">
                  <Label htmlFor="formrow-firstname-Input">
                    Payment Via <span className="text-danger">*</span>
                  </Label>
                  <Select
                    placeholder="Payment Via"
                    className="basic-multi-select"
                    classNamePrefix=" select"
                    styles={colourStyles}
                    options={paymentsOption}
                    value={updatedPayemntVia}
                    onChange={selectedOption =>
                      setUpdatedPayemntVia(selectedOption)
                    }
                  />
                </div>
                <div className="col-md-6 ps-2">
                  <Label htmlFor="formrow-firstname-Input">
                    Category <span className="text-danger">*</span>
                  </Label>
                  <Select
                    placeholder="Payment Category"
                    className="basic-multi-select"
                    classNamePrefix=" select"
                    styles={colourStyles}
                    options={Categories}
                    value={updatedCategory}
                    onChange={selectedOption =>
                      setUpdatedCategory(selectedOption)
                    }
                  />
                </div>
              </div>
              <div className="col-md-12 d-flex flex-column justify-content-start align-items-start">
                <div className="col-md-12 mb-4 ps-2 row">
                  <div className="col-md-10">
                    <Label htmlFor="formrow-firstname-Input">
                      Title <span className="text-danger">*</span>
                    </Label>

                    <div className="d-flex justify-content-start align-items-center gap-2">
                      <Input
                        required
                        type="text"
                        className="form-control"
                        placeholder="Enter Title"
                        value={updatedTitle}
                        onChange={e => setUpdatedTitle(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-md-2 mb-2">
                    <Label htmlFor="formrow-firstname-Input">Recurring</Label>
                    <div className="form-switch form-switch-md ">
                      <input
                        type="checkbox"
                        className="form-check-input mt-2"
                        id="customSwitchsizemd"
                        defaultChecked={updateRecurring == 1 ? true : false}
                        onChange={e =>
                          setupdateRecurring(e.target.checked ? 1 : 0)
                        }
                      />
                    </div>
                  </div>
                </div>

                {updateRecurring == 1 && (
                  <div className="col-md-12 d-flex ps-2 mb-4 justify-content-start align-items-end gap-2">
                    <>
                      {" "}
                      <div className="col-md-4">
                        <Label htmlFor="formrow-firstname-Input">
                          Recurring Period{" "}
                          <span className="text-danger">*</span>
                        </Label>
                        <Select
                          placeholder="Select recurring"
                          className="basic-multi-select"
                          classNamePrefix=" select"
                          styles={colourStyles}
                          options={recurringOptions}
                          value={updateRecurringPeriod}
                          onChange={selectedOption => {
                            Swal.fire({
                              icon: "warning",
                              title: "Are you sure ?",
                              text: "You want to change the recurring period.",
                              showCancelButton: true,
                            }).then(willOkay => {
                              if (willOkay.isConfirmed) {
                                setUpdateRecurringPeriod(selectedOption)
                              }
                            })
                          }}
                        />
                      </div>
                      <div className="col-md-4">
                        <Label htmlFor="formrow-firstname-Input">
                          Recurring End Date{" "}
                          <span className="text-danger">*</span>
                        </Label>
                        <Input
                          type="date"
                          className="form-control"
                          placeholder="Enter Amount"
                          value={updateRecurringEndDate}
                          onChange={e =>
                            setUpdateRecurringEndDate(e.target.value)
                          }
                        />
                      </div>
                    </>
                  </div>
                )}

                <div className="col-md-12 mb-4 ps-2 d-flex gap-2">
                  <div className="col-md-4">
                    <Label htmlFor="formrow-firstname-Input">
                      Amount <span className="text-danger">*</span>
                    </Label>

                    <div className="d-flex justify-content-start align-items-center gap-2">
                      <Input
                        required
                        type="number"
                        className="form-control"
                        placeholder="Enter Amount"
                        style={{ width: "100%" }}
                        value={updatedAmount}
                        onChange={e => setUpdatedAmount(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-md-4 ">
                    <Label htmlFor="formrow-firstname-Input">GST</Label>

                    <div className="d-flex justify-content-start align-items-center gap-2">
                      <Input
                        type="text"
                        className="form-control"
                        placeholder="Enter GST"
                        style={{ width: "100%" }}
                        value={updatedGst}
                        onChange={e => setUpdatedGst(e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="col-md-4 ">
                    <Label>Upload Bill</Label>
                    <input
                      type="file"
                      ref={expenseFileUpload}
                      className="form-control"
                    ></input>
                  </div>

                  {isConvertedAmount && (
                    <div className="col-md-4 ">
                      <Label htmlFor="formrow-firstname-Input">
                        Exchange Rate
                      </Label>
                      <div className="d-flex justify-content-start align-items-center gap-2">
                        <Input
                          type="text"
                          className="form-control"
                          readOnly
                          style={{ width: "100%" }}
                          value={convertInrAmount}
                          onChange={e => setConvertInrAmount(e.target.value)}
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="col-md-12 mb-2 pt-3">
                <div className="d-flex align-items-center gap-3">
                  {/* Introducer Toggle */}
                  <div>
                    <Label htmlFor="introducerSwitch">Introducer</Label>
                    <div className="form-switch form-switch-md">
                      <input
                        type="checkbox"
                        className="form-check-input mt-2"
                        id="introducerSwitch"
                        defaultChecked={introducer == 1}
                        onChange={e => {
                          setIntroducer(e.target.checked ? 1 : 0)
                          if (!e.target.checked) {
                            setIntroducerValue(null)
                            setRecordPayment(0)
                          }
                        }}
                      />
                    </div>
                  </div>

                  {/* Show only when introducer == 1 */}
                  {introducer == 1 && (
                    <div className="d-flex align-items-center gap-3 flex-grow-1">
                      {/* Select Introducer */}
                      <div className="flex-grow-1">
                        <Label>Select Introducer</Label>
                        <Select
                          placeholder="Select Introducer"
                          className="basic-multi-select"
                          classNamePrefix="select"
                          styles={colourStyles}
                          options={introducerOptions}
                          value={introducerValue}
                          onChange={selectedOption =>
                            setIntroducerValue(selectedOption)
                          }
                        />
                      </div>

                      {/* Record Payment Toggle */}
                      <div>
                        <Label htmlFor="recordPaymentSwitch">
                          Charge Introducer
                        </Label>
                        <div className="form-switch form-switch-md">
                          <input
                            type="checkbox"
                            className="form-check-input mt-2"
                            id="recordPaymentSwitch"
                            defaultChecked={recordPayment == 1}
                            onChange={e => {
                              setRecordPayment(e.target.checked ? 1 : 0)
                              console.log(recordPayment)
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {link && (
                <div className="col-md-10 mb-4 ps-2 d-flex gap-2">
                  <p>
                    <i className="mdi mdi-chevron-right text-primary me-1"></i>{" "}
                    <span className="text-purple fw-bold">Files</span> :{" "}
                    <a
                      className="text-light badge bg-primary me-2"
                      title="Click To Open"
                      style={{ cursor: "pointer", fontSize: "0.8rem" }}
                      target="_blank"
                      href={link}
                      rel="noreferrer"
                    >
                      Click Here
                    </a>
                  </p>
                </div>
              )}

              <div className="my-4 text-center">
                <button className=" btn btn-save btn-label">
                  <i className="fas fa-save me-2 label-icon"></i>
                  Save
                </button>
                <a
                  onClick={() => setEditExpense(false)}
                  className=" btn ms-md-2 btn-red btn-label"
                >
                  <i className="dripicons-cross me-2 icon-center label-icon"></i>
                  CANCEL
                </a>
              </div>
            </div>
          </Form>
        </div>
      </Modal>

      {/* View Expense Modal */}
      {/* <Modal isOpen={viewExpense} size="xl" className="" centered>
        <div className="modal-header pe-4">
          <h5 className="modal-title mt-0">View Expense</h5>
          <button
            type="button"
            onClick={() => {
              setViewExpense(false)
            }}
            className="btn-modal-close"
          >
            <span aria-hidden="true" className="btn-modal-span">
              ×
            </span>
          </button>
        </div>

        <div className="modal-body pe-4">
          <Form className="row d-flex justify-content-center align-items-center">
            <div className="col-md-5 d-flex justify-content-end align-items-center ps-3">
              <div className="text-center">
                <img src={viewexpense} alt="Addepe" style={{ width: "90%" }} />
              </div>
            </div>

            <div className="col-md-6 d-flex flex-column ">
              <div className="col-md-12 d-flex mb-4 justify-content-start align-items-end">
                <div className="col-md-4  ps-2">
                  <Label htmlFor="formrow-firstname-Input">
                    Date <span className="text-danger">*</span>
                  </Label>
                  <div className="d-flex justify-content-start align-items-center gap-2">
                    <Input
                      type="date"
                      value={viewBudgetData?.date}
                      className="form-control"
                      disabled
                    />
                  </div>
                </div>
                <div className="col-md-4 ps-2">
                  <Label htmlFor="formrow-firstname-Input">
                    Location <span className="text-danger">*</span>
                  </Label>
                  <Select
                    isDisabled="true"
                    placeholder="Select Location"
                    className="basic-multi-select"
                    classNamePrefix=" select"
                    styles={colourStyles}
                    value={viewBudgetData?.location}
                    options={location}
                  />
                </div>
                <div className="col-md-4 ps-2">
                  <Label htmlFor="formrow-firstname-Input">
                    Currency <span className="text-danger">*</span>
                  </Label>
                  <Select
                    isDisabled="true"
                    placeholder="Select Currency"
                    className="basic-multi-select"
                    classNamePrefix=" select"
                    styles={colourStyles}
                    options={Currency}
                    value={viewBudgetData?.currency}
                  />
                </div>
              </div>
              <div className="col-md-12 d-flex mb-4 justify-content-start align-items-end">
                <div className="col-md-6 ps-2">
                  <Label htmlFor="formrow-firstname-Input">
                    Payment Via <span className="text-danger">*</span>
                  </Label>
                  <Select
                    placeholder="Payment Via"
                    className="basic-multi-select"
                    classNamePrefix=" select"
                    isDisabled="true"
                    styles={colourStyles}
                    options={payments}
                    value={viewBudgetData?.paymentMethod}
                  />
                </div>
                <div className="col-md-6 ps-2">
                  <Label htmlFor="formrow-firstname-Input">
                    Category <span className="text-danger">*</span>
                  </Label>
                  <Select
                    isDisabled="true"
                    placeholder="Payment Category"
                    className="basic-multi-select"
                    classNamePrefix=" select"
                    styles={colourStyles}
                    options={Categories}
                    value={viewBudgetData?.categoryName}
                  />
                </div>
              </div>
              <div className="col-md-12 d-flex flex-column justify-content-start align-items-start">
                <div className="col-md-12 mb-4 ps-2 mb-4 row">
                  <div className="col-md-10">
                    <Label htmlFor="formrow-firstname-Input">
                      Title <span className="text-danger">*</span>
                    </Label>

                    <div className="d-flex justify-content-start align-items-center gap-2">
                      <Input
                        type="text"
                        className="form-control"
                        placeholder="Enter Title"
                        value={viewBudgetData?.title}
                        disabled={true}
                      />
                    </div>
                  </div>
                  <div className="col-md-2 mb-2">
                    <Label htmlFor="formrow-firstname-Input">Recurring</Label>
                    <div className="form-switch form-switch-md ">
                      <input
                        type="checkbox"
                        className="form-check-input mt-2"
                        id="customSwitchsizemd"
                        defaultChecked={viewRecurring == 1 ? true : false}
                        disabled={true}
                      />
                    </div>
                  </div>
                </div>
                {viewRecurring == 1 && (
                  <div className="col-md-12 d-flex ps-2 mb-4 justify-content-start align-items-end gap-2">
                    <>
                      {" "}
                      <div className="col-md-4">
                        <Label htmlFor="formrow-firstname-Input">
                          Recurring Period{" "}
                          <span className="text-danger">*</span>
                        </Label>
                        <Select
                          placeholder="Select recurring"
                          className="basic-multi-select"
                          classNamePrefix=" select"
                          styles={colourStyles}
                          options={recurringOptions}
                          value={viewRecurringPeriod}
                          isDisabled={true}
                        />
                      </div>
                      <div className="col-md-4">
                        <Label htmlFor="formrow-firstname-Input">
                          Recurring End Date{" "}
                          <span className="text-danger">*</span>
                        </Label>
                        <Input
                          type="date"
                          className="form-control"
                          placeholder="Enter Amount"
                          value={viewRecurringEndDate}
                          disabled={true}
                        />
                      </div>
                    </>
                  </div>
                )}
                <div className="col-md-10 mb-4 ps-2 d-flex gap-2">
                  <div className="col-md-4">
                    <Label htmlFor="formrow-firstname-Input">
                      Amount <span className="text-danger">*</span>
                    </Label>

                    <div className="d-flex justify-content-start align-items-center gap-2">
                      <Input
                        disabled
                        type="number"
                        className="form-control"
                        placeholder="Enter Amount"
                        style={{ width: "100%" }}
                        value={viewBudgetData?.amount}
                      />
                    </div>
                  </div>
                  <div className="col-md-4 ">
                    <Label htmlFor="formrow-firstname-Input">GST</Label>

                    <div className="d-flex justify-content-start align-items-center gap-2">
                      <Input
                        disabled
                        type="text"
                        className="form-control"
                        placeholder="Enter GST"
                        style={{ width: "100%" }}
                        value={viewBudgetData?.gst}
                      />
                    </div>
                  </div>
                  {viewBudgetData?.currency_rate && (
                    <div className="col-md-3">
                      <Label htmlFor="formrow-firstname-Input">
                        Exchange Rate
                      </Label>
                      <div className="d-flex justify-content-start align-items-center gap-2">
                        <Input
                          type="text"
                          className="form-control"
                          disabled
                          style={{ width: "100%" }}
                          value={viewBudgetData?.currency_rate}
                        />
                      </div>
                    </div>
                  )}
                </div>
                {viewBudgetData?.link ? (
                  <div className="col-md-10 mb-4 ps-2 d-flex gap-2">
                    <p>
                      <i className="mdi mdi-chevron-right text-primary me-1"></i>{" "}
                      <span className="text-purple fw-bold">Files</span> :{" "}
                      <a
                        className="text-light badge bg-primary me-2"
                        title="Click To Open"
                        style={{ cursor: "pointer", fontSize: "0.8rem" }}
                        target="_blank"
                        href={viewBudgetData?.link}
                        rel="noreferrer"
                      >
                        Click Here
                      </a>
                    </p>
                  </div>
                ) : null}
              </div>
            </div>
          </Form>
        </div>
      </Modal> */}

      {/* View Expense Modal */}
      <Modal isOpen={viewExpense} size="xl" className="" centered>
        <div className="modal-header pe-4">
          <h5 className="modal-title mt-0">View Expense</h5>
          <button
            type="button"
            onClick={() => {
              setViewExpense(false)
            }}
            className="btn-modal-close"
          >
            <span aria-hidden="true" className="btn-modal-span">
              ×
            </span>
          </button>
        </div>

        <div className="modal-body pe-4">
          <Form className="row d-flex justify-content-center align-items-center">
            <div className="col-md-5 d-flex justify-content-end align-items-center ps-3">
              <div className="text-center">
                <img src={viewexpense} alt="Addepe" style={{ width: "90%" }} />
              </div>
            </div>

            <div className="col-md-6 d-flex flex-column ">
              <div className="col-md-12 d-flex mb-4 justify-content-start align-items-end">
                <div className="col-md-4  ps-2">
                  <Label>
                    Date <span className="text-danger">*</span>
                  </Label>
                  <div className="d-flex gap-2">
                    <Input
                      type="date"
                      value={viewBudgetData?.date}
                      className="form-control"
                      disabled
                    />
                  </div>
                </div>

                <div className="col-md-4 ps-2">
                  <Label>
                    Location <span className="text-danger">*</span>
                  </Label>
                  <Select
                    isDisabled={true}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    styles={colourStyles}
                    value={viewBudgetData?.location}
                    options={location}
                  />
                </div>

                <div className="col-md-4 ps-2">
                  <Label>
                    Currency <span className="text-danger">*</span>
                  </Label>
                  <Select
                    isDisabled={true}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    styles={colourStyles}
                    options={Currency}
                    value={viewBudgetData?.currency}
                  />
                </div>
              </div>

              <div className="col-md-12 d-flex mb-4 justify-content-start align-items-end">
                <div className="col-md-6 ps-2">
                  <Label>
                    Payment Via <span className="text-danger">*</span>
                  </Label>
                  <Select
                    isDisabled={true}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    styles={colourStyles}
                    options={payments}
                    value={viewBudgetData?.paymentMethod}
                  />
                </div>

                <div className="col-md-6 ps-2">
                  <Label>
                    Category <span className="text-danger">*</span>
                  </Label>
                  <Select
                    isDisabled={true}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    styles={colourStyles}
                    options={Categories}
                    value={viewBudgetData?.categoryName}
                  />
                </div>
              </div>

              <div className="col-md-12 d-flex flex-column">
                <div className="col-md-12 mb-4 ps-2 row">
                  <div className="col-md-10">
                    <Label>
                      Title <span className="text-danger">*</span>
                    </Label>
                    <Input
                      type="text"
                      className="form-control"
                      value={viewBudgetData?.title}
                      disabled
                    />
                  </div>

                  <div className="col-md-2 mb-2">
                    <Label>Recurring</Label>
                    <div className="form-switch form-switch-md">
                      <input
                        type="checkbox"
                        className="form-check-input mt-2"
                        defaultChecked={viewRecurring == 1}
                        disabled
                      />
                    </div>
                  </div>
                </div>

                {viewRecurring == 1 && (
                  <div className="col-md-12 d-flex ps-2 mb-4 gap-2">
                    <div className="col-md-4">
                      <Label>Recurring Period</Label>
                      <Select
                        isDisabled={true}
                        styles={colourStyles}
                        options={recurringOptions}
                        value={viewRecurringPeriod}
                      />
                    </div>

                    <div className="col-md-4">
                      <Label>Recurring End Date</Label>
                      <Input
                        type="date"
                        value={viewRecurringEndDate}
                        disabled
                      />
                    </div>
                  </div>
                )}

                <div className="col-md-10 mb-4 ps-2 d-flex gap-2">
                  <div className="col-md-4">
                    <Label>Amount</Label>
                    <Input disabled type="number" value={viewBudgetData?.amount} />
                  </div>

                  <div className="col-md-4">
                    <Label>GST</Label>
                    <Input disabled value={viewBudgetData?.gst} />
                  </div>

                  {viewBudgetData?.currency_rate && (
                    <div className="col-md-3">
                      <Label>Exchange Rate</Label>
                      <Input disabled value={viewBudgetData?.currency_rate} />
                    </div>
                  )}
                </div>

                {/*  Introducer Section */}
                <div className="col-md-12 mb-2 pt-3">
                  <div className="d-flex align-items-center gap-3">
                    <div>
                      <Label>Introducer</Label>
                      <div className="form-switch form-switch-md">
                        <input
                          type="checkbox"
                          className="form-check-input mt-2"
                          checked={!!viewBudgetData?.introducer_id}
                          disabled
                        />
                      </div>
                    </div>
                    {viewBudgetData?.introducer_id && (
                      <div className="d-flex align-items-center gap-3 flex-grow-1">
                        <div className="flex-grow-1">
                          <Label>Select Introducer</Label>
                          <Input
                            type="text"
                            className="form-control"
                            value={
                              introducerOptions.find((opt) => opt.value == viewBudgetData?.introducer_id)?.label || ""
                            }
                            disabled
                          />
                        </div>

                        <div>
                          <Label>Charge Introducer</Label>
                          <div className="form-switch form-switch-md">
                            <input
                              type="checkbox"
                              className="form-check-input mt-2"
                              checked={!!viewBudgetData?.recordPayment}
                              disabled
                            />
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                {viewBudgetData?.link && (
                  <div className="col-md-10 mb-4 ps-2 d-flex gap-2">
                    <p>
                      <i className="mdi mdi-chevron-right text-primary me-1"></i>
                      <span className="text-purple fw-bold">Files</span> :
                      <a
                        className="text-light badge bg-primary ms-2"
                        target="_blank"
                        href={viewBudgetData?.link}
                        rel="noreferrer"
                      >
                        Click Here
                      </a>
                    </p>
                  </div>
                )}
              </div>
            </div>
          </Form>
        </div>
      </Modal>

      {/* Add/Edit Payment Mode Modal */}
      <Modal
        isOpen={paymentMode || editPaymentMode}
        size="xl"
        className=""
        centered
      >
        <div className="modal-header pe-4">
          <h5 className="modal-title mt-0">
            {editPaymentMode ? "Edit Payment" : "Add Payment"}
          </h5>
          <button
            type="button"
            onClick={() => {
              setPaymentMode(false)
              setEditPaymentMode(false)
              setPaymentId("")
              setPaymentDate("")
              setPayPaymentMode(null)
              setPayPaymentAmount("")
              setPayPaymentCurrency(null)
              setPayPaymentFile("")
              setIsConvertedAmountPay(false)
            }}
            className="btn-modal-close"
          >
            <span aria-hidden="true" className="btn-modal-span">
              ×
            </span>
          </button>
        </div>

        <div className="modal-body pe-4 my-4">
          <Form
            onSubmit={editPaymentMode ? handleEditPayment : handleAddPayment}
            className="row d-flex justify-content-center align-items-center"
          >
            <div className="col-md-5 d-flex justify-content-end align-items-center ps-3">
              <div className="text-center">
                <img src={addexpense} alt="Addepe" style={{ width: "90%" }} />
              </div>
            </div>

            <div className="col-md-5 d-flex flex-column ">
              <div className="col-md-12 d-flex mb-4 justify-content-start align-items-center gap-2">
                <div className="col-md-4">
                  <label htmlFor="">
                    Date <span className="text-danger">*</span>
                  </label>
                  <input
                    type="date"
                    required
                    value={paymentDate}
                    onChange={e => setPaymentDate(e.target.value)}
                    className="form-control"
                  />
                </div>
                <div className="col-md-5 ps-2">
                  <Label htmlFor="formrow-firstname-Input">
                    Payment Via <span className="text-danger">*</span>
                  </Label>
                  <Select
                    placeholder="Payment Via"
                    className="basic-multi-select"
                    classNamePrefix=" select"
                    styles={colourStyles}
                    options={paymentsOption}
                    value={payPaymentVia}
                    onChange={selectedOption => {
                      console.log("selected Option: ", selectedOption)
                      setPayPaymentVia(selectedOption)
                      console.log("payPaymentVia: ", payPaymentVia)
                      const findOption =
                        payments?.filter(item => {
                          return item.payment_via == selectedOption.value
                        }) || []
                      setPaymentModeOption(findOption)
                      setPayPaymentMode(null) // Reset mode when via changes
                    }}
                    required
                  />
                </div>
                <div className="col-md-5">
                  <Label htmlFor="formrow-firstname-Input">
                    Payment Mode <span className="text-danger">*</span>
                  </Label>
                  <Select
                    required
                    placeholder="Payment Mode"
                    className="basic-multi-select"
                    classNamePrefix=" select"
                    styles={colourStyles}
                    options={
                      paymentModeOption && paymentModeOption.length
                        ? paymentModeOption
                        : payments
                    }
                    value={payPaymentMode}
                    onChange={selectedOption =>
                      setPayPaymentMode(selectedOption)
                    }
                  />
                </div>
              </div>

              <div className="col-md-12 d-flex mb-4 justify-content-start align-items-end gap-2">
                <div className="col-md-4">
                  <Label htmlFor="formrow-firstname-Input">
                    Amount <span className="text-danger">*</span>
                  </Label>
                  <Input
                    required
                    type="number"
                    className="form-control"
                    placeholder="Enter Amount"
                    value={payPaymentAmount}
                    onChange={e => {
                      editPaymentMode
                        ? setPayPaymentAmount(e.target.value)
                        : handlePayAmount(e.target.value)
                    }}
                  />
                </div>
                {!editPaymentMode ? (
                  <>
                    <div className="col-md-4 ">
                      <Label htmlFor="formrow-firstname-Input">
                        Currency <span className="text-danger">*</span>
                      </Label>
                      <Select
                        placeholder="Select Currency"
                        className="basic-multi-select"
                        classNamePrefix=" select"
                        styles={colourStyles}
                        required
                        options={Currency}
                        value={paymentCurrency || payPaymentCurrency}
                        onChange={selectedOption =>
                          setPayPaymentCurrency(selectedOption)
                        }
                      />
                    </div>
                    {isConvertedAmountPay && (
                      <div className="col-md-4 ">
                        <Label htmlFor="formrow-firstname-Input">
                          Exchange Rate
                        </Label>
                        <div className="d-flex justify-content-start align-items-center gap-2">
                          <Input
                            type="text"
                            className="form-control"
                            readOnly
                            style={{ width: "100%" }}
                            value={convertInrAmountPay}
                            onChange={e =>
                              setConvertInrAmountPay(e.target.value)
                            }
                          />
                        </div>
                      </div>
                    )}
                  </>
                ) : null}
              </div>

              <div className="col-md-12 d-flex mb-4 justify-content-start align-items-end gap-2">
                <div className="col-md-9 ">
                  <label htmlFor="">Upload  Payment  Receipt</label>
                  <input
                    type="file"
                    className="form-control"
                    onChange={e => setPayPaymentFile(e.target.files[0])}
                  />
                </div>
                {editPaymentMode && existingFile ? (
                  <img
                    src={existingFile}
                    width={39}
                    height={39}
                    className="object-fit-cover"
                    alt="existing Image"
                    title="existing Image"
                  />
                ) : null}
              </div>

              {editPaymentLink ? (
                <div className="col-md-10 mb-4 ps-2 d-flex gap-2">
                  <p>
                    <i className="mdi mdi-chevron-right text-primary me-1"></i>{" "}
                    <span className="text-purple fw-bold">Files</span> :{" "}
                    <a
                      className="text-light badge bg-primary me-2"
                      title="Click To Open"
                      style={{ cursor: "pointer", fontSize: "0.8rem" }}
                      target="_blank"
                      href={editPaymentLink}
                      rel="noreferrer"
                    >
                      Click Here
                    </a>
                  </p>
                </div>
              ) : null}

              <div className="my-3 text-center pe-5 col-md-10">
                <button className=" btn btn-save btn-label">
                  <i className="fas fa-save me-2 label-icon"></i>
                  Save
                </button>
                <a
                  onClick={() => {
                    setPaymentMode(false)
                    setEditPaymentMode(false)
                    setPaymentId("")
                    setPaymentDate("")
                    setPayPaymentMode(null)
                    setPayPaymentAmount("")
                    setPayPaymentCurrency(null)
                    setPayPaymentFile("")
                    setIsConvertedAmountPay(false)
                  }}
                  className=" btn ms-md-2 btn-red btn-label"
                >
                  <i className="dripicons-cross me-2 icon-center label-icon"></i>
                  CANCEL
                </a>
              </div>
            </div>
          </Form>
        </div>
      </Modal>

      {/* Payment History Modal */}
      <Modal isOpen={payMentHistory} size="xl" className="" centered>
        <div className="modal-header pe-4">
          <h5 className="modal-title mt-0">Payment History</h5>
          <button
            type="button"
            onClick={() => {
              setPaymentHistory(false)
            }}
            className="btn-modal-close"
          >
            <span aria-hidden="true" className="btn-modal-span">
              ×
            </span>
          </button>
        </div>

        <div className="modal-body pe-4 my-5">
          <div className="row d-flex justify-content-center align-items-center">
            <div className="col-md-4 d-flex justify-content-end align-items-center ps-3">
              <div className="text-center">
                <img src={viewbill} alt="Addepe" style={{ width: "80%" }} />
              </div>
            </div>
            <div className="col-md-8">
              <Table bordered hover responsive size="" striped>
                <thead>
                  <tr>
                    <th className="text-center credit-bill-col-1">Sr. No</th>
                    <th className="credit-bill-col-2">Payment Mode</th>
                    <th className="credit-bill-col-3 text-center">Amount</th>
                    <th className="credit-bill-col-4 text-center">Date</th>
                    <th className="text-center credit-bill-col-5">Receipt</th>
                    <th className="text-center credit-bill-col-3">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {payMentHistoryData?.map((items, index) => {
                    const filterPayment = payments.find(obj => {
                      return items.payment_mode_id == obj.value
                    })
                    return (
                      <tr key={items.id}>
                        <td
                          scope="row"
                          className="text-center credit-bill-col-1"
                        >
                          {index + 1}
                        </td>
                        <td className="credit-bill-col-2">
                          {filterPayment?.label}
                        </td>
                        <td className="credit-bill-col-3 text-center">
                          {items.amount}
                        </td>
                        <td className="credit-bill-col-4 text-center">
                          {moment(items.date).format("DD-MM-YYYY")}
                        </td>
                        <td className="text-center credit-bill-col-5">
                          {items.link ? (
                            <a
                              href={items.link}
                              download={true}
                              target="_blank"
                              rel="noreferrer"
                              className="btn btn-download bg-purple"
                            >
                              <i className="fas fa-download label-icon"></i>
                            </a>
                          ) : (
                            "-"
                          )}
                        </td>
                        <td className="credit-bill-col-3 text-center">
                          <button
                            onClick={() => {
                              console.log("items: ", items)
                              handlePayEditPayment(items)
                            }}
                            className="btn btn-sm me-1 btn-outline-secondary"
                          >
                            <i className="fa fa-pencil-alt"></i>
                          </button>
                        </td>
                      </tr>
                    )
                  })}
                  {payMentHistoryData.length == 0 && (
                    <tr className="text-center">
                      <td colSpan={8}>No History Found</td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
          </div>
        </div>
      </Modal>

      <AccessDeniedPopup
        modal_Access={modal_Access}
        setAccessDenied={setAccessDenied}
      />
    </React.Fragment>
  )
}

export default Expense
